import { createElement } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function BackArrowIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.957 2.76l.943.943-3.625 3.623H15V8.66L3.274 8.659 6.9 12.284l-.943.943-4.762-4.762a.667.667 0 01-.07-.86l.07-.083L5.957 2.76z",
    clipRule: "evenodd"
  }));
}

function CloudDownloadIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M12.025 3.868C11.325 2.293 9.75 1.243 8 1.243s-3.325 1.05-4.025 2.625C2.313 3.868 1 5.268 1 6.931c0 1.662 1.4 3.062 3.063 3.062h.936v-1.4h-.936c-.886 0-1.663-.777-1.663-1.662 0-.917.707-1.663 1.575-1.663h.91l.37-.831C5.738 3.347 6.816 2.643 8 2.643s2.261.704 2.745 1.794l.37.831h.91c.869 0 1.575.746 1.575 1.663 0 .885-.776 1.662-1.662 1.662h-.954v1.4h.954C13.6 9.993 15 8.593 15 6.931c0-1.663-1.312-3.063-2.975-3.063z"
  }), /*#__PURE__*/createElement("path", {
    d: "M8.654 12.526v-4.42H7.346l.001 4.42-1.406-1.407-.925.925 2.521 2.521.068.059a.653.653 0 00.857-.059l2.522-2.521-.925-.925-1.405 1.407z"
  })));
}

function CollapsedIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.624 9.487a.637.637 0 01.821.068l4.546 4.545-.9.9-4.096-4.096L3.9 15l-.9-.9 4.545-4.545.08-.068zM12.091 1l.9.9-4.546 4.545-.078.068a.637.637 0 01-.822-.068L3 1.9l.9-.9 4.095 4.096L12.091 1z",
    clipRule: "evenodd"
  }));
}

function DownArrowIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.227 5.943L12.284 5l-4.29 4.291L3.702 5l-.943.943 4.762 4.762c.234.234.6.257.86.07l.083-.07 4.762-4.762z",
    clipRule: "evenodd"
  }));
}

function DownloadIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 13.6v1.394H1V13.6h14zM8.99 1v8.452l2.612-2.61.985.986-3.8 3.8a.697.697 0 01-.9.074l-.086-.074L4 7.828l.985-.986 2.611 2.61V1H8.99z",
    clipRule: "evenodd"
  }));
}

function DownwardIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.233 10.043l-.942-.943-3.624 3.625V1H7.333l.001 11.726L3.71 9.1l-.942.943 4.762 4.762c.234.234.6.257.86.07l.082-.07 4.762-4.762z",
    clipRule: "evenodd"
  }));
}

function ExpandIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.09 9.368l.9.9-4.545 4.546a.637.637 0 01-.82.067l-.08-.067L3 10.268l.9-.9 4.095 4.097 4.096-4.097zM8.368 1.12l.078.067 4.546 4.546-.9.9-4.096-4.097L3.9 6.632l-.9-.9 4.545-4.546a.637.637 0 01.822-.067z",
    clipRule: "evenodd"
  }));
}

function ExternalIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.264 3.314v1.273H2.273v9.14h9.14V9.736h1.273v4.628c0 .322-.24.588-.55.63L12.05 15H1.636a.636.636 0 01-.63-.55L1 14.364V3.95c0-.322.24-.588.55-.63l.086-.006h4.628zM14.364 1c.322 0 .588.24.63.55l.006.086v4.628h-1.273V3.172L8.45 8.45l-.9-.9 5.277-5.278H9.736V1h4.628z",
    clipRule: "evenodd"
  }));
}

function ForwardIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.043 2.76l-.943.943 3.625 3.623H1V8.66l11.726-.001L9.1 12.284l.943.943 4.762-4.762a.667.667 0 00.07-.86l-.07-.083-4.762-4.762z",
    clipRule: "evenodd"
  }));
}

function LeftArrowIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.957 2.5l.943.943-4.291 4.29 4.291 4.29-.943.944-4.762-4.762a.667.667 0 01-.07-.86l.07-.083L9.957 2.5z",
    clipRule: "evenodd"
  }));
}

function MergeProfilesIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.028 10.318c.331 0 .605.246.648.565l.006.089v3.566H4.375l-.001-1.989L1.924 15 1 14.075l2.451-2.451-1.989.001v-1.307h3.566zm9.51 0v1.307l-1.989-.001L15 14.075l-.925.925-2.451-2.452.001 1.99h-1.307v-3.566c0-.331.246-.605.565-.648l.089-.006h3.566zM8 5.563a2.437 2.437 0 110 4.874 2.437 2.437 0 010-4.874zm0 1.308a1.13 1.13 0 100 2.258 1.13 1.13 0 000-2.258zM1.925 1l2.449 2.45V1.462h1.308v3.566a.654.654 0 01-.565.648l-.089.006H1.462V4.375l1.988-.001L1 1.924 1.925 1zm12.15 0l.925.925-2.451 2.449h1.989v1.308h-3.566a.654.654 0 01-.648-.565l-.006-.089V1.462h1.307l-.001 1.989L14.075 1z",
    clipRule: "evenodd"
  }));
}

function RedoIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.783 1.7l3.03 3.03.068.078a.637.637 0 01-.067.822l-3.03 3.03-.9-.9 1.943-1.945H5.879l-.18.005a3.606 3.606 0 00.18 7.208h4.242v1.273H5.88l-.196-.004a4.879 4.879 0 01.196-9.754h6.947l-1.943-1.944.9-.9z",
    clipRule: "evenodd"
  }));
}

function RefreshIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c2.08 0 3.99.9 5.276 2.396l.273-2.01 1.318.178-.507 3.738a.665.665 0 01-.656.576l-.09-.006-3.801-.507.175-1.318 2.361.314A5.606 5.606 0 008 2.33C4.883 2.33 2.33 4.882 2.33 8S4.883 13.67 8 13.67c3.046 0 5.553-2.438 5.666-5.458L13.67 8H15c0 3.852-3.148 7-7 7s-7-3.148-7-7 3.148-7 7-7z",
    clipRule: "evenodd"
  }));
}

function ResetIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.968 1a7 7 0 110 14c-1.312 0-2.72-.435-3.86-1.15l-.24-.157-.215-.146a1.9 1.9 0 11.973-.948c.958.657 2.213 1.07 3.342 1.07a5.67 5.67 0 10-4.282-9.382l2.343-.311.176 1.318-3.8.507a.665.665 0 01-.73-.481l-.018-.089-.507-3.737 1.319-.18.273 2.032A6.982 6.982 0 017.968 1z",
    clipRule: "evenodd"
  }));
}

function RightArrowIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.943 2.5L5 3.443l4.291 4.29L5 12.023l.943.944 4.762-4.762a.667.667 0 00.07-.86l-.07-.083L5.943 2.5z",
    clipRule: "evenodd"
  }));
}

function ShareIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.455 3.728V5L2.273 5v8.425h10.242v-3h1.273v3.636c0 .322-.24.589-.55.63l-.086.007H1.636a.636.636 0 01-.63-.55L1 14.06V4.364c0-.322.24-.588.55-.63l.086-.006h1.819zm6.404-2.324l.075.057 4.849 4.243c.263.23.287.623.072.884l-.072.073-4.849 4.243a.637.637 0 01-1.049-.385l-.006-.094V8.648l-.14.007c-1.93.094-2.886.587-3.898 1.809l-.145.18-.129.166c-.369.485-1.143.224-1.143-.385 0-4.396 1.75-6.373 5.166-6.66l.235-.017.053-.003V1.94c0-.515.571-.804.981-.536zm.292 1.938v1.022a.636.636 0 01-.636.637c-2.69 0-4.17.888-4.646 3.346l-.042.235-.016.103.108-.087c1.001-.792 2.176-1.155 3.954-1.222l.341-.01.301-.002c.32 0 .584.236.63.543l.007.094-.001 1.02 3.246-2.84-3.246-2.84z",
    clipRule: "evenodd"
  }));
}

function SwitchIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M12.321 14.2l-.899-.9 1.5-1.5h-8.6v-1.3h8.6l-1.5-1.5.9-.9 2.5 2.5c.2.2.2.6.1.8l-.1.1-2.5 2.7z"
  }), /*#__PURE__*/createElement("path", {
    d: "M3.722 1.8l.9.9-1.4 1.5h8.6v1.3h-8.6l1.5 1.5-1 .8-2.5-2.6c-.2-.2-.3-.5-.1-.8l.1-.1 2.5-2.5z"
  })));
}

function ToFromIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.268 10.714l-.9.9-3.182-3.182a.637.637 0 01-.067-.821l.067-.08L4.368 4.35l.9.9-2.097 2.095h9.657L10.732 5.25l.9-.9 3.182 3.182a.637.637 0 01.067.82l-.067.08-3.182 3.182-.9-.9 2.095-2.096H3.172l2.096 2.096z",
    clipRule: "evenodd"
  }));
}

function TransferIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.912 1.094L13.71 12.892V9.759H15v4.69a.645.645 0 01-.557.64l-.088.005h-4.69v-1.29h3.134L1 2.008l.912-.913zm3.779 8.209l.912.912-4.69 4.69L1 13.994l4.69-4.69zM14.355.906c.327 0 .596.242.64.557L15 1.55v4.691h-1.29V3.107l-3.59 3.59-.912-.912 3.59-3.59H9.665V.905h4.69z",
    clipRule: "evenodd"
  }));
}

function TurnableIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 8c0 3.852-3.148 7-7 7-2.08 0-3.99-.901-5.277-2.397l-.272 2.011-1.318-.178.507-3.738a.665.665 0 01.656-.576l.09.006 3.801.507-.175 1.318-2.361-.314A5.606 5.606 0 008 13.67c3.046 0 5.553-2.437 5.666-5.457L13.67 8H15zM8 1c2.08 0 3.99.9 5.276 2.396l.273-2.01 1.318.178-.507 3.738a.665.665 0 01-.656.576l-.09-.006-3.801-.507.175-1.318 2.361.314A5.606 5.606 0 008 2.33c-3.046 0-5.553 2.437-5.666 5.457L2.33 8H1c0-3.852 3.148-7 7-7z",
    clipRule: "evenodd"
  }));
}

function UndoIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.217 1.7l-3.03 3.03-.068.078a.637.637 0 00.067.822l3.03 3.03.9-.9-1.943-1.945h6.948l.18.005a3.606 3.606 0 01-.18 7.208H5.88v1.273h4.242l.196-.004a4.879 4.879 0 00-.196-9.754H3.174l1.943-1.944-.9-.9z",
    clipRule: "evenodd"
  }));
}

function UnsortedIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    "data-name": "Layer 1",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#181c56",
    fillRule: "evenodd",
    d: "M8.69 11.77V4.32l2.1 2.1.9-.9-3.18-3.18-.08-.07a.626.626 0 00-.82.07L4.43 5.52l.9.9 2.1-2.1v7.45l-2.1-2.1-.9.9 3.18 3.18.08.07c.25.18.6.16.82-.07l3.18-3.18-.9-.9-2.1 2.1z"
  }));
}

function UpArrowIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.227 9.957l-.943.943-4.29-4.291L3.702 10.9l-.943-.943 4.762-4.762a.667.667 0 01.86-.07l.083.07 4.762 4.762z",
    clipRule: "evenodd"
  }));
}

function UploadIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 13.6v1.394H1V13.6h14zM7.887 1.13a.697.697 0 01.9.074l3.8 3.801-.985.985L8.99 3.38v8.453H7.597L7.596 3.38l-2.61 2.61L4 5.004l3.8-3.8.087-.074z",
    clipRule: "evenodd"
  }));
}

function UpwardIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.233 5.957l-.942.943-3.624-3.625V15H7.333l.001-11.726L3.71 6.9l-.942-.943 4.762-4.762a.667.667 0 01.86-.07l.082.07 4.762 4.762z",
    clipRule: "evenodd"
  }));
}

function VerticalSwitchIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.814 12.245l-2.546 2.546a.637.637 0 01-.82.067l-.08-.067-2.545-2.546.9-.9 1.46 1.46-.001-8.01h1.273v8.01l1.459-1.46.9.9zm6.363-8.536l-.9.9-1.459-1.46v8.646h-1.273l.001-8.647-1.46 1.461-.9-.9 2.546-2.545a.637.637 0 01.82-.067l.08.067 2.545 2.545z",
    clipRule: "evenodd"
  }));
}

function LogoNegativeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__LogoNegativeIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FF5959",
    d: "M0 14.799h15.783v-1.422H0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M0 2h6.45v1.567H1.674v2.312h4.236v1.566H1.675v2.237H6.45v1.566H0V2zm14.107 0h1.676v9.248h-.18L9.848 5.752v5.496H8.173V2h.179l5.755 5.597V2z"
  }));
}

function LogoPositiveIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__LogoPositiveIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FF5959",
    d: "M0 14.799h15.783v-1.422H0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M0 2h6.45v1.567H1.674v2.312h4.236v1.566H1.675v2.237H6.45v1.566H0V2zm14.107 0h1.676v9.248h-.18L9.848 5.752v5.496H8.173V2h.179l5.755 5.597V2z"
  }));
}

function AnimalIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.572 8.474c1.624-2.29 5.11-2.29 6.756.036l1.334 2.202c1.408 2.324-.989 5.046-3.557 4.092l-.116-.042a3.026 3.026 0 00-2.1 0l-.116.042c-2.57.954-4.966-1.768-3.558-4.092l1.357-2.238zm5.772.681C9.19 7.527 6.687 7.527 5.556 9.12l-1.334 2.202c-.817 1.348.595 2.952 2.14 2.379l.116-.043a4.204 4.204 0 012.92 0l.116.043c1.546.573 2.958-1.03 2.141-2.38l-1.31-2.166zM1.716 4.357a1.64 1.64 0 012.17.29l.249.29a1.645 1.645 0 01-.201 2.328l-.122.092a1.64 1.64 0 01-2.17-.29l-.249-.29a1.64 1.64 0 01.182-2.312l.141-.108zm10.274.29a1.64 1.64 0 012.17-.29l.021.014.121.094a1.64 1.64 0 01.182 2.312l-.248.29a1.645 1.645 0 01-2.19.276l-.122-.094a1.64 1.64 0 01-.182-2.312l.248-.29zm-8.806.6a.71.71 0 00-.926-.14l-.088.066-.07.07a.715.715 0 00-.066.848l.063.085.247.29a.71.71 0 00.926.142l.082-.062a.715.715 0 00.08-1.008l-.248-.29zm10.362-.18a.716.716 0 00-.852.18l-.248.29a.711.711 0 00.06.993l.081.063c.3.205.708.152.946-.126l.248-.29a.711.711 0 00-.06-.993l-.09-.069-.085-.048zM5.391 1.03a1.64 1.64 0 011.877 1.144l.335 1.129a1.644 1.644 0 01-1.127 2.045l-.14.034a1.64 1.64 0 01-1.877-1.145l-.335-1.128a1.64 1.64 0 011.104-2.04l.163-.04zM8.61 2.173a1.64 1.64 0 011.876-1.144l.163.04a1.64 1.64 0 011.105 2.039l-.336 1.128a1.645 1.645 0 01-1.9 1.14l-.14-.035a1.64 1.64 0 01-1.104-2.04l.336-1.128zm-2.923-.25l-.1.01-.095.022a.715.715 0 00-.482.89l.336 1.128c.105.352.46.567.794.504l.095-.023a.715.715 0 00.481-.889l-.335-1.128a.711.711 0 00-.795-.504l.101-.01zm4.53.003a.716.716 0 00-.72.51l-.336 1.13a.711.711 0 00.459.882l.094.024a.715.715 0 00.817-.5l.336-1.128a.711.711 0 00-.46-.883l-.101-.025-.09-.01z",
    clipRule: "evenodd"
  }));
}

function BabyIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 10 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.32 7.059l-2.759-2.63a.614.614 0 00-.433-.178h-2.76a.612.612 0 00-.433.178L.176 7.059a.605.605 0 00.012.865.625.625 0 00.868-.003l1.775-1.687v1.872h3.834V6.234L8.44 7.92c.242.24.634.242.877.003a.607.607 0 00.008-.86l-.005-.005zm-6.334 5.128a.152.152 0 010-.219l1.011-1.001-1.486-1.388-1.189 1.134c-.404.4-.404 1.05 0 1.449l.013.01 1.68 1.658a.581.581 0 00.817.004.564.564 0 00.005-.807l-.004-.004-.001-.001-.846-.835zm4-2.608l-1.488 1.388 1.012 1a.152.152 0 010 .218l-.846.837a.566.566 0 00-.002.807.582.582 0 00.819.001h.001l1.68-1.659.012-.009c.405-.4.405-1.05 0-1.45L6.986 9.58zM5.399 3.678a1.889 1.889 0 001.153-2.426A1.924 1.924 0 004.098.112a1.89 1.89 0 00-1.156 2.425A1.926 1.926 0 005.4 3.677z",
    clipRule: "evenodd"
  }));
}

function BicycleHotelIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.951 5.12a.42.42 0 01.372.232l.03.073 1.3 4.485c.126-.02.255-.03.386-.03 1.36 0 2.461 1.117 2.461 2.494 0 1.378-1.101 2.496-2.46 2.496-1.36 0-2.46-1.118-2.46-2.496 0-1.012.595-1.885 1.45-2.275l-.411-1.414-1.825 2.871c.086.142.135.31.135.488 0 .52-.415.942-.929.942s-.929-.421-.929-.942c0-.193.057-.372.155-.521L5.947 9.238l-.564 1.1a2.502 2.502 0 011.038 2.036c0 1.378-1.102 2.496-2.46 2.496-1.36 0-2.461-1.118-2.461-2.496 0-1.377 1.101-2.494 2.46-2.494.3 0 .586.054.851.153l.755-1.476-.485-.867h-.447a.351.351 0 01-.348-.353c0-.17.12-.313.278-.346l.07-.007h1.485a.35.35 0 01.348.353c0 .17-.12.313-.278.346l-.07.007h-.292l.332.593 4.206-.475-.58-1.995-.01-.034H7.964V5.12h1.987zm2.088 5.466a1.75 1.75 0 00-.187.01l.45 1.552a.334.334 0 01-.22.41.319.319 0 01-.377-.162l-.025-.062-.45-1.548a1.794 1.794 0 00-.954 1.588c0 .987.79 1.79 1.763 1.79.973 0 1.765-.803 1.765-1.79 0-.985-.792-1.788-1.765-1.788zm-8.078 0c-.973 0-1.765.803-1.765 1.788 0 .987.792 1.79 1.765 1.79.972 0 1.763-.803 1.763-1.79 0-.565-.26-1.07-.665-1.398l-.748 1.463a.321.321 0 01-.436.141.334.334 0 01-.166-.373l.026-.07.752-1.47a1.733 1.733 0 00-.526-.081zM8 11.715a.328.328 0 00-.325.33c0 .18.146.33.325.33.18 0 .325-.15.325-.33 0-.182-.146-.33-.325-.33zm1.951-3.196l-3.443.388 1.248 2.228a.919.919 0 01.525.011L9.95 8.52zm-1.79-7.377l.107.038 6.667 3.03-.552 1.214-6.39-2.905-6.391 2.905L1.05 4.21l6.667-3.03a.667.667 0 01.444-.038z",
    clipRule: "evenodd"
  }));
}

function BicycleParkingIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.386 2.707h-.639v-1.01h.634c.383 0 .568.184.569.497 0 .27-.15.516-.564.513M9.801 6c.146 0 .279.086.344.214l.026.068 1.201 4.14c.116-.019.235-.028.356-.028 1.255 0 2.272 1.031 2.272 2.302C14 13.968 12.983 15 11.728 15c-1.254 0-2.27-1.032-2.27-2.304 0-.934.55-1.74 1.339-2.1l-.38-1.305-1.684 2.65a.875.875 0 01.124.45c0 .481-.383.87-.857.87a.862.862 0 01-.857-.87c0-.177.052-.343.143-.48L6.105 9.8l-.52 1.017a2.31 2.31 0 01.957 1.878c0 1.272-1.016 2.304-2.27 2.304C3.017 15 2 13.968 2 12.696c0-1.27 1.017-2.302 2.272-2.302.276 0 .54.05.785.141l.696-1.363-.448-.8h-.412a.324.324 0 01-.322-.325c0-.158.11-.29.257-.32l.065-.006h1.37c.178 0 .322.146.322.326 0 .157-.11.289-.257.32l-.064.006h-.27l.306.546 3.883-.438-.535-1.841-.01-.032H7.967V6H9.8zm1.927 5.045c-.058 0-.115.004-.172.01l.416 1.432a.308.308 0 01-.204.378.294.294 0 01-.344-.141l-.027-.065-.416-1.43c-.522.276-.88.83-.88 1.467 0 .91.73 1.652 1.627 1.652.899 0 1.63-.741 1.63-1.652 0-.91-.731-1.65-1.63-1.65zm-7.456 0c-.899 0-1.63.742-1.63 1.65 0 .912.731 1.653 1.63 1.653.897 0 1.627-.741 1.627-1.652 0-.522-.24-.988-.614-1.29l-.69 1.35a.296.296 0 01-.402.13.308.308 0 01-.154-.344l.024-.065.694-1.356a1.6 1.6 0 00-.485-.076zM8 12.087c-.165 0-.3.138-.3.305 0 .167.135.305.3.305.165 0 .3-.138.3-.305a.303.303 0 00-.3-.305zm1.801-2.95l-3.178.359 1.151 2.057a.848.848 0 01.485.01L9.8 9.138zM8.366 1c.788 0 1.3.395 1.3 1.174 0 .8-.47 1.26-1.305 1.26h-.614V5H7V1h1.366z",
    clipRule: "evenodd"
  }));
}

function BusShelterIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.993 4.636a3.311 3.311 0 012.337 5.657 5.074 5.074 0 013.173 4.498l.005.209h-1.334a3.741 3.741 0 00-3.548-3.736l-.193-.005h-.881a3.741 3.741 0 00-3.736 3.548L3.81 15H2.477a5.076 5.076 0 013.178-4.708 3.311 3.311 0 012.337-5.656zm0 1.334a1.978 1.978 0 100 3.955 1.978 1.978 0 000-3.955zm.168-4.948l.107.038 6.667 3.03-.552 1.214-6.39-2.905-6.391 2.905L1.05 4.09l6.667-3.03a.667.667 0 01.444-.038z",
    clipRule: "evenodd"
  }));
}

function CoffeeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.531 13.645V15H1.28v-1.355h11.251zm1.522-8.796c.343 0 .626.254.671.585l.006.092v2.2c0 .932-.718 1.696-1.631 1.77l-.146.006h-.925a5.635 5.635 0 01-4.9 3.294l-.222.005A5.625 5.625 0 011.28 7.175v-1.65c0-.373.303-.676.677-.676h12.096zm-2.877 1.354H2.635v.972a4.269 4.269 0 004.05 4.266l.206.005.196-.004a4.27 4.27 0 004.09-4.267v-.972zm2.199 0h-.844v.972c0 .332-.029.657-.084.973h.506c.208 0 .38-.15.416-.347l.006-.076V6.203zM4.834 1.55v2.454H3.479V1.55h1.355zm5.498 0v2.454H8.977V1.55h1.355zM7.582 1v2.454H6.229V1h1.355z",
    clipRule: "evenodd"
  }));
}

function CouchetteIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.897 7.756a.632.632 0 00-.626-.547h-.09V4.248a.685.685 0 00-.684-.685h-3.374a.798.798 0 00-.382.107 1.09 1.09 0 00-.46-.107H6.622c-.166 0-.32.042-.462.107a.799.799 0 00-.383-.107H2.406a.686.686 0 00-.685.685v2.961h-.089a.632.632 0 00-.626.547L1 7.84v4.596h1.264v-1.666H13.639v1.666h1.265V7.841l-.006-.085zM13.096 4.65v2.56H10.39V4.65h2.706zm-3.792.023V7.21H6.603l.02-2.56 2.68.024zM2.808 4.65h2.704v2.559H2.807V4.65zm10.83 4.857H2.265l-.001-1.034h11.375l-.001 1.034z",
    clipRule: "evenodd"
  }));
}

function CutleryIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.213 1v3.03h1.091V1h1.334l-.001 3.03h1.091V1h1.334v5.515c0 .99-.766 1.802-1.739 1.874l-.14.005-.546-.001V15H4.305V8.393h-.545c-.99 0-1.802-.765-1.874-1.738l-.005-.14V1h1.333zm10.91 14h-1.334v-4.182h-2.97a.667.667 0 01-.659-.568l-.007-.098V5.303A4.303 4.303 0 0113.456 1c.334 0 .612.247.66.568l.006.099V15zM12.788 2.408l-.149.039a2.971 2.971 0 00-2.148 2.672l-.006.184v4.182h2.303V2.408zM6.728 5.363H3.213v1.152c0 .272.198.496.457.538l.089.008h2.424a.545.545 0 00.538-.457l.007-.089V5.363z",
    clipRule: "evenodd"
  }));
}

function FullIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.603 6.282a2.44 2.44 0 10-4.883 0c0 .758.344 1.435.886 1.882A3.82 3.82 0 001 11.784v.38h8.323v-.38l-.002-.127a3.816 3.816 0 00-2.603-3.492 2.438 2.438 0 00.885-1.883zm4.56 5.375A3.817 3.817 0 009.56 8.165 2.442 2.442 0 008.003 3.84c-.3 0-.584.061-.85.161a3.02 3.02 0 01.551 3.952 4.445 4.445 0 012.218 3.694l.002.138v.38h2.241v-.38l-.002-.128zm2.838 0a3.816 3.816 0 00-2.604-3.492 2.442 2.442 0 00-1.556-4.325c-.3 0-.584.061-.85.161a3.019 3.019 0 01.551 3.952 4.443 4.443 0 012.218 3.694l.002.138v.38h2.241v-.38l-.002-.128z",
    clipRule: "evenodd"
  }));
}

function LockerIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 10 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.517 5.45c.245 0 .447.187.479.429L7 5.946v1.582h2.481c.255 0 .467.165.51.382l.009.083V13.3c0 .257-.232.465-.519.465H.52c-.287 0-.519-.208-.519-.465V7.993c0-.256.232-.464.519-.464L3 7.528V5.946c0-.25.182-.458.417-.491l.066-.005h3.034zM2 8.568H1v4.158l1-.001V8.568zm5 0H3v4.157h4V8.568zm2 0H8v4.157h1V8.569zM6.034 6.442H3.966l-.001 1.086h2.069V6.442zM2.932 0a1.92 1.92 0 011.671 1h4.125L9.5 2l-.772 1h-.645l-.644-.666L6.796 3l-.645-.666L5.507 3h-.904a1.92 1.92 0 01-1.671 1C1.865 4 1 3.104 1 2c0-1.105.865-2 1.932-2zM2.5 1.379c-.332 0-.6.277-.6.62s.268.621.6.621.6-.277.6-.62-.269-.621-.6-.621z",
    clipRule: "evenodd"
  }));
}

function ManySeatsAvailableIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#BABBCF",
    fillRule: "evenodd",
    d: "M9.594 8.165a3.816 3.816 0 012.604 3.492l.003.128v.379h-.757v-.38c0-1.475-1.052-2.687-2.44-2.974a3.192 3.192 0 00-.228-.03c-.363-.493-.99-.778-.99-.778.1 0 .217-.004.255-.008.867-.084 1.683-.836 1.683-1.712 0-.931-.755-1.686-1.685-1.686a.973.973 0 00-.294.042l-.027-.04a2.85 2.85 0 00-.53-.597c.246-.11.608-.161.851-.161a2.441 2.441 0 011.555 4.325zm2.8 0A3.817 3.817 0 0115 11.657l.002.128v.379h-.757v-.38a3.042 3.042 0 00-2.441-2.974 3.11 3.11 0 00-.227-.03c-.362-.493-.99-.778-.99-.778.099 0 .217-.004.255-.008.868-.084 1.683-.836 1.683-1.712 0-.931-.754-1.686-1.685-1.686a.971.971 0 00-.293.042l-.03-.043A2.878 2.878 0 009.988 4c.246-.11.609-.161.85-.161a2.442 2.442 0 011.557 4.325z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.162 4.597a1.686 1.686 0 10-.001 3.371 1.686 1.686 0 000-3.37m0-.758a2.442 2.442 0 011.557 4.325 3.82 3.82 0 012.604 3.493l.002.127v.379h-.757v-.38a3.06 3.06 0 00-2.943-3.057l-.118-.003h-.688a3.063 3.063 0 00-3.06 2.944l-.001.117v.379H1v-.38a3.82 3.82 0 012.607-3.62A2.442 2.442 0 015.162 3.84",
    clipRule: "evenodd"
  }));
}

function ParkIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.596 7.414h-1.37v-2.02h1.358c.82 0 1.219.37 1.22.995 0 .538-.323 1.03-1.208 1.025M7.999 1c3.862 0 7 3.141 7 7s-3.138 7-7 7c-3.86 0-7-3.141-7-7s3.14-7 7-7zm0 1C4.692 2 2 4.691 2 8s2.692 6 6 6c3.31 0 6-2.691 6-6s-2.69-6-6-6zm.553 2c1.69 0 2.788.79 2.788 2.348 0 1.6-1.007 2.52-2.8 2.52H7.227V12H5.625V4h2.927z",
    clipRule: "evenodd"
  }));
}

function ParkAndRideIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zm0 1C4.691 2 2 4.691 2 8s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm3.004 5.65v1.3h1.3v1h-1.3v1.3h-1v-1.3h-1.3v-1h1.3v-1.3h1zM6.81 4.75c1.373 0 2.265.64 2.265 1.908 0 1.299-.818 2.047-2.274 2.047H5.732v2.545h-1.3v-6.5h2.377zm.026 1.133H5.732v1.64h1.113c.72.005.982-.395.981-.832 0-.508-.324-.808-.99-.808z",
    clipRule: "evenodd"
  }));
}

function ParkingGarageIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 12 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M6.493 4.5H3.2v9h1.801V9.975h1.48c2.015 0 3.148-1.035 3.148-2.833C9.63 5.387 8.394 4.5 6.493 4.5m.05 3.84H5V6.069H6.53c.923 0 1.371.415 1.372 1.12.002.605-.363 1.158-1.359 1.153M12 4.1L6 1.7 0 4.1V2.807L5.555.585c.285-.114.605-.114.89 0L12 2.808V4.1z"
  }));
}

function PlayroomIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 110 14.002A7 7 0 018 1zm2.19 4.465c-1.412 1.1-2.704 1.386-4.846 1.406l-.284.002c-1.645-.001-2.242.122-2.774.752A5.727 5.727 0 1013.727 8v-.03c-.815-.188-1.818-.683-2.807-1.663a7.772 7.772 0 01-.71-.813l-.02-.029zM5.396 8.58a.868.868 0 110 1.736.868.868 0 010-1.736zm5.206 0a.868.868 0 110 1.736.868.868 0 010-1.736zM8 2.273a5.73 5.73 0 00-5.305 3.566c.542-.173 1.213-.23 2.124-.238L5.06 5.6c2.317.001 3.413-.263 4.827-1.543a.636.636 0 01.965.132c.296.468.619.87.965 1.214.554.55 1.141.924 1.726 1.155A5.727 5.727 0 008 2.273z",
    clipRule: "evenodd"
  }));
}

function PowerIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.167 7.987l-.06.074c-.277.41.01.99.53.99h5.63l-.604 4.222c-.088.621.68.982 1.1.518l7.07-7.776.06-.074a.637.637 0 00-.53-.99h-5.63L8.337.727c.088-.62-.68-.981-1.1-.518L.166 7.987zm6.617-5.389L6.37 5.497l-.006.088A.636.636 0 007 6.223h4.924l-4.709 5.18.415-2.898.006-.088A.636.636 0 007 7.78H2.075l4.709-5.18z",
    clipRule: "evenodd"
  }));
}

function PremiumSeatIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.679 13.663h2.367V15h-5.44v-1.337h1.736v-3.039h-.813a3.533 3.533 0 01-3.153-1.939l-.085-.18-3.041-6.97L2.475 1l1.822 4.175h3.39v1.337H4.88l.636 1.458a2.196 2.196 0 001.85 1.312l.163.006h4.517c.145 0 .284.047.399.132l.08.07 2.23 2.292-.959.932-2.033-2.09H9.68v3.039z",
    clipRule: "evenodd"
  }));
}

function SeatIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.667 1l.847 4.522h3.43v1.29H5.756L6.11 8.7c.078.42.42.734.836.783l.115.007h5.473v1.29l-2.928-.001v2.931h2.917V15H6.817v-1.29h1.499v-2.931H7.061a2.257 2.257 0 01-2.183-1.683l-.036-.158-1.442-7.7L4.667 1z",
    clipRule: "evenodd"
  }));
}

function SeatsAvailableIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#BABBCF",
    fillRule: "evenodd",
    d: "M9.594 8.165a3.816 3.816 0 012.604 3.492l.003.128v.379h-.757v-.38c0-1.475-1.052-2.687-2.44-2.974a3.192 3.192 0 00-.228-.03c-.363-.493-.99-.778-.99-.778.1 0 .217-.004.255-.008.867-.084 1.683-.836 1.683-1.712 0-.931-.755-1.686-1.685-1.686a.973.973 0 00-.294.042l-.027-.04a2.85 2.85 0 00-.53-.597c.246-.11.608-.161.851-.161a2.441 2.441 0 011.555 4.325zm2.8 0A3.817 3.817 0 0115 11.657l.002.128v.379h-.757v-.38a3.042 3.042 0 00-2.441-2.974 3.11 3.11 0 00-.227-.03c-.362-.493-.99-.778-.99-.778.099 0 .217-.004.255-.008.868-.084 1.683-.836 1.683-1.712 0-.931-.754-1.686-1.685-1.686a.971.971 0 00-.293.042l-.03-.043A2.878 2.878 0 009.988 4c.246-.11.609-.161.85-.161a2.442 2.442 0 011.557 4.325z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.162 3.84a2.441 2.441 0 011.556 4.325 3.817 3.817 0 012.604 3.492l.002.128v.379H1v-.38a3.82 3.82 0 012.607-3.62A2.44 2.44 0 015.162 3.84z",
    clipRule: "evenodd"
  }));
}

function SleepIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.264 5.789l-.001 3.963h12.008c.32 0 .584.239.626.547l.006.086v4.596h-1.264l-.001-1.667H2.263v1.667H1V5.789h1.264zm11.375 5.228l-11.376-.001v1.034h11.375v-1.033zm-1.444-9.561l.007.086v1.074c0 .612.465 1.115 1.06 1.176l.122.006h1.074c.354 0 .613.334.525.677a2.842 2.842 0 01-3.425 2.05 2.82 2.82 0 01-2.084-2.084 2.843 2.843 0 012.05-3.424.542.542 0 01.671.439zm-1.077.954l-.015.012a1.772 1.772 0 00-.574 1.773 1.737 1.737 0 001.275 1.276c.64.15 1.259-.05 1.674-.466l.1-.108.01-.016h-.204a2.265 2.265 0 01-2.245-1.963l-.016-.153-.004-.149V2.41z",
    clipRule: "evenodd"
  }));
}

function StandingAvailableIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#BABBCF",
    fillRule: "evenodd",
    d: "M14.999 11.657a3.817 3.817 0 00-2.604-3.492 2.442 2.442 0 00-1.556-4.325c-.242 0-.605.052-.851.16.32.28.442.473.558.638a.971.971 0 01.293-.042c.93 0 1.685.755 1.685 1.686 0 .876-.815 1.628-1.683 1.712a3.554 3.554 0 01-.255.008s.628.285.99.779c.09.008.209.025.227.029a3.042 3.042 0 012.44 2.975v.379h.758v-.38l-.002-.127z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.604 6.282a2.442 2.442 0 10-3.998 1.882A3.82 3.82 0 001 11.784v.38h8.324v-.38l-.002-.127a3.818 3.818 0 00-2.604-3.492 2.439 2.439 0 00.886-1.883zM9.56 8.165a3.816 3.816 0 012.604 3.492l.002.128v.38h-2.24v-.38l-.003-.138a4.442 4.442 0 00-2.217-3.694 3.019 3.019 0 00-.552-3.952c.266-.1.55-.16.851-.16A2.441 2.441 0 019.56 8.164z",
    clipRule: "evenodd"
  }));
}

function StrollerIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.54 12.221a1.39 1.39 0 11-.001 2.78 1.39 1.39 0 010-2.78zm-5.558 0a1.39 1.39 0 110 2.78 1.39 1.39 0 010-2.78zM8.98 1a5.13 5.13 0 015.125 4.913l.005.217v2.723a2.193 2.193 0 01-2.036 2.187l-.157.005H5.641A2.194 2.194 0 013.453 9.01l-.006-.156v-3.88a.942.942 0 00-.838-.935l-.102-.006H1.9V2.778h.607c1.163 0 2.116.906 2.19 2.05l.005.145-.001.99h3.65V1.627c0-.346.281-.627.628-.627zm-.014 6.216H4.702v1.637c0 .446.312.82.73.915l.107.018.102.005h6.275a.939.939 0 00.932-.829l.007-.11-.001-1.635H8.979l-.014-.001zm.64-4.91v3.656h3.246l-.015-.212a3.878 3.878 0 00-2.922-3.382l-.199-.044-.11-.019z",
    clipRule: "evenodd"
  }));
}

function TVMIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.56 10.57V6.2h-.863v4.37h.863zM1 2.393h14V1H1v1.394zm2.8 12.093a.5.5 0 00.49.513h2.443a.5.5 0 00.49-.513c0-.566.438-1.027.977-1.027.503 0 .919.402.972.915l.006.112a.5.5 0 00.489.513h2.444a.5.5 0 00.489-.513V4h-1.231l-.001 9.768h-1.074l-.043-.122a2.213 2.213 0 00-1.904-1.413l-.147-.005c-.938 0-1.726.592-2.051 1.418l-.044.122H5.032V4H3.8v10.487zm4.624-5.666h.864V6.2h-.864v2.622z",
    clipRule: "evenodd"
  }));
}

function ToiletIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.092 10.832L5.188 6.96h.024L6.3 10.832h1.376l1.616-5.664H7.9l-.936 3.848H6.94L5.924 5.168H4.492L3.5 9.016h-.024l-.928-3.848H1.116l1.6 5.664h1.376zm8.608.152c.968 0 1.712-.376 2.184-.928l-.896-.92c-.256.376-.704.608-1.232.608-.952 0-1.632-.736-1.632-1.744 0-1 .672-1.752 1.648-1.752.488 0 .928.216 1.168.544l.896-.944c-.464-.528-1.296-.832-2.12-.832-1.72 0-3.048 1.192-3.048 2.984 0 1.76 1.304 2.984 3.032 2.984z",
    clipRule: "evenodd"
  }));
}

function TrainCarIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 12.5A1.25 1.25 0 114 15a1.25 1.25 0 010-2.5zm8 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM14 1c.552 0 1 .407 1 .91v8.18c0 .504-.448.91-1 .91H2c-.552 0-1-.406-1-.91V1.91C1 1.406 1.448 1 2 1h12zm-.2 6.2H2.2v2.6h11.6V7.2zm-6.4-5H2.2V6h5.2V2.2zm6.4 0H8.6V6h5.2V2.2z",
    clipRule: "evenodd"
  }));
}

function VendingMachineIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 7c0 3.859 3.14 7.001 7.001 7.001 3.86 0 7-3.142 7-7.001 0-3.859-3.14-7-7-7C3.14 0 0 3.141 0 7zm1 0c0-3.309 2.692-6 6.001-6A6.006 6.006 0 0113 7a6.007 6.007 0 01-5.999 6.001A6.008 6.008 0 011 7zm5.036-2.818a.25.25 0 01.057.494l-.057.006H5.99l.302.685c.153.326.261.558.289.872l.007.165v3.758a.903.903 0 01-.755.914l-.12.012-1.417.001a.917.917 0 01-.89-.818l-.006-.115V6.404c0-.349.088-.584.225-.886l.073-.157.136-.298.113-.26.05-.12h-.045a.25.25 0 01-.057-.494l.057-.007h2.084zm-.92.5h-.25l-.042.1c-.065.153-.156.371-.257.605l-.145.313c-.172.37-.22.485-.22.704v3.758c-.002.071.046.124.11.127h1.37c.055-.002.107-.063.106-.113V6.404c0-.218-.049-.333-.22-.699l-.453-1.023zM11.24 5c.213 0 .408.13.478.31a.51.51 0 01-.108.583L8.423 9.077c-.101.127-.26.197-.348.185L8 9.266A.525.525 0 017.5 8.74V5.518A.528.528 0 018.025 5h3.216zm-2.942.799v2.274L10.572 5.8l-2.273-.001zM5.584 2.8l.052.014a.165.165 0 01.094.114l.003.052v.709H4.254v-.721l.01-.05a.175.175 0 01.1-.106l.051-.012h1.17z",
    clipRule: "evenodd"
  }));
}

function WaitingRoomIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.26 7.155a.41.41 0 01.41.41l-.001 1.617h.676V7.566a.41.41 0 01.328-.402l.083-.009h3.38a.41.41 0 01.41.41l-.001 1.617h1.265a.41.41 0 01.404.337l.007.074V15H13.4l-.001-1.1H8.524V15h-1v-1.1H2.6V15h-.82V9.593l.007-.074a.41.41 0 01.403-.336l1.279-.001V7.566a.41.41 0 01.328-.402l.083-.009h3.38zm6.14 2.848h-.855v1.956a.41.41 0 01-.327.402l-.083.008h-3.38a.41.41 0 01-.41-.41v-1.777h-.676v1.777a.41.41 0 01-.327.402l-.083.008H3.88a.41.41 0 01-.41-.41l-.001-1.956h-.868L2.6 12.9h10.799v-2.897zM6.847 11H4.289v.548h2.56L6.848 11zm4.876 0H9.166v.548h2.558V11zm0-3.024H9.166v2.22h2.558v-2.22zm-4.875 0h-2.56v2.22h2.559v-2.22zM11.218 1a2.462 2.462 0 110 4.924 2.462 2.462 0 010-4.924zm.002.71a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zm.196.59v.923h.923v.616h-1.231a.308.308 0 01-.302-.246l-.006-.062V2.3h.616z",
    clipRule: "evenodd"
  }));
}

function WaterTapIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.739 1h5.512v1.315H6.74V1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.844 4.246h-2.45c-1.83 0-3.242 1.578-3.242 3.434H4.46c0-1.21.905-2.119 1.934-2.119H14.4V4.246h-4.248V2.128H8.844v2.118zM4.291 9.459l-.485.442-.484-.442a.652.652 0 01.969 0zm-.485 1.479a9.529 9.529 0 00-.239.33 5.89 5.89 0 00-.48.81c-.13.278-.179.479-.179.599 0 .674.466 1.008.898 1.008s.899-.334.899-1.008c0-.12-.05-.321-.18-.598a5.89 5.89 0 00-.48-.81 9.529 9.529 0 00-.239-.331zm0-1.037l-.484-.442-.002.002-.005.005-.015.017a7.37 7.37 0 00-.241.285c-.153.187-.359.45-.566.75a7.191 7.191 0 00-.588.999c-.16.342-.305.752-.305 1.16C1.6 14.112 2.687 15 3.806 15c1.12 0 2.207-.888 2.207-2.323 0-.408-.145-.818-.305-1.16a7.191 7.191 0 00-.588-1 11.711 11.711 0 00-.807-1.034l-.016-.017-.004-.005-.001-.001-.001-.001-.485.442z",
    clipRule: "evenodd"
  }));
}

function WheelchairIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.719 7.942v1.273a2.257 2.257 0 102.176 2.855l.035-.147 1.247.253a3.53 3.53 0 11-3.64-4.23l.182-.004zM7.454 1a2.372 2.372 0 01.636 4.658v1.127h2.257v1.273L8.09 8.057v1.62h3.414c.211 0 .406.105.524.275l.045.077 1.736 3.472-1.139.569-1.56-3.12H7.454a.636.636 0 01-.63-.55l-.006-.086V5.658A2.373 2.373 0 017.455 1zm0 1.273a1.1 1.1 0 100 2.198 1.1 1.1 0 000-2.198z",
    clipRule: "evenodd"
  }));
}

function WifiIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 10.474a1.237 1.237 0 110 2.474 1.237 1.237 0 010-2.474zm0-3.712c1.384 0 2.703.514 3.755 1.416l.194.174.452.422-.844.904-.453-.422C10.247 8.456 9.15 8 8 8c-1.072 0-2.1.397-2.93 1.1l-.174.156-.453.422-.844-.904.452-.422C5.132 7.342 6.53 6.762 8 6.762zM8 3.05c2.398 0 4.654.919 6.353 2.515l.21.203.437.437-.875.875-.437-.437A8.027 8.027 0 008 4.287c-2.072 0-4.019.79-5.49 2.165l-.198.19-.437.438L1 6.205l.437-.437A9.264 9.264 0 018 3.05z",
    clipRule: "evenodd"
  }));
}

function DenmarkIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__DenmarkIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#D80027",
    d: "M1 14h14V4H1z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M4.652 4v4.022H1v1.956h3.652V14h1.826V9.978H15V8.022H6.478V4z"
  }));
}

function NorwayIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__NorwayIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#d80027",
    d: "M15 3H1v10h14z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#d80027",
    d: "M15 3H1v10h14z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M7.594 13V9.304H15V6.696H7.594V3H5.16v3.696H1v2.608h4.16V13h1.826z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0052b4",
    d: "M1 7.348v1.304h4.768V13h1.218V8.652H15V7.348H6.986V3H5.768v4.348z"
  }));
}

function SamiIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__SamiIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#0035AD",
    d: "M14.7 3H7.4v10h7.3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#DC241F",
    d: "M1.3 3h4.3v10H1.3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#007229",
    d: "M5.6 3h.9v10h-.9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFCE00",
    d: "M6.5 3h.9v10h-.9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M9.2 8c0-1.5-1.2-2.7-2.7-2.7v5.3C8 10.7 9.2 9.5 9.2 8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#DC241F",
    d: "M6.5 4.8v.5C8 5.3 9.2 6.5 9.2 8S8 10.7 6.5 10.7v.5c1.8 0 3.2-1.4 3.2-3.2S8.3 4.8 6.5 4.8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0035AD",
    d: "M3.8 8c0-1.5 1.2-2.7 2.7-2.7v-.5C4.7 4.8 3.3 6.2 3.3 8s1.4 3.2 3.2 3.2v-.5C5 10.7 3.8 9.5 3.8 8z"
  }));
}

function SwedenIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__SwedenIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#0052B4",
    d: "M1 14h14V4H1z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFDA44",
    d: "M4.652 4v4.022H1v1.956h3.652V14h1.826V9.978H15V8.022H6.478V4z"
  }));
}

function UKIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 10",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__UKIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M0 0h14v10H0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#D80027",
    d: "M4.81 6.286L0 9.999h.582L5.4 6.286z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0052B4",
    d: "M0 6.286v3.036l3.935-3.036z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0052B4",
    d: "M1.734 10h3.99V6.926z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0052B4",
    d: "M8.274 10h3.99l-3.99-3.074z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#D80027",
    d: "M8.599 6.286l4.818 3.713H14L9.189 6.286z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0052B4",
    d: "M10.063 6.286L14 9.322V6.286z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0052B4",
    d: "M10.063 3.713v.002H14V.677z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#D80027",
    d: "M13.417 0L8.599 3.713h.59L14 0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0052B4",
    d: "M8.274 0v3.075L12.264 0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0052B4",
    d: "M0 3.715h3.935v-.002L0 .677z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#D80027",
    d: "M0 0l4.81 3.713h.589L.581 0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0052B4",
    d: "M1.734 0l3.99 3.075V0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#D80027",
    d: "M14 4.348H7.652V0H6.348v4.348H0v1.305H6.348V10h1.304V5.653H14z"
  })));
}

function BergenBysykkelIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__BergenBysykkelIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#008A34",
    d: "M11.816 12.932a3.184 3.184 0 110-6.368 3.184 3.184 0 010 6.368zm0-4.895a1.71 1.71 0 101.711 1.711c0-.944-.766-1.71-1.71-1.71zm-7.632 4.895a3.184 3.184 0 113.183-3.184 3.188 3.188 0 01-3.183 3.184zm0-4.895a1.71 1.71 0 100 3.422 1.71 1.71 0 000-3.422zM6.55 5.733H3.986a.737.737 0 010-1.475h2.565a.737.737 0 010 1.475zm4.485-.794a5.619 5.619 0 01-2.2-.446.737.737 0 11.58-1.356 4.147 4.147 0 001.62.327 4.146 4.146 0 001.64-.334.74.74 0 11.59 1.356 5.631 5.631 0 01-2.23.453z"
  }));
}

function BoltIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__BoltIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "#34D186"
  }, /*#__PURE__*/createElement("path", {
    d: "M8 1a4.86 4.86 0 000 9.718A4.86 4.86 0 008 1zm0 6.433c-.87 0-1.575-.703-1.575-1.574S7.13 4.284 8 4.284c.87 0 1.575.704 1.575 1.575S8.87 7.433 8 7.433z"
  }), /*#__PURE__*/createElement("circle", {
    cx: 8,
    cy: 13.425,
    r: 1.575
  })));
}

function BrakarIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 49.8 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__BrakarIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/createElement("path", {
    d: "M23.5 8c.8-.2 1.2-.9 1.2-1.7 0-1.2-.9-2.1-2.3-2.1h-3.1v8.3h2.9c1.8 0 2.7-1 2.7-2.4.1-1-.4-1.8-1.4-2.1zm-3-2.8h1.7c.9 0 1.3.5 1.3 1.3 0 .7-.4 1.2-1.3 1.2h-1.8l.1-2.5zm1.7 6.2h-1.6V8.6h1.8c1 0 1.5.6 1.5 1.4 0 .8-.6 1.4-1.7 1.4z"
  }), /*#__PURE__*/createElement("path", {
    d: "M27.1 7.7V6.5H26v5.9h1.1V9.3c0-1.1.5-1.8 1.2-1.8.4 0 .7.1.9.3v-1c-.2-.2-.5-.3-.8-.3-.6-.1-1.1.4-1.3 1.2z"
  }), /*#__PURE__*/createElement("path", {
    d: "M31.9 6.3c-.8 0-1.5.3-2 .7v1.1c.5-.5 1.1-.8 1.8-.8 1 0 1.6.6 1.6 1.6v.5c-.3-.4-.8-.7-1.6-.7-1.3 0-2.1.8-2.1 1.9 0 1.1.9 1.9 2.1 1.9.8 0 1.4-.4 1.7-1v.8h1.1V8.8c-.1-1.5-1-2.5-2.6-2.5zm.1 5.4c-.8 0-1.3-.4-1.3-1.1 0-.7.5-1.1 1.3-1.1s1.3.4 1.3 1.1c.1.6-.4 1.1-1.3 1.1z"
  }), /*#__PURE__*/createElement("path", {
    d: "M40.4 6.5h-1.5L36.6 9V4.1h-1.1v8.3h1.1V9.5l2.5 2.9h1.5l-3-3.2z"
  }), /*#__PURE__*/createElement("path", {
    d: "M42.9 6.3c-.8 0-1.5.3-2 .7v1.1c.5-.5 1.1-.8 1.8-.8 1 0 1.6.6 1.6 1.6v.5c-.3-.4-.8-.7-1.6-.7-1.3 0-2.1.8-2.1 1.9 0 1.1.9 1.9 2.1 1.9.8 0 1.4-.4 1.7-1v.8h1.1V8.8c-.1-1.5-1.1-2.5-2.6-2.5zm.1 5.4c-.8 0-1.3-.4-1.3-1.1 0-.7.5-1.1 1.3-1.1s1.3.4 1.3 1.1c0 .6-.5 1.1-1.3 1.1z"
  }), /*#__PURE__*/createElement("path", {
    d: "M49 6.4c-.6 0-1.1.4-1.4 1.3V6.5h-1.1v5.9h1.1V9.3c0-1.1.5-1.8 1.2-1.8.4 0 .7.1.9.3v-1c-.2-.3-.4-.4-.7-.4z"
  })), /*#__PURE__*/createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/createElement("path", {
    d: "M.2 6.4C.1 6.9 0 7.5 0 8.1c1.1-.3 2.1-.5 3.2-.6-.9-.6-2-.9-3-1.1z"
  }), /*#__PURE__*/createElement("path", {
    d: "M.2 9.9c.6 2.4 2.2 4.4 4.5 5.4-.3-2.6-2.1-4.7-4.5-5.4z"
  }), /*#__PURE__*/createElement("path", {
    d: "M8 0C4.9 0 2.2 1.8.9 4.4c2.2-.4 4.5-.5 6.8-.2.2-.3.6-.4 1-.4.5 0 1 .3 1.2.9.7.2 1.4.3 2 .6l-.7.7c-.7-.3-1.4-.5-2.2-.7 0-.1.1-.2.1-.2 0-.2-.2-.4-.4-.4s-.4.2-.4.4v.1C5.6 4.7 3 4.8.4 5.4v.1c1.6.3 3.1 1 4.3 1.9 2.4 0 4.7.4 6.9 1.4l1-1c-.7-.4-1.5-.7-2.3-.9l.7-.7c1.1.4 2.1.9 3.1 1.4-.4.4-1.9 1.8-2.3 2.2-1.9-.8-3.9-1.4-6-1.5C7.9 10.3 9 13 9 15.9c3.9-.5 7-3.9 7-7.9 0-4.4-3.6-8-8-8z"
  }), /*#__PURE__*/createElement("path", {
    d: "M4.4 8.3C3 8.4 1.6 8.6.2 9c1.5.4 2.8 1.2 3.8 2.4s1.5 2.7 1.6 4.2c.8.3 1.7.4 2.5.4 0-3-1.3-5.8-3.7-7.7z"
  })));
}

function BrakarNoTextIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__BrakarNoTextIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M.2 6.4C.1 6.9 0 7.4 0 8v.1c1.1-.3 2.1-.5 3.2-.6-.9-.6-2-.9-3-1.1"
  }), /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M.2 9.9c.6 2.4 2.2 4.4 4.5 5.4-.3-2.6-2.1-4.7-4.5-5.4"
  }), /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M8 0C4.9 0 2.2 1.8.9 4.4c1.3-.3 2.6-.4 4-.4.9 0 1.9.1 2.8.2.2-.3.6-.4 1-.4.5 0 1 .3 1.2.9.6.1 1.2.3 1.8.5 0 0 .1 0 .2.1l-.7.7c-.5-.2-1-.3-1.5-.4-.1 0-.2-.1-.4-.1 0-.1-.2-.1-.3-.2 0-.1.1-.2.1-.2 0-.2-.1-.4-.3-.4h-.1-.1c-.2 0-.4.2-.4.4v.1c-.1 0-.3 0-.4-.1-.1 0-.3 0-.4-.1-.8 0-1.7-.1-2.5-.1-1.5 0-3 .2-4.4.5v.1c1.6.3 3.1 1 4.3 1.9h.1c2.3 0 4.6.5 6.8 1.4l1-1c-.7-.4-1.4-.6-2.2-.9h-.1l.6-.7c.9.3 1.7.7 2.5 1.1l.5.3-.6.6-1.7 1.7-.3-.1c-1.7-.9-3.6-1.4-5.6-1.5l.1.1c2 2 3.1 4.7 3.1 7.5 3.9-.5 7-3.9 7-7.9 0-4.4-3.6-8-8-8"
  }), /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M8.1 16c0-3-1.4-5.8-3.7-7.7-1.4 0-2.8.3-4.2.7 1.5.4 2.8 1.3 3.8 2.5s1.5 2.7 1.6 4.2c.8.2 1.6.3 2.4.3h.1z"
  }));
}

function FarteIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 90 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__FarteIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M55.202 3.039L53.413 4.23v2.536h-1.234V8.37h1.234v7.383h1.789V8.37h1.666V6.766h-1.666z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M84.855 6.56c-2.57 0-4.69 2.119-4.69 4.69 0 2.57 2.12 4.709 4.69 4.709 2.57 0 4.668-2.139 4.668-4.71 0-2.57-2.097-4.689-4.668-4.689zm0 7.754c-1.707 0-2.838-1.358-2.838-3.065 0-1.665 1.13-3.043 2.838-3.043 1.727 0 2.817 1.378 2.817 3.043 0 1.707-1.09 3.065-2.817 3.065z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M34.937 0c-1.707 0-2.509 1.09-2.509 3.208v3.558h-1.234V8.37h1.234v7.383h1.81V8.37h1.666V6.766h-1.666V3.044c0-.885.37-1.399 1.05-1.399.184 0 .39.02.595.082l.206.056V.155A4.612 4.612 0 0034.937 0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M75.47 6.56c-1.254 0-1.908.519-2.693 1.255l-.165.154V6.766h-1.81v8.987h1.81v-4.915c0-1.666 1.028-2.632 2.427-2.632 1.336 0 1.85.822 1.85 2.241v5.306h1.81v-5.717c0-1.954-.74-3.476-3.228-3.476z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M68.188 13.45c-.72 0-1.275.555-1.275 1.275 0 .74.596 1.275 1.275 1.275.72 0 1.275-.576 1.275-1.296 0-.678-.555-1.254-1.275-1.254z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M65.974 11.25c0-2.51-1.44-4.69-4.195-4.69-2.571 0-4.278 2.119-4.278 4.69 0 2.632 1.583 4.709 4.771 4.709 1.049 0 2.128-.302 2.653-.679l.165-.118v-1.834c-.878.712-2.038.986-2.818.986-1.645 0-2.694-.803-2.838-2.098a7.34 7.34 0 01-.016-.185h6.556v-.782zm-6.649-.659c0-.08 0-.155.006-.205.165-1.214 1.09-2.201 2.448-2.201 1.48 0 2.213.967 2.365 2.2l.025.206h-4.844z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M40.403 6.56c-.898 0-1.9.26-2.518.66v1.684l.214-.164c.309-.246 1.05-.658 2.14-.658 1.48 0 2.138.638 2.138 1.79v.727a2.689 2.689 0 00-.165-.131c-.37-.288-1.192-.72-2.344-.72-1.85 0-3.455 1.131-3.455 3.126 0 2.057 1.666 3.085 3.455 3.085.967 0 1.83-.411 2.406-1.131l.165-.218v1.143h1.707V9.851c0-1.543-.576-3.29-3.743-3.29zm-.185 7.918c-1.275 0-2.036-.679-2.036-1.666 0-.966.822-1.624 2.036-1.624 1.13 0 2.088.717 2.088 1.601 0 .864-.916 1.69-2.088 1.69zm2.45-3.63l-.001-.002c.01.001.013.002.002.002z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M27.618 6.765l-8.989 8.989h-3.62l8.99-8.989z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M20.382 6.765l-8.989 8.989H7.774l8.988-8.989z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M13.145 6.765l-8.988 8.989H.537l8.989-8.989z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M51.267 6.764h-.346c-1.13 0-2.294.518-2.897 1.473V6.766h-1.81v8.987h1.81V11.99c0-2.299 1.158-3.62 2.912-3.62h.33V6.764z"
  }));
}

function GOAIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 56.732 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__GOAIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M34.447 15.1h.011l.58-3.288h.566l-.72 4.084h-.713l-1.496-3.358h-.014l-.593 3.358h-.56l.721-4.084h.722l1.496 3.288z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M38.027 16a2.28 2.28 0 01-.776-.125 1.692 1.692 0 01-.597-.354 1.567 1.567 0 01-.384-.556 1.886 1.886 0 01-.136-.73c-.002-.337.06-.67.182-.984.116-.297.286-.57.502-.803.213-.228.469-.412.753-.542a2.358 2.358 0 011.702-.074 1.602 1.602 0 01.978.908c.093.23.14.478.136.727.002.337-.058.672-.177.987-.11.297-.278.57-.492.805a2.358 2.358 0 01-.75.542 2.232 2.232 0 01-.94.199zm1.771-2.483a1.52 1.52 0 00-.086-.516 1.174 1.174 0 00-.667-.705 1.425 1.425 0 00-.563-.104c-.251-.004-.5.055-.723.17-.215.11-.404.264-.558.45a2.22 2.22 0 00-.473 1.367c0 .175.03.348.088.513.054.157.14.3.25.423.114.124.254.222.41.285.181.073.374.108.568.104.254.004.504-.054.73-.167.213-.109.402-.26.554-.446.153-.19.27-.406.348-.637a2.24 2.24 0 00.122-.737z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M41.48 15.896h-.56l.721-4.084h1.162c.184-.002.369.02.548.066.153.038.297.105.425.196a.886.886 0 01.366.753 1.17 1.17 0 01-.087.464 1.073 1.073 0 01-.59.588c-.146.064-.3.108-.457.132l.872 1.882h-.635l-.813-1.823h-.63l-.322 1.826zm.398-2.29h.629c.138 0 .276-.01.412-.035a.999.999 0 00.334-.116.605.605 0 00.31-.562.498.498 0 00-.233-.464 1.197 1.197 0 00-.62-.139h-.6l-.232 1.316z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M45.304 11.812h1.322c.232 0 .463.032.686.094.221.06.43.163.612.3.185.142.335.324.438.531.118.244.175.512.167.782.005.335-.059.666-.187.976-.12.283-.297.539-.522.749a2.336 2.336 0 01-.791.482 2.801 2.801 0 01-.992.17h-1.454l.721-4.084zM45.23 15.4h.837c.279.007.556-.046.813-.153.22-.095.417-.233.58-.406.158-.168.279-.365.356-.581.078-.215.117-.442.116-.671.002-.17-.027-.34-.086-.5a1.132 1.132 0 00-.262-.41 1.257 1.257 0 00-.45-.28 1.843 1.843 0 00-.65-.103h-.71L45.23 15.4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M49.628 15.896h-.565l.72-4.084h.566l-.72 4.084z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M54.31 15.25a1.92 1.92 0 01-1.093.692c-.175.04-.354.059-.533.058a2.106 2.106 0 01-.748-.127 1.678 1.678 0 01-.58-.358 1.6 1.6 0 01-.373-.554 1.869 1.869 0 01-.132-.715 2.6 2.6 0 01.187-.992 2.473 2.473 0 011.287-1.348 2.286 2.286 0 011.384-.152c.135.028.266.072.39.13.115.053.224.12.323.198.093.072.171.16.233.26l-.465.34a.79.79 0 00-.127-.172 1.045 1.045 0 00-.468-.275 1.196 1.196 0 00-.334-.045 1.591 1.591 0 00-.733.171c-.22.11-.418.261-.58.446-.164.186-.291.401-.376.634-.088.234-.133.481-.133.73a1.58 1.58 0 00.083.52c.054.156.138.3.249.423.113.124.252.221.406.285.176.072.365.107.554.104.466.005.908-.206 1.195-.572l.385.319z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M4.515 6.605H6.36l-.193 1.136c-.2.1-.415.17-.635.207a5.277 5.277 0 01-.743.074 2.95 2.95 0 01-1.07-.18 2.193 2.193 0 01-.789-.507 2.102 2.102 0 01-.48-.776 2.854 2.854 0 01-.16-.966 3.958 3.958 0 01.248-1.394 3.76 3.76 0 01.681-1.161 3.261 3.261 0 011.03-.796 2.867 2.867 0 011.29-.294c.405-.015.808.075 1.17.26.288.158.537.38.727.65L9.054 1.4A3.179 3.179 0 007.616.355 5.586 5.586 0 005.578 0a5.416 5.416 0 00-2.225.454c-.67.294-1.274.719-1.778 1.25A5.742 5.742 0 00.398 3.557a6.195 6.195 0 00-.42 2.285 4.288 4.288 0 00.327 1.711 3.7 3.7 0 00.916 1.296 4.04 4.04 0 001.423.823 5.66 5.66 0 001.852.288c.629 0 1.255-.079 1.865-.233a7.445 7.445 0 001.626-.601l.75-4.347H4.85l-.335 1.825z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M16.487 4.533a2.733 2.733 0 00-.716-.922 3.147 3.147 0 00-1.082-.58 4.468 4.468 0 00-1.363-.201 4.122 4.122 0 00-1.698.334 3.94 3.94 0 00-1.278.896 3.88 3.88 0 00-.813 1.31 4.463 4.463 0 00-.28 1.577c-.017.825.34 1.613.969 2.146.314.262.677.46 1.068.58.435.137.888.205 1.344.202a4.279 4.279 0 001.724-.334 3.899 3.899 0 001.29-.89c.357-.376.633-.821.813-1.308.188-.51.283-1.048.28-1.591a2.78 2.78 0 00-.258-1.219zM14.502 6.8c-.084.249-.213.48-.38.682a1.79 1.79 0 01-.595.465 1.768 1.768 0 01-.776.167c-.446 0-.79-.132-1.03-.395a1.418 1.418 0 01-.36-.995 2.47 2.47 0 01.133-.813c.084-.25.212-.484.379-.689a1.78 1.78 0 01.587-.465c.242-.118.507-.178.776-.174.445 0 .79.134 1.035.4.248.275.38.635.368 1.004 0 .277-.047.552-.137.813z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M32.894 3.457a1.8 1.8 0 00-.662-.441 2.588 2.588 0 00-.962-.16 2.22 2.22 0 00-1.19.314c-.312.184-.58.432-.789.728h-.027l.65-3.676h-2.149l-1.664 9.464h2.138l.642-3.582c.06-.383.221-.744.465-1.046a1.15 1.15 0 01.942-.434c.33 0 .558.086.688.26.133.185.201.408.194.635a2.683 2.683 0 01-.067.561l-.628 3.61h2.139l.718-4.097c.027-.117.045-.235.053-.355.01-.116.014-.242.014-.368.002-.26-.037-.52-.116-.767a1.73 1.73 0 00-.39-.646z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M40.675 4.431a2.408 2.408 0 00-.602-.874 2.636 2.636 0 00-.929-.543 3.656 3.656 0 00-1.196-.187 4.085 4.085 0 00-1.618.315 3.81 3.81 0 00-1.262.862 4.023 4.023 0 00-.83 1.29 4.202 4.202 0 00-.299 1.598c-.008.441.078.879.254 1.284.16.361.398.683.697.943.304.258.656.453 1.036.573.415.133.848.2 1.283.198a4.718 4.718 0 001.698-.301 3.821 3.821 0 001.43-.983l-1.35-1.055c-.2.21-.436.382-.696.508a2.04 2.04 0 01-.896.187c-.183 0-.366-.026-.54-.08a1.54 1.54 0 01-.465-.232c-.137-.1-.25-.227-.335-.374a.988.988 0 01-.127-.502c0-.039.005-.078.014-.116h4.771a5.967 5.967 0 00.175-1.297 3.15 3.15 0 00-.213-1.214zm-1.684 1.057c0 .045-.005.09-.014.134h-2.89c.04-.156.103-.304.186-.442.094-.155.212-.295.349-.414.15-.13.32-.235.502-.314.204-.087.425-.131.648-.128.392 0 .693.099.902.295a.964.964 0 01.315.736l.002.133z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M47.453 4.019a1.955 1.955 0 00-.58-.669 2.512 2.512 0 00-.877-.394 4.564 4.564 0 00-1.109-.127 4.852 4.852 0 00-1.544.26c-.502.164-.97.415-1.383.743l.882 1.229c.255-.19.537-.344.835-.454.293-.114.603-.173.917-.175.268-.015.534.048.767.182a.63.63 0 01.274.567v.117a.876.876 0 01-.026.187c-.552 0-1.104.035-1.65.106-.507.06-1.002.19-1.471.388a2.645 2.645 0 00-1.045.789c-.267.338-.401.774-.401 1.31-.009.29.055.577.187.835.117.219.284.407.488.548.203.139.43.239.669.294.234.057.473.086.714.087.866 0 1.543-.29 2.032-.869h.027a4.87 4.87 0 00-.053.708h1.897c0-.151.012-.348.034-.588.022-.24.056-.476.1-.708l.455-2.594a3.89 3.89 0 00.06-.413c.013-.143.02-.277.02-.402a2.027 2.027 0 00-.22-.957zM45.42 7.093a1.665 1.665 0 01-.521.942c-.28.256-.65.392-1.029.38a1.308 1.308 0 01-.609-.14c-.182-.093-.274-.274-.274-.54a.627.627 0 01.215-.496c.159-.133.343-.233.541-.293.241-.075.49-.122.741-.14.277-.023.548-.033.813-.033h.187l-.064.32z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M54.612.222l-.622 3.663h-.026a1.924 1.924 0 00-.803-.749 2.698 2.698 0 00-1.27-.28 3.339 3.339 0 00-1.477.327c-.443.214-.839.517-1.161.89-.332.385-.59.83-.762 1.31a4.607 4.607 0 00-.274 1.603c-.005.391.058.78.187 1.15.117.334.301.641.541.901.243.26.54.463.869.596.37.147.764.22 1.161.214.454.005.903-.09 1.314-.281.377-.174.7-.447.936-.789h.04l-.16.91h1.971L56.754.221h-2.142zM53.462 6.8c-.089.25-.222.48-.394.682a1.864 1.864 0 01-.601.465c-.234.111-.49.169-.75.167-.453 0-.796-.134-1.029-.402a1.473 1.473 0 01-.348-1.002 2.51 2.51 0 01.134-.828 2.12 2.12 0 01.374-.676 1.735 1.735 0 011.363-.622c.38-.019.75.125 1.016.395.254.274.388.637.374 1.01a2.37 2.37 0 01-.138.811h-.001z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M21.805.222l-2.9 4.552h2.266l1.209-2.119.449 3.049-3.003 2.098h3.275l.321 1.884h2.339L23.97.222z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M17.739 6.605l-1.963 3.081h2.54l.998-1.654.813-1.427z"
  }));
}

function InnlandstrafikkIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 77.331 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__InnlandstrafikkIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/createElement("path", {
    d: "M-.014 0v8.111C-.014 13.463 6.351 16 6.351 16s6.364-2.54 6.364-7.889V0H-.014zM6.35 1.713L9 4.36l-.617.617L6.35 2.946 4.32 4.978l-.618-.617L6.35 1.713zM2.101 5.227L.86 6.469V5.235L2.1 3.993l3.633 3.632-.617.618-3.015-3.016zm9.742 1.242L10.6 5.227l-5.13 5.13a1.255 1.255 0 101.766.006l-.27-.27.617-.617.248.249a2.125 2.125 0 11-2.947-.013L10.6 3.995l1.243 1.243V6.47z"
  }), /*#__PURE__*/createElement("path", {
    d: "M16.88 3.344h.944v5.57h-.944v-5.57z"
  }), /*#__PURE__*/createElement("path", {
    d: "M20.135 6.593v2.295h-.893v-4.24h.893v.773a1.605 1.605 0 011.41-.836c.478 0 .865.146 1.16.438.295.292.443.714.443 1.267v2.598h-.893V6.561c0-.78-.324-1.171-.973-1.172a1.169 1.169 0 00-.807.307c-.227.205-.34.504-.34.897z"
  }), /*#__PURE__*/createElement("path", {
    d: "M25.117 6.593v2.295h-.893v-4.24h.893v.773a1.605 1.605 0 011.41-.836c.48 0 .866.146 1.16.438.295.292.442.714.442 1.267v2.598h-.892V6.561c0-.78-.324-1.171-.972-1.172a1.17 1.17 0 00-.806.307c-.228.205-.342.504-.342.897z"
  }), /*#__PURE__*/createElement("path", {
    d: "M31.366 8.585c-.212.245-.51.367-.893.368a1.253 1.253 0 01-.92-.343c-.232-.229-.347-.566-.347-1.012V3.317h.893v4.177c0 .425.159.637.478.637a.427.427 0 00.398-.2l.391.654z"
  }), /*#__PURE__*/createElement("path", {
    d: "M35.487 8.888h-.813v-.566c-.35.42-.821.63-1.411.63-.4.014-.79-.12-1.095-.378-.29-.25-.45-.618-.435-1 0-.417.154-.73.462-.936.308-.208.725-.311 1.252-.312h1.156V6.17c0-.563-.315-.844-.944-.844-.393 0-.803.144-1.228.43l-.4-.557a2.738 2.738 0 011.757-.614c.498 0 .908.126 1.227.378.32.251.477.649.472 1.191v2.734zm-.893-1.577v-.359h-1.003c-.643 0-.965.202-.965.605a.54.54 0 00.238.472c.2.119.43.176.661.164.268.005.53-.08.745-.24a.763.763 0 00.324-.642z"
  }), /*#__PURE__*/createElement("path", {
    d: "M37.583 6.593v2.295h-.892v-4.24h.892v.773a1.605 1.605 0 011.411-.836c.48 0 .866.146 1.16.438.293.292.441.714.442 1.267v2.598h-.893V6.561c0-.78-.324-1.171-.971-1.172a1.17 1.17 0 00-.806.307c-.228.205-.343.504-.343.897z"
  }), /*#__PURE__*/createElement("path", {
    d: "M42.183 8.347c-.399-.404-.598-.935-.598-1.594 0-.66.204-1.186.614-1.579a2.038 2.038 0 011.462-.59c.549-.01 1.064.261 1.367.718V2.975h.893v5.913h-.893v-.637c-.33.467-.81.701-1.442.702a1.907 1.907 0 01-1.403-.606zm.291-1.558c-.014.37.128.73.391.992.242.245.573.381.917.378.339.005.664-.136.892-.387.25-.269.381-.626.368-.992a1.454 1.454 0 00-.368-1.012 1.162 1.162 0 00-.9-.407 1.21 1.21 0 00-.916.407 1.425 1.425 0 00-.384 1.02z"
  }), /*#__PURE__*/createElement("path", {
    d: "M50.426 7.621c.014.375-.148.734-.439.971-.292.242-.666.363-1.123.363a2.988 2.988 0 01-.96-.174 2.855 2.855 0 01-.882-.472l.43-.693c.494.372.972.558 1.435.558.17.011.34-.036.48-.134a.433.433 0 00.175-.355c0-.212-.283-.403-.85-.573a1.26 1.26 0 00-.094-.033c-.881-.239-1.322-.637-1.322-1.195-.01-.37.16-.723.46-.944.304-.236.701-.354 1.19-.354.495.002.977.152 1.385.43l-.335.66a2.005 2.005 0 00-1.124-.342 1.02 1.02 0 00-.518.116.378.378 0 00-.195.346.317.317 0 00.207.303c.13.058.264.102.402.133.173.042.325.085.458.127.133.043.262.094.387.144.14.062.275.136.403.222.287.194.43.493.43.896z"
  }), /*#__PURE__*/createElement("path", {
    d: "M52.791 5.366v2.152a.699.699 0 00.164.482.566.566 0 00.446.18c.19 0 .378-.095.55-.284l.366.63c-.28.268-.651.42-1.038.423a1.34 1.34 0 01-.973-.395c-.268-.264-.402-.618-.402-1.064V5.366h-.535v-.718h.535V3.317h.892v1.331h1.116v.718h-1.12z"
  }), /*#__PURE__*/createElement("path", {
    d: "M57.203 5.486c-.44 0-.773.143-.997.43-.224.287-.335.672-.334 1.155v1.817h-.893v-4.24h.893v.85c.14-.261.341-.485.586-.653.23-.164.503-.256.785-.263l.008.9-.048.004z"
  }), /*#__PURE__*/createElement("path", {
    d: "M61.772 8.888h-.813v-.566c-.35.42-.821.63-1.41.63-.4.014-.79-.12-1.096-.378-.29-.25-.45-.618-.435-1 0-.417.154-.73.462-.936.308-.208.725-.311 1.252-.312h1.154V6.17c0-.563-.315-.844-.944-.844-.394 0-.803.144-1.228.43l-.398-.557a2.738 2.738 0 011.753-.614c.499 0 .908.126 1.227.378.32.251.478.649.473 1.191l.003 2.734zm-.893-1.577v-.359h-1.004c-.642 0-.964.202-.964.605a.542.542 0 00.238.472c.2.119.43.176.661.164.269.005.531-.08.746-.24a.765.765 0 00.323-.642z"
  }), /*#__PURE__*/createElement("path", {
    d: "M64.115 4.298v.35h1.114v.718h-1.114v3.522h-.892V5.366h-.535v-.718h.535v-.327c0-.446.134-.801.402-1.064.257-.258.608-.4.972-.394.388.004.76.155 1.039.423l-.366.63c-.176-.19-.36-.284-.55-.284a.567.567 0 00-.447.18.703.703 0 00-.158.486z"
  }), /*#__PURE__*/createElement("path", {
    d: "M66.582 3.803a.556.556 0 11.797-.776.556.556 0 01-.797.776zm.836 5.085h-.892v-4.24h.892v4.24z"
  }), /*#__PURE__*/createElement("path", {
    d: "M69.674 8.888h-.892V2.975h.892V6.45l1.721-1.802h1.148l-1.61 1.678 1.73 2.559H71.58L70.32 7.03l-.645.654v1.203z"
  }), /*#__PURE__*/createElement("path", {
    d: "M74.328 8.888h-.892V2.975h.892V6.45l1.722-1.802h1.147l-1.61 1.678 1.727 2.562h-1.08l-1.26-1.857-.646.654v1.203z"
  })));
}

function KolumbusIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 69.4 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__KolumbusIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M67 8.5c1.4.2 2.6.6 2.6 2 0 1.3-1.1 2.1-2.8 2.1-1.6 0-2.7-.7-2.9-1.9l1.5-.2c.1.7.6 1 1.4 1 .7 0 1.2-.3 1.2-.8s-.4-.7-1.5-.9c-1.5-.2-2.5-.7-2.5-2 0-1.4 1.3-2 2.7-2 1.4 0 2.6.7 2.7 1.8l-1.5.3c-.1-.6-.5-1-1.2-1-.6 0-1.1.3-1.1.8s.6.6 1.4.8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M62.8 12.3h-1.5v-1c-.4.7-1 1.1-2 1.1-1.3 0-2.3-.7-2.3-2.2V5.9h1.6V10c0 .9.6 1.3 1.2 1.3.8 0 1.5-.7 1.5-1.9V5.9h1.6l-.1 6.4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M55.9 9.1c0 2.1-1.3 3.4-3 3.4-1.1 0-1.8-.5-2.1-1.1v1h-1.5V2.8h1.6v3.9c.4-.5 1.1-1 2.1-1 1.7 0 2.9 1.3 2.9 3.4zm-5 .3c0 1.3 1 1.9 1.8 1.9 1 0 1.7-.9 1.7-2.2 0-1.2-.7-2.2-1.7-2.2-.8 0-1.8.5-1.8 1.9v.6z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M38 5.9h1.5v1c.4-.7 1-1.2 2-1.2.9 0 1.7.4 2 1.2.4-.6 1.1-1.2 2.1-1.2 1.2 0 2.2.7 2.2 2.2v4.5h-1.6V8.3c0-.9-.5-1.3-1.1-1.3-.7 0-1.4.7-1.4 1.9v3.4h-1.6v-4c0-.9-.5-1.3-1.1-1.3-.7 0-1.4.7-1.4 1.9v3.4H38V5.9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M36.3 12.3h-1.5v-1c-.4.7-1 1.1-2 1.1-1.3 0-2.3-.7-2.3-2.2V5.9h1.6V10c0 .9.6 1.3 1.2 1.3.8 0 1.5-.7 1.5-1.9V5.9h1.6l-.1 6.4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M27.4 2.8H29v9.5h-1.6z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M26.3 9.1c0 2-1.3 3.4-3.3 3.4s-3.3-1.4-3.3-3.4S21 5.7 23 5.7s3.3 1.4 3.3 3.4zm-1.6 0c0-1.2-.5-2.2-1.7-2.2-1.1 0-1.7 1-1.7 2.2 0 1.2.5 2.2 1.7 2.2 1.1 0 1.7-1 1.7-2.2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M14.6 7.8l-.9 1v3.5h-1.6V2.8h1.6v4l3.8-4h1.9l-3.6 3.8 3.9 5.7h-2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M0 10.6V14l7.8-4.2V6.4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M0 2v3.3l3.8 2.1 3.1-1.7z"
  }));
}

function KolumbusBysykkelIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__KolumbusBysykkelIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#3CB454",
    d: "M3.45 11.033V15l9.1-4.9V6.133z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#3CB454",
    d: "M3.45 1v3.85L7.883 7.3 11.5 5.317z"
  }));
}

function LimeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__LimeIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "#0D0"
  }, /*#__PURE__*/createElement("path", {
    d: "M8 1.794c3.422 0 6.206 2.784 6.206 6.206S11.422 14.206 8 14.206c-3.422 0-6.206-2.784-6.206-6.206S4.578 1.794 8 1.794M8 1a7 7 0 100 14A7 7 0 008 1z"
  }), /*#__PURE__*/createElement("circle", {
    cx: 8,
    cy: 8,
    r: 0.906
  }), /*#__PURE__*/createElement("path", {
    d: "M9.533 6.658l2.173-1.255a.758.758 0 00.164-1.186 5.406 5.406 0 00-2.524-1.46.76.76 0 00-.95.734V6c0 .584.632.949 1.137.657z"
  }), /*#__PURE__*/createElement("path", {
    d: "M7.604 6V3.49a.76.76 0 00-.95-.733 5.406 5.406 0 00-2.524 1.46.758.758 0 00.164 1.186l2.173 1.255A.759.759 0 007.604 6z"
  }), /*#__PURE__*/createElement("path", {
    d: "M9.93 8.657l2.173 1.255a.758.758 0 001.11-.45 5.415 5.415 0 000-2.923.758.758 0 00-1.11-.451L9.929 7.343a.759.759 0 000 1.314z"
  }), /*#__PURE__*/createElement("path", {
    d: "M6.467 9.342l-2.173 1.255a.758.758 0 00-.164 1.186 5.406 5.406 0 002.524 1.46.76.76 0 00.95-.734V10a.759.759 0 00-1.137-.657z"
  }), /*#__PURE__*/createElement("path", {
    d: "M6.07 7.343L3.898 6.088a.758.758 0 00-1.11.45 5.415 5.415 0 000 2.923.758.758 0 001.11.451l2.174-1.255a.759.759 0 000-1.314z"
  }), /*#__PURE__*/createElement("path", {
    d: "M8.396 10v2.51c0 .496.469.856.95.733a5.406 5.406 0 002.524-1.46.758.758 0 00-.164-1.186L9.533 9.342A.759.759 0 008.396 10z"
  })));
}

function MoveAboutIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__MoveAboutIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "#5BD6FF"
  }, /*#__PURE__*/createElement("path", {
    d: "M4.8 11.216a.476.476 0 100-.951.476.476 0 000 .95z"
  }), /*#__PURE__*/createElement("path", {
    d: "M11.58 6.695a.363.363 0 10-.001.726.363.363 0 000-.726z"
  }), /*#__PURE__*/createElement("path", {
    d: "M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm3.8 8.643a.428.428 0 00-.426.486.182.182 0 01-.036.155l-.63.693c-.034.037-.072.028-.086-.02l-.69-2.409a.195.195 0 01.033-.158s.188-.224.188-.427a.627.627 0 10-.627.629c.071 0 .117-.013.117-.013a.092.092 0 01.111.065l.597 2.295c.013.048-.015.073-.061.055l-.769-.297a.309.309 0 01-.131-.11s-.218-.359-.48-.358A.536.536 0 108.91 11.3c.225 0 .44-.265.44-.265a.11.11 0 01.135-.024l.629.369a.104.104 0 01.04.129l-1.224 2.704c-.208.031-.42.052-.634.062l-1.542-2.677a.453.453 0 01-.049-.169l-.21-4.712a.138.138 0 01.08-.124l.9-.359a.149.149 0 01.149.032s.378.386.709.385a.886.886 0 10-.88-.782.1.1 0 01-.073.112l-.908.218c-.05.012-.076-.018-.06-.065l.716-2.141c.016-.047.036-.086.044-.085h.007a.666.666 0 10-.667-.666c0 .279.343.558.343.558a.126.126 0 01.033.14l-.775 1.74a.113.113 0 01-.126.06L4.836 5.47a.293.293 0 01-.143-.094S4.486 5.1 4.26 5.1a.515.515 0 10.001 1.03c.24 0 .448-.313.448-.313a.126.126 0 01.136-.046l1.056.358c.047.016.088.07.09.12l.241 5.177c.002.05.018.13.036.176l.977 2.636a6.283 6.283 0 112.885-.324l.392-2.299a.37.37 0 01.077-.156l.896-.97a.13.13 0 01.143-.026s.072.036.163.036a.427.427 0 00-.002-.855z"
  })));
}

function OsloBysykkelIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__OsloBysykkelIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#005FC9",
    d: "M11.816 12.932a3.184 3.184 0 110-6.368 3.184 3.184 0 010 6.368zm0-4.895a1.71 1.71 0 101.711 1.711c0-.944-.766-1.71-1.71-1.71zm-7.632 4.895a3.184 3.184 0 113.183-3.184 3.188 3.188 0 01-3.183 3.184zm0-4.895a1.71 1.71 0 100 3.422 1.71 1.71 0 000-3.422zM6.55 5.733H3.986a.737.737 0 010-1.475h2.565a.737.737 0 010 1.475zm4.485-.794a5.619 5.619 0 01-2.2-.446.737.737 0 11.58-1.356 4.147 4.147 0 001.62.327 4.146 4.146 0 001.64-.334.74.74 0 11.59 1.356 5.631 5.631 0 01-2.23.453z"
  }));
}

function OstfoldIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 74.153 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__OstfoldIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/createElement("path", {
    d: "M24.843 13.663v.554h-1.726v-2.771h.61v2.196l1.116.021z"
  }), /*#__PURE__*/createElement("path", {
    d: "M27.052 13.663v.554h-1.726v-2.771h.61v2.196l1.116.021z"
  }), /*#__PURE__*/createElement("path", {
    d: "M19.502 14.155l-.03.062h-.607l-.738-1.08a2.92 2.92 0 01-.408.087h-.061v.988h-.61v-2.766h.61v1.264c.551-.06.969-.525.97-1.08v-.184h.62v.21c.017.486-.213.947-.611 1.226l.865 1.273z"
  }), /*#__PURE__*/createElement("path", {
    d: "M19.647 12.829a1.471 1.471 0 111.471 1.432 1.419 1.419 0 01-1.47-1.432zm2.32 0a.852.852 0 10-1.704.053.852.852 0 001.703-.053z"
  }), /*#__PURE__*/createElement("path", {
    d: "M28.075 11.986v.623h1.094v.47h-1.094v.593h1.155v.54h-1.756v-2.766h1.756v.54h-1.155z"
  }), /*#__PURE__*/createElement("path", {
    d: "M32.274 14.155l-.03.062h-.607l-.738-1.08c-.133.039-.27.068-.408.087h-.062v.988h-.61v-2.766h.61v1.264c.552-.06.97-.525.971-1.08v-.184h.62v.21c.017.486-.213.947-.611 1.226l.865 1.273z"
  }), /*#__PURE__*/createElement("path", {
    d: "M34.835 11.999h-.879v2.196h-.61v-2.196h-.879v-.553h2.398l-.03.553z"
  }), /*#__PURE__*/createElement("path", {
    d: "M35.278 11.446h.61v2.77h-.61v-2.77z"
  }), /*#__PURE__*/createElement("path", {
    d: "M41.427 11.999h-.878v2.196h-.61v-2.196h-.88v-.553h2.399l-.031.553z"
  }), /*#__PURE__*/createElement("path", {
    d: "M44.159 14.155l-.031.062h-.637l-.825-.927h-.224v.927h-.585v-2.771h1.002c.663 0 1.098.368 1.098.913a.878.878 0 01-.655.878l.857.918zm-1.704-1.317h.351c.365 0 .575-.19.575-.44s-.21-.439-.575-.439h-.351v.879z"
  }), /*#__PURE__*/createElement("path", {
    d: "M46.337 13.681H45.02l-.233.536h-.62l1.274-2.771h.475l1.282 2.77h-.624l-.237-.535zm-.215-.496l-.44-1.006-.438 1.006h.878z"
  }), /*#__PURE__*/createElement("path", {
    d: "M48.116 11.986v.65h1.04v.478h-1.04v1.094h-.62v-2.762h1.757v.54h-1.137z"
  }), /*#__PURE__*/createElement("path", {
    d: "M49.794 11.446h.61v2.77h-.61v-2.77z"
  }), /*#__PURE__*/createElement("path", {
    d: "M53.544 14.155l-.03.062h-.606l-.738-1.08c-.134.039-.27.068-.409.087H51.7v.988h-.61v-2.766h.61v1.264c.551-.06.97-.525.97-1.08v-.184h.62v.21c.017.486-.213.947-.61 1.226l.864 1.273z"
  }), /*#__PURE__*/createElement("path", {
    d: "M56.448 14.155l-.031.062h-.606l-.738-1.08a2.92 2.92 0 01-.409.087H54.6v.988h-.607v-2.766h.607v1.264h.022a1.09 1.09 0 00.966-1.08v-.184h.623v.21c.018.487-.214.949-.614 1.226l.852 1.273z"
  }), /*#__PURE__*/createElement("path", {
    d: "M38.849 11.446v.048l-1.054 2.723h-.466l-1.045-2.723v-.048h.584l.698 2.024.708-2.024h.575z"
  }), /*#__PURE__*/createElement("path", {
    d: "M25.682 4.669a4.418 4.418 0 01-4.564 4.444 4.774 4.774 0 01-2.428-.64l-.8.957-.786-.65.76-.936a4.348 4.348 0 01-1.318-3.193 4.418 4.418 0 014.568-4.44 4.831 4.831 0 012.539.698l.75-.909.796.65-.747.878a4.357 4.357 0 011.23 3.14zm-6.628 1.756l3.448-4.12a2.556 2.556 0 00-1.384-.394 2.635 2.635 0 00-2.635 2.749 2.855 2.855 0 00.571 1.774v-.009zm4.7-1.756a2.864 2.864 0 00-.501-1.656l-3.426 4.084c.39.218.831.328 1.278.321a2.635 2.635 0 002.649-2.75z"
  }), /*#__PURE__*/createElement("path", {
    d: "M44.392 2.042v2.025h3.228v1.51h-3.228v3.387h-1.889V.378h5.486v1.669l-3.597-.005z"
  }), /*#__PURE__*/createElement("path", {
    d: "M74.09 4.669c0 2.565-1.757 4.295-4.308 4.295h-3.62V.378h3.62c2.613 0 4.308 1.757 4.308 4.29zm-1.888 0c0-1.568-.984-2.636-2.456-2.636h-1.655v5.27h1.655c1.498-.008 2.456-1.075 2.456-2.634z"
  }), /*#__PURE__*/createElement("path", {
    d: "M48.898 4.669A4.392 4.392 0 0153.46.229c2.613 0 4.563 1.888 4.563 4.44a4.563 4.563 0 01-9.126 0zm7.203 0a2.635 2.635 0 10-5.27 0 2.635 2.635 0 005.27 0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M64.968 7.247v1.717H59.61V.378h1.888v6.869h3.47z"
  }), /*#__PURE__*/createElement("path", {
    d: "M27.157 8.534l-.307-1.757.04-.022a6.944 6.944 0 002.99.773c1.033 0 1.73-.347 1.73-.936 0-.439-.307-.685-.794-.878l-2.205-.615a2.301 2.301 0 01-1.669-2.284c0-1.642 1.362-2.587 3.351-2.587a6.11 6.11 0 012.675.563v1.708a5.073 5.073 0 00-2.613-.69c-1.129 0-1.524.44-1.524.997 0 .282.1.686.764.905l2.134.641c1.103.317 1.757 1.09 1.757 2.196 0 1.63-1.471 2.579-3.513 2.579a8.156 8.156 0 01-2.816-.593z"
  }), /*#__PURE__*/createElement("path", {
    d: "M41.286 2.095H38.44v6.869h-1.893V2.095h-2.846V.378h7.585v1.717z"
  }), /*#__PURE__*/createElement("path", {
    d: "M.063.378v6.535c0 3.074 2.451 6.887 6.36 9.087 3.904-2.196 6.35-6 6.355-9.087L12.8.378H.063zm6.369 12.736c-1.186 0-2.148-.224-2.148-.303 0-.079.962-.307 2.148-.307s2.143.224 2.143.307c0 .084-.97.303-2.152.303h.009zm0-1.642c-1.823 0-3.294-.33-3.294-.47 0-.14 1.471-.474 3.294-.474s3.294.316 3.294.456-1.485.47-3.303.47l.009.018zm0-1.91c-2.236 0-4.045-.41-4.045-.58 0-.172 1.81-.58 4.045-.58s4.04.408 4.04.58c0 .17-1.818.562-4.05.562l.01.017zm4.172-2.487c-1.39.183-2.792.268-4.194.255a31.504 31.504 0 01-4.2-.255c-.034 0-.056 0-.047-.052a12.082 12.082 0 014.185-5.477.097.097 0 01.119 0 12.082 12.082 0 014.185 5.477c.027.03 0 .048-.048.052z"
  })));
}

function RuterIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 55.9 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__RuterIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M55.5 6.6l.4-1.8H53l.5-2.8h-1.9l-.5 2.7h-2.9l.5-2.7h-1.9l-.5 2.7h-2.9L43 6.6h2.9l-.5 2.7h-2.9l-.4 1.8H45l-.5 2.7h1.9l.5-2.7h2.9l-.5 2.7h1.9l.5-2.7h2.9l.4-1.8h-2.9l.5-2.7h2.9zm-5.3 2.7h-2.9l.5-2.7h2.9l-.5 2.7zM6.3 13.9L4 9.2H2.3v4.7H0V2h4.7c2.4 0 3.9 1.7 3.9 3.6 0 1.7-1 2.7-2.2 3.1L9 13.9H6.3zM4.5 4.1H2.3v3.1h2.2c1 0 1.7-.7 1.7-1.6s-.7-1.5-1.7-1.5zm11.1 9.8v-.8c-.6.6-1.4.9-2.2.9-.9 0-1.6-.3-2.1-.8-.7-.7-.9-1.5-.9-2.5V5.2h2.2v5.3c0 1.2.8 1.6 1.4 1.6.7 0 1.5-.4 1.5-1.6V5.2h2.2v8.7h-2.1zm7.3 0c-1.8 0-2.5-1.3-2.5-2.5V6.8h-.9V5.2h.9V2.9h2.2v2.3h1.5v1.7h-1.5v4.4c0 .5.2.8.8.8h.8v1.8h-1.3zm4.8-3.7c0 1.1.7 1.9 1.9 1.9 1 0 1.4-.3 2-.8l1.3 1.3c-.9.9-1.8 1.4-3.3 1.4-2.1 0-4-.9-4-4.5 0-2.8 1.5-4.4 3.8-4.4 2.4 0 3.8 1.8 3.8 4.2v1l-5.5-.1zm3.1-2.4c-.2-.5-.7-.9-1.5-.9-.7 0-1.2.4-1.5.9-.1.3-.2.6-.2.9H31c0-.3-.1-.6-.2-.9zm9.9-2.4c-.4-.2-.8-.3-1.4-.3-.9 0-1.8.4-2.2.9v-.8H35v8.7h2.2V8.7c0-1.1.7-1.5 1.4-1.6.8-.1 1.2.3 1.2.3l.9-2z"
  }));
}

function SJIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__SJIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M15.77 5.558c-.254 1.729-1.822 1.805-2.872 1.749-.074-.004-.152-.017-.214-.025-.098-.011-.106-.12-.02-.156.212-.09 1.263-.645 1.378-1.82.023-.242.022-.58.022-.645V.125H15.8v4.598c0 .536-.015.737-.03.835zm-1.92 4.833c.072-1.772 1.562-2.993 3.868-2.993h6.198c.085 0 .107.053.059.141-.226.419-.952 1.624-1.852 1.624h-3.608c-1.993 0-3.328 1.06-3.71 2.148-.069.198-.265.67-.549.67-.388 0-.45-.51-.406-1.59zm-3.7 0c.044 1.08-.018 1.59-.406 1.59-.284 0-.48-.472-.549-.67-.382-1.089-1.717-2.148-3.71-2.148H1.877C.978 9.163.251 7.958.025 7.54c-.048-.088-.027-.14.059-.14h6.198c2.306 0 3.797 1.22 3.868 2.992zM12 14.062c1.298 0 2.6-.667 3.146-1.396.676-.903.798-2.543 3.824-2.543h2.671c.086 0 .107.054.059.142-.226.418-1.056 1.754-1.956 1.754H18.5c-.672 0-.828.448-1.15.975C16.4 14.784 14.524 16 12 16c-2.525 0-4.4-1.216-5.351-3.006-.322-.527-.48-.975-1.15-.975H4.257c-.9 0-1.731-1.336-1.957-1.754-.047-.088-.026-.142.06-.142h2.67c3.026 0 3.148 1.64 3.824 2.543.545.729 1.849 1.396 3.146 1.396zM12.62.348v1.106s-.9-.424-1.579-.424c-.678 0-1.19.234-1.19.72 0 .605 1.154.89 1.578 1.033.424.143 1.678.682 1.678 1.776 0 1.16-.654 2.225-2.924 2.225-1.195 0-1.878-.36-1.878-.36V5.328c.395.144 1.282.361 1.74.361.777 0 1.246-.163 1.246-.653 0-.621-1.219-.95-1.69-1.139-.47-.188-1.55-.635-1.55-1.904C8.05.579 9.35 0 10.902 0c1.052 0 1.717.348 1.717.348z",
    clipRule: "evenodd"
  }));
}

function SkyssIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 63 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__SkyssIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M8.4 9.94c.01-1.49-.98-2.23-3.33-2.62-1.04-.17-1.64-.27-1.86-.32-.7-.16-1.01-.44-1.01-.83.01-.29.11-.44.47-.6.36-.15.98-.22 1.85-.22.85 0 1.69.05 2.71.17l.17.02.24-1.59-.18-.02c-1.17-.14-2.43-.2-3.36-.2-2.64 0-4.1.76-4.1 2.41-.01 1.02.57 1.81 1.59 2.17.39.15 1.18.31 2.29.52.78.14 1.07.2 1.34.3.69.25.92.53.92.87-.01.31-.17.53-.58.72-.42.18-1.08.29-1.95.29s-1.74-.05-3.04-.19L.4 10.8l-.03.17-.26 1.47.2.02c1.29.12 2.42.19 3.38.19 3.01 0 4.71-.88 4.71-2.71"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M19.41 12.55l-5.09-4.89 4.99-3.86h-2.9l-4.02 3.06h-.45V0H9.76v12.55h2.18V8.44h.4l4.22 4.11z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M29.73 12.24V3.8h-2.27v7.09c-.59.08-1.27.14-1.74.14-2.63 0-2.91-.79-2.91-2.23v-5h-2.27v5.02c0 3.11 1.85 3.86 4.92 3.86.59 0 1.47-.1 1.98-.23-.01.51-.01 1.1-.38 1.47-.34.34-1.08.4-2.24.4-1.05 0-2.28-.13-3.32-.29l-.27 1.62c1.4.24 2.56.35 3.7.35 3.91 0 4.8-1.13 4.8-3.76"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M39.61 9.94c.02-1.49-.98-2.23-3.33-2.62-1.04-.17-1.64-.27-1.85-.32-.7-.16-1.01-.45-1.01-.83.01-.29.11-.44.47-.6.36-.15.98-.22 1.85-.22.85 0 1.69.05 2.71.17l.17.02.24-1.59-.19-.02c-1.17-.14-2.44-.21-3.37-.21-2.64 0-4.09.77-4.1 2.41-.01 1.02.58 1.81 1.59 2.17.39.15 1.18.31 2.29.52.78.14 1.07.2 1.34.3.69.26.92.53.92.87-.01.31-.17.53-.58.72-.42.18-1.08.29-1.95.29s-1.74-.05-3.04-.19l-.17-.02-.03.17-.26 1.47.2.02c1.29.12 2.41.19 3.38.19 3.02.01 4.72-.87 4.72-2.7"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M49.02 9.94c.01-1.49-.98-2.23-3.33-2.62-1.04-.17-1.63-.27-1.85-.32-.7-.16-1.01-.45-1.01-.83.01-.29.11-.44.47-.6.36-.15.98-.22 1.85-.22.85 0 1.69.05 2.71.17l.17.02.24-1.59-.19-.02c-1.17-.14-2.44-.21-3.37-.21-2.64 0-4.1.77-4.1 2.41-.01 1.02.57 1.81 1.59 2.17.39.15 1.18.31 2.29.52.78.14 1.07.2 1.34.3.69.26.92.53.92.87-.01.31-.17.53-.58.72-.42.18-1.08.29-1.95.29s-1.74-.05-3.04-.19l-.17-.02-.03.17-.26 1.47.2.02c1.29.12 2.41.19 3.38.19 3.02.01 4.72-.87 4.72-2.7"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M53.28 3.8c0 3.84 0 5.28.2 6.09.54 2.14 2.3 3.99 4.38 4.43 2.07-.44 3.89-2.29 4.43-4.43.21-.81.21-2.25.21-6.09h-9.22zm3.09 1.46c.15.09.21.2.3.32 0-.13.09-.23.21-.23s.22.1.22.22-.1.22-.22.22c-.03 0-.06 0-.09-.01l.31.49.67-.22v-.63l-.28.16-.19-.16v-.25l.19-.16.28.16-.12-.35.25-.28.25.28-.13.35.28-.16.18.17v.25l-.19.16-.28-.16v.63l.66.22.3-.49c-.02 0-.05.01-.08.01-.12 0-.22-.1-.22-.22s.1-.22.22-.22.21.11.21.23c.1-.12.16-.23.3-.32.16-.09.49-.09.49-.09l-.78.88-.07.75c-.15-.18-.65-.27-1.14-.27-.37 0-1 .06-1.15.28l-.09-.77-.79-.88s.33-.01.5.09zm2.59 1.65c0 .07-.37.23-1.06.23s-1.06-.16-1.06-.23c0-.06.36-.22 1.06-.22.69 0 1.05.16 1.06.22zm2.45 1.52c-.48.56-1.03.74-1.16.75.33-.4.25-1.06-.15-1.39l-.29-.05-1.65 1.96 2.15 2.56-.31.26-2.1-2.5-2.11 2.51-.31-.26 2.15-2.57-1.65-1.96-.29.05c-.4.33-.48.99-.15 1.39-.12-.01-.68-.19-1.15-.75-.47-.56-.55-1.14-.54-1.27.33.39.99.43 1.39.1l.1-.29-.2-.24.31-.26.2.24.3-.04.45.53-.09.29 1.59 1.9 1.59-1.9-.09-.29.43-.52.3.04.2-.24.31.26-.2.24.1.28c.39.33 1.06.29 1.41-.1.01.13-.07.71-.54 1.27z"
  }));
}

function TierIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__TierIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#69D2AA",
    d: "M1.343 3.505h13.314a.322.322 0 01.342.342v1.126a.322.322 0 01-.342.322H9.006v6.879a.342.342 0 01-.342.322H7.336a.342.342 0 01-.342-.322V5.295H1.343A.322.322 0 011 4.973V3.847a.322.322 0 01.342-.342z"
  }));
}

function TrondheimBysykkelIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__TrondheimBysykkelIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#E02344",
    d: "M11.816 12.932a3.184 3.184 0 110-6.368 3.184 3.184 0 010 6.368zm0-4.895a1.71 1.71 0 101.711 1.711c0-.944-.766-1.71-1.71-1.71zm-7.632 4.895a3.184 3.184 0 113.183-3.184 3.188 3.188 0 01-3.183 3.184zm0-4.895a1.71 1.71 0 100 3.422 1.71 1.71 0 000-3.422zM6.55 5.733H3.986a.737.737 0 010-1.475h2.565a.737.737 0 010 1.475zm4.485-.794a5.619 5.619 0 01-2.2-.446.737.737 0 11.58-1.356 4.147 4.147 0 001.62.327 4.146 4.146 0 001.64-.334.74.74 0 11.59 1.356 5.631 5.631 0 01-2.23.453z"
  }));
}

function VKTIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 41.393 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__VKTIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/createElement("path", {
    d: "M18.577 8.788h.41v1.46l.568-.67h.491l-.65.76.71.996h-.492l-.62-.886h-.007v.886h-.41V8.788z"
  }), /*#__PURE__*/createElement("path", {
    d: "M20.142 10.456c0-.576.27-.92.775-.92.506 0 .775.344.775.92 0 .575-.27.918-.775.918s-.775-.343-.775-.918zm.775.63c.295 0 .34-.302.34-.63 0-.329-.045-.632-.34-.632-.295 0-.34.303-.34.632 0 .328.045.63.34.63z"
  }), /*#__PURE__*/createElement("path", {
    d: "M22.102 8.788h.41v2.546h-.41V8.788z"
  }), /*#__PURE__*/createElement("path", {
    d: "M23.025 8.788h.41v2.546h-.41V8.788z"
  }), /*#__PURE__*/createElement("path", {
    d: "M25.22 11.304c-.147.049-.302.07-.49.07-.569 0-.886-.365-.886-1.01 0-.492.221-.827.753-.827.446 0 .668.284.668.712v.1h-1.041c0 .243.166.738.66.738.13 0 .263-.04.336-.067v.284zm-.343-1.203c0-.11-.055-.302-.31-.302-.24 0-.321.199-.332.302h.642z"
  }), /*#__PURE__*/createElement("path", {
    d: "M25.645 8.788h.41v1.46l.568-.67h.49l-.649.76.709.996h-.491l-.62-.886h-.007v.886h-.41V8.788z"
  }), /*#__PURE__*/createElement("path", {
    d: "M28.516 11.345c-.11.018-.225.03-.336.03-.465 0-.539-.222-.539-.484v-1.03h-.343v-.284h.343V9.16l.41-.247v.664h.52v.285h-.52v.83c0 .21.026.395.277.395.066 0 .129-.015.188-.03v.288z"
  }), /*#__PURE__*/createElement("path", {
    d: "M28.863 8.788h.41v.405h-.41v-.405zm0 .79h.41v1.756h-.41V9.577z"
  }), /*#__PURE__*/createElement("path", {
    d: "M29.52 9.577h.428l.391 1.203h.008l.394-1.203h.429l-.628 1.757h-.398l-.624-1.757z"
  }), /*#__PURE__*/createElement("path", {
    d: "M32.539 11.345a2.08 2.08 0 01-.336.03c-.465 0-.539-.222-.539-.484v-1.03h-.343v-.284h.343V9.16l.41-.247v.664h.52v.285h-.52v.83c0 .21.026.395.277.395.066 0 .129-.015.188-.03v.288z"
  }), /*#__PURE__*/createElement("path", {
    d: "M32.86 9.577h.41v.325h.007c.096-.17.214-.365.568-.365v.428c-.413 0-.576.173-.576.598v.771h-.41V9.577z"
  }), /*#__PURE__*/createElement("path", {
    d: "M35 11.131h-.007c-.055.115-.177.243-.458.243-.295 0-.516-.177-.516-.46 0-.584.738-.587.981-.595v-.173c0-.174-.044-.322-.247-.322-.225 0-.27.152-.27.27h-.398c0-.336.222-.557.668-.557.436 0 .639.188.639.546v1.251H35v-.203zm-.365-.044c.266 0 .365-.288.365-.528-.265 0-.583.081-.583.317 0 .137.078.21.218.21z"
  }), /*#__PURE__*/createElement("path", {
    d: "M36.015 9.862h-.32v-.285h.32v-.24c0-.372.225-.59.68-.59.129 0 .291.015.383.037v.313a.831.831 0 00-.299-.062c-.299 0-.354.217-.354.42v.122h.517v.285h-.517v1.472h-.41V9.862zm1.174-1.074h.41v.405h-.41v-.405zm0 .79h.41v1.756h-.41V9.577z"
  }), /*#__PURE__*/createElement("path", {
    d: "M38.1 8.788h.41v1.46l.569-.67h.49l-.65.76.71.996h-.492l-.62-.886h-.007v.886h-.41V8.788z"
  }), /*#__PURE__*/createElement("path", {
    d: "M39.865 8.788h.41v1.46l.568-.67h.49l-.649.76.709.996h-.491l-.62-.886h-.008v.886h-.41V8.788z"
  })), /*#__PURE__*/createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/createElement("path", {
    d: "M13.116 0H2.674S0 0 0 2.674v5.984L15.446 1.32C15.11.658 14.442 0 13.116 0z"
  }), /*#__PURE__*/createElement("path", {
    d: "M15.544 1.539c-.932.613-2.1 1.437-3.251 2.404-2.515 2.113-1.84 3.51.402 4.326 1.13.41 2.259.737 3.094.959V2.674s-.002-.54-.245-1.135z"
  }), /*#__PURE__*/createElement("path", {
    d: "M0 13.326S0 16 2.674 16h10.442s2.673 0 2.673-2.674v-3.77H0v3.77z"
  })), /*#__PURE__*/createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/createElement("path", {
    d: "M18.246 5.67h.264l.507 1.362h.007l.442-1.362h.264l-.583 1.724h-.25l-.651-1.724z"
  }), /*#__PURE__*/createElement("path", {
    d: "M21.167 7.383c-.105.032-.235.05-.394.05-.533 0-.84-.322-.84-.96 0-.514.213-.843.673-.843.406 0 .601.279.601.656v.083h-.992v.101c0 .26.116.757.612.757.192 0 .26-.029.34-.047v.203zm-.242-1.22c0-.116-.08-.327-.33-.327-.257 0-.34.21-.362.326h.692z"
  }), /*#__PURE__*/createElement("path", {
    d: "M22.21 6.42c.18.094.401.195.401.492 0 .344-.239.521-.64.521-.225 0-.403-.05-.471-.072v-.224c.043.014.25.09.445.09.239 0 .42-.08.42-.279 0-.177-.21-.253-.311-.311l-.156-.084c-.16-.09-.391-.184-.391-.467 0-.279.206-.456.59-.456.185 0 .326.04.406.058v.228a1.233 1.233 0 00-.402-.08c-.21 0-.348.102-.348.225 0 .141.174.2.312.272l.144.086z"
  }), /*#__PURE__*/createElement("path", {
    d: "M23.81 7.415c-.073.011-.145.018-.218.018-.347 0-.478-.137-.478-.445V5.876h-.282V5.67h.282v-.402l.246-.156v.558h.464v.206h-.464v1.061c0 .113.03.29.283.29.08 0 .112-.014.166-.033v.221z"
  }), /*#__PURE__*/createElement("path", {
    d: "M24.301 5.876h-.29V5.67h.29v-.24c0-.282.134-.546.565-.546.123 0 .214.014.294.033v.22a.747.747 0 00-.25-.047c-.286 0-.362.16-.362.392v.188h.496v.206h-.496v1.518H24.3V5.876z"
  }), /*#__PURE__*/createElement("path", {
    d: "M25.217 6.535c0-.503.196-.905.702-.905.511 0 .71.402.71.905 0 .504-.199.898-.71.898-.506 0-.702-.394-.702-.898zm.702.692c.283 0 .428-.26.428-.695 0-.431-.145-.696-.428-.696-.278 0-.42.265-.42.696 0 .434.142.695.42.695z"
  }), /*#__PURE__*/createElement("path", {
    d: "M27.103 4.895h.246v2.499h-.246v-2.5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M28.873 7.1h-.007a.468.468 0 01-.449.333c-.416 0-.59-.34-.59-.887 0-.463.163-.916.586-.916.301 0 .41.2.453.322h.007V4.895h.247v2.499h-.247V7.1zm-.405.127c.282 0 .405-.391.405-.688 0-.384-.137-.703-.398-.703-.293 0-.366.392-.366.757 0 .221.033.634.359.634z"
  })));
}

function VoiIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__VoiIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#F46C63",
    d: "M11.702 3.24l-3.957 9.377H4.94L.999 3.24h2.807l2.6 6.38 2.681-6.38h2.615zm1.606 9.516a1.633 1.633 0 01-1.202-.487 1.653 1.653 0 01-.489-1.22c0-.5.163-.904.489-1.212a1.796 1.796 0 012.405 0c.326.31.488.713.488 1.211.012.457-.164.898-.489 1.22a1.633 1.633 0 01-1.202.488z"
  }));
}

function VyIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 31.6 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__VyIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M23.728 10c.1 0 .1 0 0 0 .1-.1.1-.1 0 0-.2-.1-.5-.1-.7-.3-.5-.3-.8-.9-1.101-1.8 0-.1-1.6-5.4-1.7-5.8-.4-1.2-1-1.7-1.6-2-.3 0-.6-.1-.9-.1h-.4c.2 0 .4.1.5.1.6.2 1.2.8 1.5 1.9.1.3 1.6 5.6 1.7 5.7.3 1 .7 1.6 1.2 1.9.3.2.6.3 1 .3l.5.1z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M25.127 10c0-.1 0-.1 0 0-.7-.1-1.1-1.1-1.4-1.9-.3-.9-1.2-4.1-1.8-5.9-.5-1.9-2.3-2.2-3.1-2.2.7.1 1.8.5 2.3 2.1.4 1.5 1.7 5.8 1.7 5.9.3.9.7 1.4 1.1 1.7.3.1.7.2 1.2.3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M6.927 16h-.2c-.6 0-1.4-.3-1.8-1.8l-3.8-12.8C.927.6.627.2.127.1h.6c.7 0 1.1.4 1.4 1.3 0 0 3.5 11.8 3.8 12.9.2.8.5 1.4.9 1.6l.1.1s.1 0 0 0c.1 0 0 0 0 0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M5.727 1.9c-.4-1.3-1-1.8-2-1.8h-.5c.8.1 1.3.7 1.6 1.8 0 0 3.1 10.6 3.5 11.9.1-.3.2-.8.4-1.5-.3-1.2-3-10.4-3-10.4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M7.227 16h.4c.5 0 .8-.1 1-.3.4-.3.6-.9.8-1.5 0-.1 3.3-11.2 3.5-11.7.4-1.5 1.3-2.1 2.2-2.4.2 0 .3-.1.5-.1h-.4c-1.2 0-2.6.5-3.1 2.5-.2.7-3.4 11.6-3.5 11.7-.2.6-.4 1.2-.8 1.5-.2.2-.4.2-.6.3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M24.127 8.3l1.9-6.5c.4-1.1.9-1.7 1.7-1.8h-.5c-1 0-1.6.5-2 1.8l-1.5 5.2c0-.1.4 1.2.4 1.3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M29.327.1h-.5c-.9 0-1.4.4-1.7 1.5 0 0-1.9 6.4-1.9 6.5-.1.5-.3.9-.5 1.2.2.2.3.4.5.4.3-.4.6-.9.9-1.7l1.9-6.5c.2-.8.6-1.3 1.3-1.4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M25.327 10.3h-.9c-.4 1.3-.9 3-1.1 3.7-.5 1.8.3 2 .6 2h.7c-.4-.1-.9-.5-.4-2 0 0 .8-2.7 1.1-3.7z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M30.427.1c-.9 0-1.3.4-1.5 1.3 0 0-1.5 5-2 6.6-.5 1.6-.8 2-1.4 2.1h.4c1.1 0 1.5-.7 1.9-2 .3-1.1 2.2-7.5 2.2-7.5.1-.2.2-.4.4-.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M26.228 10.3l-1.2 4c-.5 1.5.3 1.7.5 1.7h.7c-.301-.1-.7-.4-.4-1.7 0 0 1-3.2 1.3-4.5-.1.2-.4.4-.9.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M27.827 16c.1 0 .1 0 0 0 .1 0 .1 0 0 0-.3-.1-.6-.4-.3-1.4 0 0 3.7-12.5 3.9-13.2.2-.7-.3-1.2-.7-1.2.1 0 .2.2.1.3l-4.2 14.1c-.3 1.2.3 1.4.6 1.4h.6z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M22.027 10c0-.1 0-.1 0 0-.2-.1-.5-.1-.7-.3-.5-.3-.9-.9-1.2-1.9 0-.1-1.6-5.4-1.7-5.6-.3-1.1-.9-1.7-1.4-1.9-.2-.2-.5-.3-.8-.3h-.4c.1 0 1.3.1 1.9 2.1.6 2 1.3 4.5 1.6 5.4.5 1.9 1.2 2.5 2.3 2.5h.4z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M16.427.8c-.4.4-.8.9-1 1.8 0 .1-3.3 11.2-3.4 11.4-.3.9-.5 1.9-1.6 2h.4c1.1 0 1.6-.5 2-2 .3-1.1 3.3-11.3 3.4-11.4.1-.4.3-.9.5-1.3 0-.2-.1-.4-.3-.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M16.027.5c-.3-.1-.8-.1-1.2.3-.4.3-.8.9-1 1.7 0 .1-3.5 11.7-3.5 11.7-.2.6-.4 1.1-.8 1.5-.2.2-.5.3-.7.3h.5c.5 0 .8-.1 1-.3.4-.3.6-.9.8-1.5 0-.1 3.4-11.6 3.5-11.7.2-.8.6-1.4 1-1.8.2 0 .3-.1.4-.2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M7.927 15c-.2-.2-.3-.5-.4-.8-.1-.5-3.7-12.6-3.7-12.6-.3-1-.8-1.5-1.6-1.5h-.6c.7.1 1.1.6 1.4 1.5l3.7 12.6c.2.7.5 1.1.7 1.4.2-.1.4-.3.5-.6z"
  }));
}

function ZvippIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__ZvippIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("path", {
    id: "a",
    d: "M14.783 5.275l-2.709-2.364H4.023L1 5.511l6.755 7.673z"
  })), /*#__PURE__*/createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/createElement("use", {
    overflow: "visible",
    xlinkHref: "#a"
  })), /*#__PURE__*/createElement("g", {
    fill: "#FFD600",
    clipPath: "url(#b)"
  }, /*#__PURE__*/createElement("path", {
    d: "M4.132 5.149l4.611 7.555.471-.457-4.315-6.601z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.731 7.448L8.229 2.542l-2.31.004 2.536 3.097h-.432L5.476 2.54l-.746.004.524 3.099 4.165 6.337 1.142-1.623z"
  })), /*#__PURE__*/createElement("g", {
    fill: "#009D48"
  }, /*#__PURE__*/createElement("path", {
    d: "M4.601 5.646h.298l.355-.003h2.457L5.192 2.58H3.963L1 5.511l6.972 7.909.989-1.113z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.232 7.448H8.59l1.987 3.041L15 5.511 12.014 2.58H8.26z"
  })));
}

function BanknoteIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 2.5H1.636c-.351 0-.636.298-.636.665v9.67c0 .367.285.665.636.665h12.728c.351 0 .636-.298.636-.665v-9.67c0-.367-.285-.665-.636-.665zm-.637 1.33v8.34H2.273V3.83h11.454zM8 6.4a1.61 1.61 0 101.612 1.61C9.612 7.12 8.89 6.4 8 6.4zm0 .908a.702.702 0 11.001 1.404A.702.702 0 018 7.308zm2.893-2.805H5.107a.465.465 0 00-.454.475c0 .74-.574 1.338-1.281 1.338a.465.465 0 00-.455.475V9.21c0 .262.204.475.455.475.707 0 1.28.599 1.28 1.338 0 .262.204.475.455.475h5.786a.465.465 0 00.454-.475c0-.74.574-1.338 1.281-1.338a.465.465 0 00.455-.475V6.79a.465.465 0 00-.455-.475c-.707 0-1.28-.599-1.28-1.338a.465.465 0 00-.455-.475zm-.408.95l.025.11c.2.794.799 1.418 1.558 1.628l.105.025v1.568l-.105.025c-.76.21-1.357.834-1.558 1.628l-.025.11H5.514l-.024-.11c-.2-.794-.799-1.418-1.558-1.628l-.106-.025V7.216l.106-.025c.76-.21 1.357-.834 1.558-1.628l.024-.11h4.971z",
    clipRule: "evenodd"
  }));
}

function BanknoteMultiIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.207 2c.322 0 .588.234.63.538l.006.085-.001 1.075h.522c.32 0 .584.23.63.53l.006.093v9.056a.63.63 0 01-.636.623H1.636A.63.63 0 011 13.377V4.321a.63.63 0 01.636-.623h.521V2.623c0-.316.24-.576.55-.617L2.793 2h10.414zm.52 2.943H2.273v7.81h11.454v-7.81zm-2.834.631c.25 0 .454.2.454.445 0 .692.574 1.253 1.281 1.253.251 0 .455.2.455.445v2.264a.45.45 0 01-.455.445c-.707 0-1.28.56-1.28 1.253a.45.45 0 01-.455.445H5.107a.45.45 0 01-.454-.445c0-.692-.574-1.253-1.281-1.253a.45.45 0 01-.455-.445V7.717a.45.45 0 01.455-.445c.707 0 1.28-.56 1.28-1.253a.45.45 0 01.455-.445h5.786zm-.408.89H5.514l-.024.103A2.17 2.17 0 013.932 8.09l-.106.023v1.469l.106.024a2.17 2.17 0 011.558 1.524l.024.103h4.971l.025-.103a2.17 2.17 0 011.558-1.524l.105-.024V8.114l-.105-.023a2.17 2.17 0 01-1.558-1.524l-.025-.104zM8 7.23a1.61 1.61 0 11-1.612 1.61c0-.89.722-1.61 1.612-1.61zm0 .908a.702.702 0 10-.001 1.404A.702.702 0 008 8.138zm4.57-4.893H3.43l-.001.453h9.141v-.453z",
    clipRule: "evenodd"
  }));
}

function DepositionIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.477 5.529v1.286h-1.21l1.061 1.657c.379.635.615 1.348.663 2.054l.009.265C15 13.134 13.145 15 10.817 15H5.183C2.855 15 1 13.134 1 10.79c0-.867.23-1.685.688-2.344l1.08-1.631H1.581V5.53h12.896zm-2.729 1.286H4.302L2.743 9.172a2.654 2.654 0 00-.438 1.189l-.021.226-.006.204c0 1.632 1.282 2.923 2.905 2.923h5.634c1.623 0 2.905-1.29 2.905-2.923 0-.546-.178-1.134-.479-1.64l-1.495-2.336zM5.5 1a1.5 1.5 0 11.001 2.999A1.5 1.5 0 015.5 1zm5 0a1.5 1.5 0 11.001 2.999A1.5 1.5 0 0110.5 1z",
    clipRule: "evenodd"
  }));
}

function DiffIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.103 8.885l1.012 1.012-2.045 2.045 2.045 2.046L6.103 15l-2.046-2.045L2.012 15 1 13.988l2.045-2.046L1 9.897l1.012-1.012 2.045 2.044 2.046-2.044zM15 12.249v1.432H9.478v-1.432H15zm0-3.068v1.432H9.478V9.18H15zM4.774 1l-.001 2.045h2.046v1.432H4.773v2.045H3.343L3.34 4.477H1.297V3.045H3.34V1h1.433zM15 3.045v1.432H9.478V3.045H15z",
    clipRule: "evenodd"
  }));
}

function EuroIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 100 14A7 7 0 008 1zm0 1.273a5.727 5.727 0 110 11.454A5.727 5.727 0 018 2.273zm.579 2.198c.68 0 1.373.214 1.935.579l.182.127.509.382-.764 1.018-.509-.382a2.338 2.338 0 00-1.353-.451c-.735 0-1.376.331-1.785.857L9 6.6v1H6.356a2.373 2.373 0 00-.01.736H9v1H6.747c.406.562 1.068.92 1.832.92a2.35 2.35 0 001.208-.352l.145-.099.51-.382.763 1.018-.51.382a3.61 3.61 0 01-2.116.706 3.498 3.498 0 01-3.274-2.193H4.3v-1h.765A3.69 3.69 0 015.07 7.6H4.3v-1h1.03A3.498 3.498 0 018.58 4.471z",
    clipRule: "evenodd"
  }));
}

function MastercardIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__MastercardIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FF5F00",
    d: "M6.107 4.599h3.786v6.803H6.107z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#EB001B",
    d: "M6.347 8A4.32 4.32 0 018 4.6a4.326 4.326 0 100 6.803A4.32 4.32 0 016.347 8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#F79E1B",
    d: "M15 8a4.326 4.326 0 01-7 3.402 4.326 4.326 0 000-6.803 4.326 4.326 0 017 3.4v.002z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#F79E1B",
    d: "M14.587 10.68v-.139h.056v-.029H14.5v.03h.061v.139h.026zm.277 0v-.168h-.043l-.05.12-.051-.12h-.038v.169h.03v-.127l.048.11h.032l.047-.11v.128l.025-.001z"
  }));
}

function MoneyIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.972 1c1.776 0 3.292.758 3.292 1.943 0 .387-.162.729-.442 1.013.28.284.442.625.442 1.01l-.007.127c.246-.031.5-.048.76-.048 1.776 0 3.292.758 3.292 1.944 0 .387-.162.729-.442 1.013.28.284.442.625.442 1.01 0 .387-.162.729-.442 1.013.28.284.442.625.442 1.009 0 .387-.162.729-.442 1.013.28.285.442.625.442 1.01 0 1.185-1.516 1.943-3.292 1.943s-3.292-.758-3.292-1.943l.007-.128a5.888 5.888 0 01-.76.049c-1.776 0-3.292-.759-3.292-1.944 0-.384.162-.725.442-1.01-.28-.284-.442-.625-.442-1.012 0-.385.162-.725.443-1.01-.281-.284-.443-.626-.443-1.013 0-.385.162-.726.443-1.01-.28-.284-.443-.626-.443-1.013 0-.385.162-.726.443-1.01-.281-.284-.443-.626-.443-1.013C2.68 1.758 4.196 1 5.972 1zm5.803 11.698l-.06.02c-.5.168-1.083.26-1.698.26a5.35 5.35 0 01-1.758-.28c-.235.137-.344.273-.344.359 0 .304.899.753 2.102.753s2.102-.449 2.102-.753c0-.086-.109-.222-.344-.36zm-7.561-2.022c-.235.136-.344.272-.344.358 0 .304.899.754 2.102.754.328 0 .643-.033.928-.093a1.332 1.332 0 01-.175-.661l.007-.128a5.885 5.885 0 01-.76.049c-.64 0-1.245-.098-1.758-.28zm7.561 0l-.059.02c-.5.168-1.084.259-1.699.259a5.351 5.351 0 01-1.757-.28c-.236.137-.345.273-.345.359 0 .112.123.245.338.367a.202.202 0 01.038.018l-.038-.018c.04.022.083.045.13.067.06.014.117.037.168.07.371.144.883.25 1.466.25.58 0 1.089-.105 1.46-.247a.55.55 0 01.18-.077c.293-.138.462-.298.462-.43 0-.086-.108-.222-.344-.359zm0-2.024l-.059.021c-.5.168-1.084.259-1.699.259a5.35 5.35 0 01-1.758-.28c-.235.137-.344.273-.344.36 0 .095.09.206.25.312a.59.59 0 01.237.129l.011.006c.043.011.083.029.12.051.374.146.893.255 1.484.255 1.204 0 2.103-.45 2.103-.754 0-.086-.11-.222-.345-.359zm-7.561 0c-.236.138-.344.274-.344.36 0 .128.161.284.439.42.088.014.17.048.241.099.367.137.861.234 1.422.234.328 0 .644-.033.929-.093a1.327 1.327 0 01-.175-.66l.007-.129a5.885 5.885 0 01-.761.05c-.64 0-1.245-.1-1.758-.28zm0-2.022c-.235.136-.344.272-.344.359 0 .141.194.314.522.458l.009.003c.376.165.93.293 1.57.293.33 0 .645-.034.93-.094a1.326 1.326 0 01-.175-.66l.007-.128c-.245.032-.5.048-.761.048a5.351 5.351 0 01-1.757-.279zm5.803-.395c-1.203 0-2.102.45-2.102.754 0 .1.1.218.276.33.046.013.09.034.131.061l.043.034.022.01a.56.56 0 01.157.066c.372.146.886.252 1.473.252.563 0 1.059-.098 1.428-.233a.558.558 0 01.232-.1c.28-.136.443-.291.443-.42 0-.305-.9-.754-2.103-.754zM7.73 4.607l-.06.02c-.5.169-1.083.26-1.698.26a5.35 5.35 0 01-1.758-.28c-.235.136-.344.272-.344.359 0 .129.162.284.44.42a.576.576 0 01.24.099c.366.137.86.234 1.422.234 1.203 0 2.102-.449 2.102-.753 0-.086-.109-.222-.344-.359zM5.972 2.19c-1.203 0-2.102.449-2.102.753 0 .13.161.284.439.42a.57.57 0 01.243.1c.366.137.86.234 1.42.234.586 0 1.1-.107 1.473-.251a.532.532 0 01.153-.068c.3-.137.476-.3.476-.435 0-.304-.899-.753-2.102-.753z",
    clipRule: "evenodd"
  }));
}

function PriceFromIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M9.037 1.018l2.147.548c.07.017.135.049.193.091a.524.524 0 01.2.556l-.575 2.043a.56.56 0 01-.68.374.526.526 0 01-.394-.648l.228-.81-3.602 1.98-2.038 1.112-.388.227a.581.581 0 01-.422.053.552.552 0 01-.337-.246.514.514 0 01.204-.723L6.48 3.971 9.6 2.257l-.852-.218a.527.527 0 01-.393-.647.56.56 0 01.68-.374zM5.778 13.943c1.104 0 2.058-.269 2.746-.721.012.063.032.126.032.192C8.556 14.318 7.36 15 5.778 15 4.194 15 3 14.318 3 13.414c0-.066.02-.129.032-.192.688.452 1.642.72 2.746.72zM3 11.299c0-.904 1.194-1.586 2.778-1.586s2.778.682 2.778 1.586-1.194 1.586-2.778 1.586S3 12.203 3 11.299zm7.222-.53c1.104 0 2.059-.267 2.746-.72.013.064.032.126.032.192 0 .905-1.194 1.587-2.778 1.587a5.19 5.19 0 01-.62-.039c.04-.16.065-.323.065-.49 0-.198-.032-.387-.085-.568.208.02.419.039.64.039zM7.445 8.127c0-.904 1.193-1.586 2.777-1.586S13 7.222 13 8.126s-1.194 1.587-2.778 1.587-2.777-.682-2.777-1.587zm2.777 4.76c1.104 0 2.059-.269 2.746-.722.013.064.032.126.032.192 0 .904-1.194 1.587-2.778 1.587a5.19 5.19 0 01-.62-.04c.04-.16.065-.321.065-.49 0-.194-.03-.383-.083-.567.207.02.417.039.638.039z"
  }));
}

function PricelistIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.92 12.113c-.41.046-.705.358-.705.756v1.495a.636.636 0 01-.636.636H1.636A.636.636 0 011 14.364v-1.736c0-.99.803-1.793 1.793-1.793l1.678-.001V1.636c0-.322.24-.588.55-.63L5.107 1h9.257c.322 0 .588.24.63.55l.006.086v11.281a2.082 2.082 0 11-4.165 0c0-.455-.292-.76-.705-.804l-.105-.006-.105.006zm2.187.804a.81.81 0 001.614.102l.006-.102V2.273H5.744l-.001 8.561h4.282c1.149 0 2.082.863 2.082 2.083zm-4.018-.81H2.793a.52.52 0 00-.52.521v1.1h5.669v-.859c0-.239.04-.467.115-.678l.032-.084zm4.018-7.636v1.273H7.364V4.47h4.743zm0 2.893v1.272H7.364V7.364h4.743z",
    clipRule: "evenodd"
  }));
}

function ReferenceIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.697 1c.169 0 .33.067.45.186l6.667 6.667a.636.636 0 010 .9l-6.061 6.06a.636.636 0 01-.9 0L1.186 8.148A.636.636 0 011 7.697V3.455c0-.17.067-.331.186-.45l1.819-1.819A.636.636 0 013.455 1h4.242zm-.263 1.273H3.716L2.273 3.716v3.718l6.03 6.03 5.16-5.161-6.03-6.03zM5.1 4a1.1 1.1 0 11.001 2.199A1.1 1.1 0 015.1 4z",
    clipRule: "evenodd"
  }));
}

function ShoppingCartIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.3 12a1.499 1.499 0 100 2.997A1.499 1.499 0 105.3 12zm7 0a1.499 1.499 0 100 2.997 1.499 1.499 0 100-2.997zM3.455 1c.285 0 .532.19.61.457l.02.091.327 2.344h9.951c.373 0 .66.317.636.677l-.013.09-1.212 5.785a.636.636 0 01-.524.499l-.099.007H4.667a.636.636 0 01-.61-.456l-.02-.092L2.9 2.272H1V1h2.455zm10.124 4.164h-8.99l.63 4.513h7.414l.946-4.513z",
    clipRule: "evenodd"
  }));
}

function StatsIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.28 2.5H6.72a.61.61 0 00-.598.621v9.758a.61.61 0 00.598.621h2.56a.61.61 0 00.598-.621V3.121A.61.61 0 009.28 2.5zm-.597 1.242v8.516H7.317V3.742h1.366zM4.159 8.71H1.598A.61.61 0 001 9.33v3.549a.61.61 0 00.598.621h2.56a.61.61 0 00.598-.621V9.331a.61.61 0 00-.597-.621zM3.56 9.952v2.306H2.195V9.952h1.366zm10.841-4.79h-2.56a.61.61 0 00-.598.62v7.097a.61.61 0 00.597.621h2.561a.61.61 0 00.598-.621V5.782a.61.61 0 00-.598-.62zm-.597 1.241v5.855h-1.366V6.403h1.366z",
    clipRule: "evenodd"
  }));
}

function VippsIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__VippsIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FF5B24",
    d: "M2.02 3.333h11.96c.563 0 1.02.457 1.02 1.021v7.292a1.02 1.02 0 01-1.02 1.02H2.02A1.02 1.02 0 011 11.647V4.354c0-.564.457-1.02 1.02-1.02z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FF5B24",
    d: "M5.813 3.917h4.375a3.938 3.938 0 010 7.875H5.811a3.937 3.937 0 110-7.875z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M9.127 6.91a.733.733 0 00.746-.743.733.733 0 00-.746-.743.733.733 0 00-.746.743c0 .438.344.743.746.743zm.975 1.2c-.497.648-1.023 1.096-1.95 1.096-.947 0-1.683-.571-2.257-1.41-.23-.343-.583-.42-.841-.238-.239.171-.296.534-.076.848.793 1.21 1.892 1.915 3.174 1.915 1.176 0 2.094-.571 2.81-1.524.268-.353.259-.715 0-.915-.238-.19-.592-.124-.86.229z",
    clipRule: "evenodd"
  }));
}

function VippsLogoIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 119.4 30.4",
    xmlSpace: "preserve",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__VippsLogoIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FF5B24",
    d: "M6 .6l5.1 14.9 5-14.9H22l-8.8 22.1H8.8L0 .6h6z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FF5B24",
    d: "M35.3 19.2c3.7 0 5.8-1.8 7.8-4.4 1.1-1.4 2.5-1.7 3.5-.9s1.1 2.3 0 3.7c-2.9 3.8-6.6 6.1-11.3 6.1-5.1 0-9.6-2.8-12.7-7.7-.9-1.3-.7-2.7.3-3.4s2.5-.4 3.4 1c2.2 3.3 5.2 5.6 9 5.6zm6.9-12.3c0 1.8-1.4 3-3 3s-3-1.2-3-3 1.4-3 3-3 3 1.3 3 3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FF5B24",
    d: "M56.3.6v3C57.8 1.5 60.1 0 63.5 0c4.3 0 9.3 3.6 9.3 11.3 0 8.1-4.8 12-9.8 12-2.6 0-5-1-6.8-3.5v10.6h-5.4V.6h5.5zm0 11c0 4.5 2.6 6.9 5.5 6.9 2.8 0 5.6-2.2 5.6-6.9 0-4.6-2.8-6.8-5.6-6.8s-5.5 2.1-5.5 6.8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FF5B24",
    d: "M82.3.6v3C83.8 1.5 86.1 0 89.5 0c4.3 0 9.3 3.6 9.3 11.3 0 8.1-4.8 12-9.8 12-2.6 0-5-1-6.8-3.5v10.6h-5.4V.6h5.5zm0 11c0 4.5 2.6 6.9 5.5 6.9 2.8 0 5.6-2.2 5.6-6.9 0-4.6-2.8-6.8-5.6-6.8-2.9 0-5.5 2.1-5.5 6.8z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#FF5B24",
    d: "M110.3 0c4.5 0 7.7 2.1 9.1 7.3l-4.9.8c-.1-2.6-1.7-3.5-4.1-3.5-1.8 0-3.2.8-3.2 2.1 0 1 .7 2 2.8 2.4l3.7.7c3.6.7 5.6 3.1 5.6 6.3 0 4.8-4.3 7.2-8.4 7.2-4.3 0-9.1-2.2-9.8-7.6l4.9-.8c.3 2.8 2 3.8 4.8 3.8 2.1 0 3.5-.8 3.5-2.1 0-1.2-.7-2.1-3-2.5l-3.4-.6c-3.6-.7-5.8-3.2-5.8-6.4.1-5 4.6-7.1 8.2-7.1z"
  }));
}

function VisaIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon__VisaIcon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#FFF",
    d: "M1 3.553h14v8.893H1z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#F7B600",
    d: "M1.233 11.002h13.533v1.213H1.233z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#1A1F71",
    d: "M1.233 3.787h13.533V5H1.233z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#1A1F71",
    d: "M6.65 6.337L5.252 9.672H4.34L3.652 7.01c-.041-.163-.078-.224-.205-.293-.207-.113-.55-.218-.85-.283l.02-.097h1.468c.187 0 .355.124.398.34l.363 1.93.898-2.27h.906zm3.574 2.246c.004-.88-1.217-.929-1.209-1.322.003-.12.117-.247.366-.28.124-.015.464-.028.85.15l.152-.708a2.326 2.326 0 00-.807-.147c-.853 0-1.453.453-1.458 1.102-.005.48.429.748.755.908.337.163.45.268.448.414-.002.224-.269.323-.516.327-.434.007-.686-.117-.886-.211l-.157.731c.202.093.574.173.96.177.906 0 1.499-.448 1.502-1.141m2.252 1.089h.798l-.697-3.335h-.736a.393.393 0 00-.368.244l-1.294 3.09h.906l.18-.497h1.107l.104.498zm-.963-1.182l.454-1.252.262 1.252h-.716zm-3.63-2.153L7.17 9.672h-.863l.713-3.335h.863z"
  }));
}

function FacebookIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M6.418 15L6.4 8.875H4V6.25h2.4V4.5C6.4 2.138 7.738 1 9.664 1c.922 0 1.715.075 1.946.108v2.469h-1.336c-1.048 0-1.25.545-1.25 1.344V6.25H12l-.8 2.625H9.024V15H6.418z"
  }));
}

function GithubIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"
  }));
}

function GoogleIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M7.9 7v2.4H12c-.2 1-1.2 3-4 3-2.4 0-4.3-2-4.3-4.4s2-4.4 4.3-4.4c1.4 0 2.3.6 2.8 1.1l1.9-1.8C11.5 1.7 9.9 1 8 1 4.1 1 1 4.1 1 8s3.1 7 7 7c4 0 6.7-2.8 6.7-6.8 0-.5 0-.8-.1-1.2H7.9z"
  }));
}

function InstagramIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M4.5 2.75c-.818 0-1.75.932-1.75 1.75v7c0 .834.916 1.75 1.75 1.75h7c.818 0 1.75-.932 1.75-1.75v-7c0-.818-.932-1.75-1.75-1.75h-7zm7 12.25h-7C2.701 15 1 13.299 1 11.5v-7C1 2.701 2.701 1 4.5 1h7C13.299 1 15 2.701 15 4.5v7c0 1.799-1.701 3.5-3.5 3.5zM8 6.25c-.965 0-1.75.785-1.75 1.75S7.035 9.75 8 9.75 9.75 8.965 9.75 8 8.965 6.25 8 6.25m0 5.25c-1.93 0-3.5-1.57-3.5-3.5S6.07 4.5 8 4.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zm3.627-7.935a.84.84 0 110 1.68.84.84 0 010-1.68z"
  }));
}

function LinkedinIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 11.924h-1.946v-2.81c0-.684 0-1.52-.973-1.52s-1.135.76-1.135 1.52V12H6V6.152h1.865v.76C8.108 6.455 8.757 6 9.649 6c1.946 0 2.27 1.215 2.27 2.734v3.19H12zM3 4c-.571 0-1-.5-1-1 0-.571.429-1 1-1s1 .429 1 1c-.071.5-.5 1-1 1zm.917 8H2V6h2v6h-.083zm9.387-12H.61A.596.596 0 000 .613v12.862c0 .263.26.525.609.525H13.39a.596.596 0 00.609-.613V.613C13.913.263 13.652 0 13.304 0z",
    clipRule: "evenodd"
  }));
}

function SkypeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M8 12.025c-2.362 0-3.413-1.138-3.413-2.013 0-.437.35-.787.788-.787.963 0 .787 1.4 2.625 1.4.963 0 1.488-.525 1.488-1.05 0-1.05-1.225-.875-2.888-1.313-1.662-.437-1.925-1.312-1.925-2.187 0-1.75 1.663-2.45 3.238-2.45 1.487 0 3.15.787 3.15 1.837 0 .438-.438.7-.876.7-.874 0-.7-1.225-2.45-1.225-.875 0-1.312.35-1.312.963 0 .787 1.575.962 2.8 1.225 1.663.437 2.1 1.4 2.1 2.275.088 1.575-1.05 2.625-3.325 2.625m6.475-2.888c.087-.35.525-3.325-1.837-5.862-2.188-2.363-5.6-1.925-5.95-1.838C6.161 1.175 5.55 1 4.937 1 1.874 1 1 3.887 1 4.937s.525 1.925.525 1.925c-.35 1.4.087 2.888.35 3.675.787 2.013 2.712 3.15 3.5 3.5 1.925.788 3.5.438 3.763.438.612.35 1.224.525 1.924.525 1.05 0 3.938-.875 3.938-3.938 0-1.05-.525-1.925-.525-1.925"
  }));
}

function TwitterIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M15 4.27c-.525.253-1.05.338-1.663.422.613-.338 1.05-.846 1.226-1.523-.526.339-1.138.508-1.838.677a3.109 3.109 0 00-2.1-.846c-1.488 0-2.8 1.27-2.8 2.792 0 .254 0 .423.087.593C5.55 6.3 3.363 5.2 1.963 3.508c-.262.423-.35.846-.35 1.438 0 .93.526 1.777 1.313 2.285-.437 0-.875-.17-1.312-.339 0 1.354.962 2.454 2.275 2.708-.263.085-.526.085-.788.085-.175 0-.35 0-.525-.085.35 1.1 1.4 1.946 2.712 1.946-.962.762-2.187 1.185-3.587 1.185H1C2.313 13.492 3.8 14 5.375 14c5.25 0 8.137-4.23 8.137-7.87v-.338c.613-.423 1.138-.93 1.488-1.523"
  }));
}

function VimeoIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M14.993 4.849c-.088 1.381-1.05 3.194-2.886 5.525C10.183 12.791 8.609 14 7.297 14c-.787 0-1.487-.777-2.1-2.245-.699-2.072-1.224-6.302-2.448-6.302-.087 0-.437.26-1.05.69L1 5.282c.7-.605 3.06-2.936 4.11-3.022 1.05-.086 1.75.604 2.012 2.158.262 1.727.7 5.266 1.574 5.266.787 0 2.186-2.935 2.274-3.453.087-.777-.263-1.64-2.012-.95C9.658 3.037 10.97 2 12.894 2c1.487.086 2.186 1.036 2.099 2.849"
  }));
}

function YoutubeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M6.25 10.5v-5L10.625 8 6.25 10.5zm8.575-5.167c-.175-1.083-.7-1.833-1.925-2C10.975 3 8 3 8 3s-2.975 0-4.9.333c-1.225.167-1.838.917-1.925 2C1 6.417 1 8 1 8s0 1.583.175 2.667.7 1.833 1.925 2C5.025 13 8 13 8 13s2.975 0 4.9-.333c1.225-.25 1.75-.917 1.925-2S15 8 15 8s0-1.583-.175-2.667z"
  }));
}

function BatteryIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.05 4c.351 0 .636.278.636.62l-.001 1.07h1.679c.322 0 .588.233.63.536L15 6.31v3.38c0 .314-.24.573-.55.614l-.086.006h-1.679l.001 1.07a.625.625 0 01-.542.613L12.05 12H1.636A.628.628 0 011 11.38V4.62c0-.342.285-.62.636-.62H12.05zM5.292 5.24h-3.02v5.52h5.854L5.292 5.24zm6.12 0H6.717l2.834 5.52h1.863V5.24zm1.273 3.83h1.042V6.93h-1.042v2.14z",
    clipRule: "evenodd"
  }));
}

function CalculatorIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M7.5 6.5H9V8H7.5V6.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M5 6.5h1.5V8H5V6.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M7.5 9H9v1.5H7.5V9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M5 9h1.5v1.5H5V9z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M7.5 11.5H9V13H7.5v-1.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M5 11.5h1.5V13H5v-1.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M10 6.5h1V13h-1V6.5z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.29 1c.947 0 1.71.805 1.71 1.793v10.414c0 .988-.763 1.793-1.71 1.793H4.71C3.764 15 3 14.195 3 13.207V2.793C3 1.805 3.763 1 4.71 1h6.58zm-7.062 9.371v2.836c0 .258.173.468.396.512l.087.008h6.579c.264 0 .482-.23.482-.52l-.001-2.836V5.5H4.228v4.871zm0-5.871h7.543V2.794a.51.51 0 00-.395-.513l-.086-.008H4.71c-.264 0-.482.23-.482.52V4.5z",
    clipRule: "evenodd"
  }));
}

function CameraIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.421 1.5l-.09.006a.636.636 0 00-.439.28l-.97 1.47H1.637A.64.64 0 001 3.902v9.955a.64.64 0 00.636.644h12.728a.64.64 0 00.636-.644V3.9l-.006-.088a.64.64 0 00-.63-.556H12.39l-.968-1.47a.634.634 0 00-.53-.287h-3.47zm3.13 1.288l.97 1.47.054.073c.12.135.292.214.475.214h1.677v8.666H2.273V4.545h3.991l.09-.006a.636.636 0 00.44-.28l.968-1.47h2.79zM9 5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 1.262a2.238 2.238 0 110 4.476 2.238 2.238 0 010-4.476zM4.075 5.4a.875.875 0 100 1.75.875.875 0 000-1.75z",
    clipRule: "evenodd"
  }));
}

function DatabaseIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 12 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 0c3.312 0 6 .92 6 2.5 0 .024 0 .047-.002.07l.002.053v9.056C12 13.165 9.352 14 6 14c-3.261 0-5.856-.79-5.994-2.202L0 11.68V2.623l.004-.047L0 2.5C0 .963 2.54.052 5.725.002L6 0zM1.307 11.68c0 .425 2.063 1.075 4.693 1.075 2.545 0 4.56-.61 4.687-1.034l.006-.042V9.202C9.602 9.722 7.916 10 6 10s-3.6-.278-4.694-.798v2.477zm9.387-7.539C9.594 4.697 7.9 5 6 5s-3.595-.303-4.694-.859v3.494C1.307 8.068 3.37 8.73 6 8.73s4.693-.663 4.693-1.096l.001-3.494zM6 1.341c-2.594 0-4.693.719-4.693 1.159S3.407 3.659 6 3.659s4.693-.719 4.693-1.159S8.593 1.341 6 1.341z",
    clipRule: "evenodd"
  }));
}

function DesktopIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.893 14.5v-1.235l3.47-.001v-1.706H1.636a.63.63 0 01-.63-.526L1 10.942V2.117c0-.341.285-.618.636-.618h12.728c.351 0 .636.277.636.618v8.823a.627.627 0 01-.636.618l-5.728-.001v1.706h3.471V14.5H3.893zm9.834-11.765H2.273v7.589h11.454V2.735z",
    clipRule: "evenodd"
  }));
}

function ImageIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 1c.351 0 .636.285.636.636v12.728a.636.636 0 01-.636.636H1.636A.636.636 0 011 14.364V1.636C1 1.285 1.285 1 1.636 1h12.728zm-.637 1.273H2.273v11.454h11.454V2.273zm-4.614 4.8a.579.579 0 01.942.054l2.63 4.208a.579.579 0 01-.49.885H3.778a.579.579 0 01-.48-.9l2.103-3.155a.579.579 0 01.89-.088l1.12 1.12 1.7-2.124zm.393 1.36l-1.593 1.992a.579.579 0 01-.861.048l-1.08-1.08-1.112 1.67h6.29l-1.644-2.63zM6.935 3.7a1.63 1.63 0 110 3.26 1.63 1.63 0 010-3.26zm0 1.157a.473.473 0 100 .946.473.473 0 000-.946z",
    clipRule: "evenodd"
  }));
}

function LaptopIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.247 2c.647 0 1.178.486 1.239 1.106l.005.118v5.842l1.407 3.228c.336.77-.197 1.625-1.023 1.7l-.12.006H2.245c-.892 0-1.494-.898-1.143-1.706l1.406-3.23v-5.84c0-.636.494-1.16 1.124-1.218L3.752 2h8.495zm.187 7.82h-8.87L2.29 12.747h11.418l-1.274-2.925zm-.217-6.566H3.782v5.313h8.435V3.254z",
    clipRule: "evenodd"
  }));
}

function MobileIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 11.3a.7.7 0 110 1.4.7.7 0 010-1.4M11.29 1c.947 0 1.71.805 1.71 1.793v10.414c0 .988-.763 1.793-1.71 1.793H4.71C3.764 15 3 14.195 3 13.207V2.793C3 1.805 3.763 1 4.71 1h6.58zm.481 9.371H4.228v2.836c0 .258.173.468.396.512l.087.008h6.578c.265 0 .483-.23.483-.52l-.001-2.836zm0-5.785H4.228v4.513h7.543V4.586zm-.482-2.313H4.711c-.265 0-.483.23-.483.52v.521h7.543v-.52a.511.511 0 00-.395-.513l-.087-.008z",
    clipRule: "evenodd"
  }));
}

function PhoneIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.922 1.765a.636.636 0 01.9 0l2.892 2.892a.636.636 0 010 .9L5.428 6.843l3.728 3.728 1.287-1.285a.637.637 0 01.82-.068l.08.068 2.892 2.892a.636.636 0 010 .9L12.5 14.814a.636.636 0 01-.45.186C5.947 15 1 10.053 1 3.95c0-.168.067-.33.186-.45l1.736-1.735zm.45 1.35L2.276 4.21c.134 5.106 4.182 9.237 9.254 9.503l.26.01 1.095-1.097-1.993-1.992-1.285 1.286a.637.637 0 01-.821.067l-.079-.067-4.628-4.628a.636.636 0 010-.9l1.285-1.286-1.992-1.992zM9.157 1a5.843 5.843 0 015.84 5.633l.003.21h-1.273a4.57 4.57 0 00-4.372-4.566l-.198-.004V1zm0 2.314a3.53 3.53 0 013.524 3.347l.005.182h-1.273a2.257 2.257 0 00-2.108-2.251l-.148-.005V3.314z",
    clipRule: "evenodd"
  }));
}

function PrinterIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.471 1c.322 0 .588.24.63.55l.006.086v2.312a3.493 3.493 0 012.888 3.29L15 7.42v4.686h-2.893v2.257c0 .32-.235.584-.542.63l-.094.006H4.53a.636.636 0 01-.636-.636l-.001-2.257H1V7.421a3.496 3.496 0 012.892-3.473V1.636c0-.322.24-.588.55-.63L4.53 1h6.942zm-.636 8.793h-5.67v3.934h5.67V9.793zm.636-4.628H4.53c-1.218 0-2.177.91-2.252 2.106l-.004.15v3.414l1.619-.001V9.157c0-.32.236-.584.543-.63l.094-.006h6.942c.352 0 .636.285.636.636v1.677h1.62V7.422c0-1.217-.91-2.176-2.105-2.251l-.15-.005zm-.636-2.892h-5.67v1.619h5.669v-1.62zm.62 3.909a.637.637 0 110 1.273.637.637 0 010-1.273",
    clipRule: "evenodd"
  }));
}

function QRIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.5 10.5V12H15v3h-1.5v-1.5h-3V15H9v-1.5h1.5V12H12v-1.5h1.5zM12 9v1.5h-1.5V12H9V9h3zm3 0v1.5h-1.5V9H15zM6.41 1a.59.59 0 01.59.59v4.82a.59.59 0 01-.59.59H1.59A.59.59 0 011 6.41V1.59A.59.59 0 011.59 1h4.82zm8 0a.59.59 0 01.59.59v4.82a.59.59 0 01-.59.59H9.59A.59.59 0 019 6.41V1.59A.59.59 0 019.59 1h4.82zm-8 8a.59.59 0 01.59.59v4.82a.59.59 0 01-.59.59H1.59a.59.59 0 01-.59-.59V9.59A.59.59 0 011.59 9h4.82zM14 2v4h-4V2h4zm-8 8v4H2v-4h4z",
    clipRule: "evenodd"
  }));
}

function SaveIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.471 1c.206 0 .398.1.518.266l2.892 4.05a.636.636 0 01.119.37v8.678a.636.636 0 01-.636.636H1.636A.636.636 0 011 14.364V1.636C1 1.285 1.285 1 1.636 1h9.835zm-.327 1.273l-.773-.001v3.414c0 .322-.239.588-.55.63l-.085.006H3.95a.636.636 0 01-.63-.55l-.006-.086V2.272H2.273v11.455h1.041V8.579c0-.323.24-.589.55-.631l.086-.006h8.1c.322 0 .588.24.63.55l.006.087-.001 5.148h1.042V5.89l-2.583-3.617zm.269 6.942H4.586v4.512h6.827V9.215zm-1.677 1.62v1.272H6.264v-1.272h3.472zm-.637-8.563H4.586v2.777H9.1V2.272z",
    clipRule: "evenodd"
  }));
}

function AlignCenterIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.107 12.6V14H3.893v-1.4h8.214zM15 9.1v1.4H1V9.1h14zm-2.893-3.6v1.4H3.893V5.5h8.214zM15 2v1.4H1V2h14z",
    clipRule: "evenodd"
  }));
}

function AlignLeftIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 2v1.4H1V2h14zM9.215 5.5v1.4H1V5.5h8.215zM15 9.1v1.307H1V9.1h14zm-5.785 3.5V14H1v-1.4h8.215z",
    clipRule: "evenodd"
  }));
}

function AlignRightIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 2v1.4H1V2h14zm0 3.5v1.4H6.785V5.5H15zm0 3.6v1.4H1V9.1h14zm0 3.5V14H6.785v-1.4H15z",
    clipRule: "evenodd"
  }));
}

function AttachmentIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.816 1c1.78 0 3.22 1.35 3.311 3.067l.005.173v5.785c0 1.161-.943 2.082-2.132 2.082-1.14 0-2.053-.846-2.127-1.938l-.005-.144V5.107h1.303v4.918c0 .458.36.81.829.81.433 0 .773-.3.823-.706l.006-.104V4.24c0-1.095-.893-1.967-2.013-1.967-1.072 0-1.935.798-2.008 1.825l-.005.142v6.363c0 1.731 1.425 3.124 3.197 3.124 1.713 0 3.102-1.301 3.193-2.952l.004-.172V3.372H12.5v7.231C12.5 13.037 10.491 15 8 15c-2.424 0-4.391-1.858-4.496-4.2l-.004-.197V4.24C3.5 2.442 4.976 1 6.816 1z",
    clipRule: "evenodd"
  }));
}

function BoldIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.188 1c2.001 0 3.624 1.58 3.624 3.529a3.482 3.482 0 01-1.229 2.648C13.012 7.835 14 9.251 14 10.893c0 2.203-1.782 4.002-4.02 4.103L9.783 15H2v-1.273h1.187l.001-6.306V2.272H2V1h7.188zm.594 7.058H4.494v5.67h5.288c1.608 0 2.911-1.27 2.911-2.835 0-1.512-1.215-2.747-2.746-2.83l-.165-.005zM4.495 6.785h4.693c1.28 0 2.317-1.01 2.317-2.256 0-1.196-.956-2.175-2.165-2.251l-.152-.005-4.693-.001v4.513z",
    clipRule: "evenodd"
  }));
}

function BulletListIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.75 1.58a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zm0 4.69a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zm0 4.68a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zM15 2.671v1.4H6v-1.4h9zm0 4.685v1.4H6v-1.4h9zm0 4.685v1.4H6v-1.4h9z",
    clipRule: "evenodd"
  }));
}

function ItalicIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1v1.325h-1.831l-3.005 11.35h1.48V15H4v-1.325h1.829l3.006-11.35H7.357V1H12z",
    clipRule: "evenodd"
  }));
}

function LinkIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.508 2.1c1.468-1.467 3.924-1.467 5.391 0 1.419 1.42 1.466 3.762.142 5.242l-.142.15-2.055 2.055-.906-.906 2.055-2.055c.967-.967.967-2.612 0-3.58-.927-.926-2.476-.965-3.455-.115l-.124.116L7.36 5.062l-.906-.906L8.508 2.1zM4.156 6.454l.906.906-2.055 2.055c-.967.967-.967 2.612 0 3.58.927.926 2.476.965 3.455.115l.124-.116 2.055-2.055.906.906L7.492 13.9c-1.468 1.468-3.924 1.468-5.391 0-1.419-1.418-1.466-3.76-.142-5.241l.142-.15 2.055-2.055zm5.313-.828l.906.906-3.844 3.844-.906-.906 3.844-3.844z",
    clipRule: "evenodd"
  }));
}

function NumberListIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.361 4.617V4.19l.468-.038c.076-.005.087-.027.087-.108V2.155c0-.065-.016-.097-.071-.113l-.473-.098.06-.444h1.305v2.544c0 .086.005.103.087.108l.445.038v.427H1.361zm-.282 4.85v-.503l.729-.71c.548-.53.782-.746.782-1.055 0-.2-.098-.346-.386-.346-.3 0-.424.097-.424.482l-.74-.065c.006-.86.664-1.002 1.234-1.002.843 0 1.142.357 1.142.866s-.353.844-.75 1.223l-.614.585h.799c.054 0 .076-.01.087-.065l.076-.427h.576v1.017H1.079zm1.834 3.15c.463.07.717.346.717.833 0 .715-.537 1.05-1.314 1.05-.55 0-1.038-.195-1.316-.498l.435-.476c.207.2.434.357.815.357.305 0 .565-.108.565-.487 0-.33-.206-.465-.543-.465-.136 0-.239.01-.403.037v-.54l.267-.033c.391-.049.603-.238.603-.584 0-.206-.092-.374-.396-.374-.294 0-.435.098-.435.482l-.744-.066c0-.854.646-1 1.217-1 .836 0 1.158.319 1.158.898a.848.848 0 01-.626.844v.022zM15 2.367v1.4H5v-1.4h10zm0 4.81v1.4H5v-1.4h10zm0 4.808v1.4H5v-1.4h10z",
    clipRule: "evenodd"
  }));
}

function SourceCodeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.182 4.5l.9.9-2.547 2.545 2.547 2.546-.9.9-2.996-2.996a.637.637 0 01-.067-.82l.067-.08L4.182 4.5zm7.636 0l2.996 2.995a.637.637 0 01.067.822l-.067.078-2.996 2.996-.9-.9 2.547-2.546L10.918 5.4l.9-.9zM8.81 2l1.234.316L7.19 14l-1.234-.316L8.81 2z",
    clipRule: "evenodd"
  }));
}

function TextColorIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 11.413c.351 0 .636.285.636.637v2.314a.636.636 0 01-.636.636H1.636A.636.636 0 011 14.364V12.05c0-.352.285-.637.636-.637h12.728zm-.637 1.272H2.273v1.042h11.454v-1.042zM8.58 1c.239 0 .455.134.563.341l.036.081L11.919 9.1h1.345v1.273H9.678V9.099h.889L9.782 6.9H6.217l-.785 2.199h.89v1.273H2.736V9.099H4.08l1.084-3.033a.629.629 0 01.005-.015l1.653-4.629a.636.636 0 01.511-.416L7.421 1H8.58zM8.13 2.273h-.26L6.67 5.628h2.657L8.13 2.273z",
    clipRule: "evenodd"
  }));
}

function UnderlineIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 13.727V15H1v-1.273h14zM5.744 1v1.273l-1.158-.001V8a3.413 3.413 0 006.822.181L11.413 8V2.272h-1.157V1h3.587v1.273l-1.158-.001L12.686 8a4.686 4.686 0 01-9.368.198L3.314 8V2.272H2.157V1h3.587z",
    clipRule: "evenodd"
  }));
}

function UnlinkIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.49 2.317c1.413-1.413 3.779-1.413 5.193 0 1.366 1.367 1.412 3.623.136 5.05l-.136.144-1.98 1.979-.873-.873 1.98-1.98c.931-.93.931-2.515 0-3.447-.893-.893-2.385-.93-3.328-.111l-.12.111-1.98 1.98-.872-.873 1.98-1.98zM4.296 6.51l.873.873-1.98 1.98c-.931.93-.931 2.515 0 3.447.893.893 2.385.93 3.328.111l.12-.111 1.98-1.98.872.873-1.98 1.98c-1.413 1.413-3.779 1.413-5.193 0-1.366-1.367-1.412-3.623-.136-5.05l.136-.144 1.98-1.979zm5.118-.798l.873.873-3.703 3.703-.873-.873 3.703-3.703zm2.695 5.65l.552-1.104L15 11.428l-.552 1.103-2.338-1.169zm-1.852 1.3l1.104-.552 1.17 2.338-1.105.552-1.17-2.338zm-6.79-11.11L4.574 1l1.17 2.338-1.105.552-1.17-2.338zM1.553 3.469L3.89 4.638l-.552 1.104L1 4.572l.552-1.103z",
    clipRule: "evenodd"
  }));
}

function AnimalFreeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.232 4.656l.236-.276a.681.681 0 01.812-.172l.08.046.086.065c.268.23.3.659.057.945l-.236.276a.68.68 0 01-.9.121l-.078-.06a.675.675 0 01-.057-.945m-.497 1.629l.117.089a1.565 1.565 0 002.084-.262l.236-.276a1.56 1.56 0 00-.173-2.2l-.115-.09-.02-.014a1.562 1.562 0 00-2.066.276l-.235.276a1.56 1.56 0 00.172 2.2m-.567 1.201c-.672-.95-1.669-1.467-2.707-1.604l4.218 4.218a2.809 2.809 0 00-.24-.518l-1.271-2.096zm-7.592-1.87l-.078.06a.676.676 0 01-.882-.136l-.236-.276-.059-.08a.68.68 0 01.063-.808l.067-.067.083-.063a.677.677 0 01.88.135l.237.276a.68.68 0 01-.075.96zm.554.685c.674-.575.75-1.56.19-2.216l-.235-.276a1.56 1.56 0 00-2.067-.276l-.134.103a1.561 1.561 0 00-.173 2.2l.236.277a1.56 1.56 0 002.066.277L3.13 6.3zm1.024-4.208a.682.682 0 01.458-.846l.09-.022a.676.676 0 01.756.48l.32 1.074a.68.68 0 01-.458.847l-.09.02h-.004l.673.674a1.555 1.555 0 00.724-1.791l-.32-1.075A1.56 1.56 0 004.517.364l-.155.037a1.56 1.56 0 00-1.099 1.283L4.36 2.778l-.205-.686zm3.951.686l.32-1.074a.68.68 0 01.685-.486l.086.01.096.024c.339.1.544.48.437.84l-.32 1.074a.68.68 0 01-.777.475l-.09-.022a.679.679 0 01-.437-.84m.208 1.69l.132.032a1.566 1.566 0 001.809-1.084l.32-1.074A1.561 1.561 0 009.521.402L9.366.363a1.561 1.561 0 00-1.785 1.09l-.32 1.074A1.562 1.562 0 008.313 4.47m.129 7.957l-.11-.04a4.003 4.003 0 00-2.78 0l-.11.04c-1.472.546-2.816-.98-2.038-2.264l1.27-2.096c.413-.582 1.02-.918 1.673-1.046l4.29 4.29a1.643 1.643 0 01-2.195 1.116zm5.558.901L.673 0 0 .673l5.443 5.443a3.78 3.78 0 00-1.706 1.335L2.445 9.58c-1.34 2.212.941 4.805 3.387 3.896l.11-.04a2.88 2.88 0 012 0l.11.04c1.46.542 2.848-.17 3.454-1.298L13.327 14l.673-.673z",
    clipRule: "evenodd"
  }));
}

function BicycleIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__bicycle ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || '#181c56'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.51 3.97a.453.453 0 00-.432-.324h-2.14v.7h1.95l.01.035.625 2.12-4.528.503-.357-.629h.313a.375.375 0 000-.75h-1.6a.375.375 0 000 .75h.482l.523.92-1.971 3.803a.349.349 0 00.62.32l1.761-3.4 1.505 2.65.608-.344-1.508-2.657 3.708-.412L8 10.479l.589.38 2.208-3.428 1.143 3.877a.35.35 0 10.67-.198l-2.1-7.14z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M7.977 10.65a.35.35 0 110 .7.35.35 0 010-.7m0-.65a1 1 0 100 2 1 1 0 000-2z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12.327 9.45c1.048 0 1.9.852 1.9 1.9s-.852 1.9-1.9 1.9-1.9-.852-1.9-1.9.852-1.9 1.9-1.9m0-.75a2.65 2.65 0 100 5.3 2.65 2.65 0 000-5.3z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M3.627 9.45c1.048 0 1.9.852 1.9 1.9s-.852 1.9-1.9 1.9-1.9-.852-1.9-1.9.852-1.9 1.9-1.9m0-.75a2.65 2.65 0 100 5.3 2.65 2.65 0 000-5.3z"
  }));
}

function BusIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__bus ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || '#c5044e'
  }), /*#__PURE__*/createElement("g", {
    fill: "#C5044E",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M10.5 11.8a1 1 0 111.998.003A1 1 0 0110.5 11.8z"
  }), /*#__PURE__*/createElement("path", {
    d: "M14.996 9.595l-.7-4.296A.353.353 0 0013.95 5H1.7c-.35 0-.7.358-.7.717V10.642c0 .178.128.358.3.358h1.547c.236-.719.906-1.2 1.703-1.2s1.468.481 1.703 1.2h3.544c.236-.719.906-1.2 1.703-1.2s1.467.481 1.703 1.2h1.447c.193 0 .35-.161.35-.358v-.988c0-.02-.002-.04-.004-.06zm-2.84-2.805c0-.198.158-.358.35-.358h1.087a.35.35 0 01.347.311l.185 1.432a.36.36 0 01-.085.282.343.343 0 01-.262.122h-1.272a.354.354 0 01-.35-.358V6.79zm-4.2 0c0-.198.157-.358.35-.358h2.8c.193 0 .35.16.35.358V8.22a.354.354 0 01-.35.358h-2.8a.354.354 0 01-.35-.358V6.79zm-4.2 0c0-.198.157-.358.35-.358h2.8c.194 0 .351.16.351.358V8.22a.355.355 0 01-.35.358h-2.8a.354.354 0 01-.35-.358V6.79zm-2.1 0c0-.198.158-.358.35-.358h.701c.193 0 .349.16.349.358V8.22a.353.353 0 01-.349.358h-.7a.354.354 0 01-.35-.358V6.79z"
  }), /*#__PURE__*/createElement("path", {
    d: "M3.55 11.8c0-.551.449-1 1-1s1 .449 1 1a1 1 0 01-2 0z"
  })));
}

function CablewayIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__cableway ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || '#642e88'
  }), /*#__PURE__*/createElement("path", {
    fill: "#642E88",
    fillRule: "evenodd",
    d: "M13.295 1.803l-3.917.984a1.225 1.225 0 00-.188-.806L13.094 1l.201.803zm-5.127.121a.74.74 0 110 1.482.74.74 0 010-1.482zm5.011 6.011a.432.432 0 00-.42-.336h-9.18a.432.432 0 00-.422.336l-1.146 5.068a.557.557 0 00.09.433l1.003 1.385a.432.432 0 00.35.179h9.429a.432.432 0 00.35-.179l1.002-1.385a.556.556 0 00.09-.433L13.18 7.935zM5.49 11.502c0 .24-.193.433-.432.433H3.763a.432.432 0 01-.422-.526l.382-1.727a.43.43 0 01.42-.34h.915c.239 0 .432.194.432.433v1.727zm4.494 0a.432.432 0 01-.432.433H6.961a.432.432 0 01-.432-.432V9.775c0-.238.193-.432.432-.432h2.591c.238 0 .432.194.432.432v1.728zm2.927.272a.432.432 0 01-.337.162h-1.295a.432.432 0 01-.433-.433V9.775c0-.238.194-.432.432-.432h.914a.43.43 0 01.422.34l.381 1.727a.431.431 0 01-.084.364zM6.959 2.54l-3.918.984.202.803 3.904-.98a1.225 1.225 0 01-.188-.807zm1.623 1.273v1.724h1.43v.828H6.324v-.828h1.43V3.814c.13.047.268.084.414.084.147 0 .284-.037.414-.084z",
    clipRule: "evenodd"
  }));
}

function CarIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.002 7.2H14l-1.092-3.337C12.74 3.35 12.223 3 11.636 3H4.368c-.587 0-1.104.35-1.272.862L2 7.2h-.002A.998.998 0 001 8.198v3.503c0 .276.223.499.499.499H2v.667a1.1 1.1 0 002.2 0V12.2h7.6v.667a1.1 1.1 0 002.2 0V12.2h.501a.499.499 0 00.499-.499V8.198a.998.998 0 00-.998-.998zM3.27 7.133l.84-2.739a.51.51 0 01.495-.344h6.79c.23 0 .431.14.494.344l.84 2.74c.01.033-.016.066-.054.066h-9.35c-.038 0-.065-.033-.055-.067zM2.8 8.2c.44.002.799.36.8.804a.8.8 0 11-.8-.804zm10.4 1.6a.8.8 0 110-1.6.8.8 0 010 1.6z",
    clipRule: "evenodd"
  }));
}

function CarferryIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__carferry ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || '#0497bc'
  }), /*#__PURE__*/createElement("path", {
    fill: "#0497BC",
    fillRule: "evenodd",
    d: "M11.858 5.7l-.703-2.145c-.108-.33-.44-.555-.818-.555H5.665c-.377 0-.71.225-.817.554L4.143 5.7h-.001a.642.642 0 00-.642.642v2.252c0 .177.144.32.32.32h.323v.429a.707.707 0 001.414 0v-.429h4.886v.429a.707.707 0 001.414 0v-.429h.322a.32.32 0 00.321-.32V6.342a.642.642 0 00-.642-.642zM4.96 5.657l.54-1.76c.041-.132.17-.222.319-.222h4.364c.148 0 .278.09.318.221l.54 1.761c.007.022-.01.043-.035.043h-6.01c-.025 0-.042-.021-.036-.043zm-.302.686a.515.515 0 110 1.028.515.515 0 010-1.028zm6.686 1.028a.515.515 0 110-1.028.515.515 0 010 1.028z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0497BC",
    d: "M2 12.289c.109-.015.231-.023.373-.023.576 0 .837.136 1.167.31.101.053.122.067.238.12.023.01.196.097.438.172.105.033.222.058.348.08.037.006.307.052.608.052.824 0 1.254-.226 1.633-.425.33-.173.591-.31 1.167-.31s.837.137 1.167.31c.38.2.81.425 1.633.425s1.253-.226 1.633-.425c.33-.173.59-.31 1.168-.31.145 0 .29.017.427.045v-1.013a2.99 2.99 0 00-.427-.031c-.823 0-1.253.225-1.633.424-.33.173-.59.31-1.168.31s-.838-.137-1.168-.31c-.379-.199-.809-.424-1.632-.424s-1.253.225-1.632.424c-.33.173-.59.31-1.168.31-.179 0-.326-.012-.454-.04-.094-.022-.192-.04-.322-.09a3.304 3.304 0 01-.392-.18c-.378-.199-.808-.424-1.631-.424a3.94 3.94 0 00-.373.017v1.006z"
  }));
}

function CityBikeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 4.45h-3v1.1h2.62l1.375 3.606a2.743 2.743 0 00-.893.65c-.454.487-.79 1.127-1.082 1.744-.092.193-.178.383-.264.57-.2.438-.391.857-.613 1.254-.148.263-.3.499-.461.702a1.498 1.498 0 00-1.959-.36L7.89 8.05h.61a.55.55 0 100-1.1h-3a.55.55 0 000 1.1h1.16l.725 1.45-1.105 2.21a4 4 0 102.682 4.34h1.467a1.5 1.5 0 002.527-.687c.486-.397.85-.92 1.147-1.452.245-.438.467-.923.674-1.378.081-.177.16-.35.237-.512.289-.611.565-1.113.892-1.463a1.68 1.68 0 01.481-.371l.688 1.806a4 4 0 101.028-.392L16.75 8.05H18a.55.55 0 00.51-.346l1-2.5-1.02-.408-.862 2.154H16.33l-.817-2.146A.55.55 0 0015 4.45zm-7 6.28l2.018 4.036c-.01.06-.015.122-.017.184H8.963a4 4 0 00-1.7-2.748L8 10.73zm9.472 2.305l1.014 2.66a.55.55 0 101.028-.39L18.5 12.642a2.9 2.9 0 11-1.028.392zM4.45 15.5H2.1a2.9 2.9 0 005.748.55H5a.55.55 0 01-.55-.55zm3.398-.55H5.89l.875-1.751a2.9 2.9 0 011.083 1.751zm3.652.55a.5.5 0 100-1 .5.5 0 000 1z",
    clipRule: "evenodd"
  }));
}

function FerryIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__ferry ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || '#0497bc'
  }), /*#__PURE__*/createElement("path", {
    fill: "#0497BC",
    d: "M8.737 13c-.824 0-1.253-.226-1.632-.425-.33-.173-.591-.31-1.168-.31s-.838.137-1.168.31c-.38.2-.81.425-1.633.425-1.052 0-1.969-.588-2.007-.613L1 12.316l.447-.894.196.108c.037.023.743.47 1.493.47.577 0 .838-.137 1.168-.31.38-.199.81-.424 1.633-.424s1.254.225 1.633.424c.33.173.59.31 1.167.31s.837-.137 1.167-.31c.379-.199.81-.424 1.632-.424.643 0 1.046.137 1.372.292l-.479.88c-.23-.103-.48-.172-.893-.172-.577 0-.837.136-1.168.31-.378.198-.808.424-1.631.424z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#0497BC",
    d: "M14.75 7.456h-1.432a.053.053 0 01-.05-.036l-.907-2.746a.348.348 0 00-.33-.242h-.554a.05.05 0 01-.047-.034l-.34-.825c-.073-.186-.214-.298-.417-.198l-1.213.706a.45.45 0 00-.244.402v.463c0 .04-.026.054-.047.054H5.78a.354.354 0 00-.318.198L4.362 7.422a.05.05 0 01-.047.034h-.667a.35.35 0 00-.314.195l-1.496 3.047c.313.16.658.302 1.275.302 1.4 0 1.4-.733 2.8-.733s1.4.733 2.8.733 1.4-.733 2.8-.733c.9 0 1.45.306 1.845.521l1.611-2.963a.25.25 0 00-.22-.37zm-7.353-.2a.2.2 0 01-.2.2H5.272c-.125 0-.236-.098-.133-.279l.381-.78a.254.254 0 01.228-.141h1.45c.11 0 .2.09.2.2v.8zm2.204-.004a.204.204 0 01-.204.204H8.005a.204.204 0 01-.204-.204V6.46c0-.113.091-.204.204-.204h1.392c.113 0 .204.091.204.204v.792zm2.535.204l-1.933.001A.202.202 0 0110 7.256v-.799c0-.11.09-.201.202-.201h1.653c.116 0 .217.079.245.191l.193.78c.053.165-.049.229-.158.229z"
  }));
}

function FunicularIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__funicular ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || '#642e88'
  }), /*#__PURE__*/createElement("path", {
    fill: "#78469A",
    fillRule: "evenodd",
    d: "M14.062 5.273A.35.35 0 0013.721 5H2.279a.35.35 0 00-.341.273L1.009 9.38a.451.451 0 00.074.35l.812 1.124a.35.35 0 00.283.145h11.643a.35.35 0 00.284-.145l.812-1.123a.451.451 0 00.074-.351l-.929-4.108zM3.75 8.183a.35.35 0 01-.35.35H2.35a.35.35 0 01-.342-.426l.31-1.4a.35.35 0 01.34-.275H3.4a.35.35 0 01.35.35v1.4zm3.5 0a.35.35 0 01-.35.35H4.799a.35.35 0 01-.35-.35V6.781a.35.35 0 01.35-.35h2.1a.35.35 0 01.35.35v1.4zm3.51 0a.35.35 0 01-.35.35h-2.1a.35.35 0 01-.35-.35V6.781a.35.35 0 01.35-.35h2.1a.35.35 0 01.35.35v1.4zm3.073.219a.35.35 0 01-.272.131H11.81a.35.35 0 01-.35-.35V6.782a.35.35 0 01.35-.35H13.251a.35.35 0 01.342.275l.309 1.4a.347.347 0 01-.07.295z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "#78469A",
    fillRule: "evenodd",
    d: "M2 12h12v1H2z",
    clipRule: "evenodd"
  }));
}

function HelicopterIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__helicopter ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || '#800664'
  }), /*#__PURE__*/createElement("path", {
    fill: "#800664",
    fillRule: "evenodd",
    d: "M15 4.671V4H4v.671h5.17v1.127h-.52a.65.65 0 00-.65.65v.554H2.558l-.315-.863a.21.21 0 00-.2-.139h-.832A.211.211 0 001 6.211l.009 1.907a.212.212 0 00.176.206L8 9.475v.875c0 .359.291.65.65.65h4.7a.65.65 0 00.65-.65V9.198c0-1.875-1.526-3.4-3.4-3.4h-.76V4.67H15zm-4.638 2.242v-.097a.229.229 0 01.221-.19h.526c.891 0 1.631.66 1.76 1.516.014.083.01.128-.012.17-.03.051-.084.085-.21.085-.195 0-.888-.002-2.064 0a.22.22 0 01-.221-.22V6.913z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "#800664",
    fillRule: "evenodd",
    d: "M9 11.999h4v1H9z",
    clipRule: "evenodd"
  }));
}

function PlaneIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__plane ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || '#800664'
  }), /*#__PURE__*/createElement("path", {
    fill: "#800664",
    fillRule: "evenodd",
    d: "M14.833 5.682a.216.216 0 00-.044-.03l-.016-.011-.043-.025c-.146-.084-1.008-.42-1.478-.576a.761.761 0 00-.398-.024L9.037 6.044 5.21 4.438c-.273-.118-.318-.14-.57-.125l-.794.076c-.171.018-.198.158-.055.294L6.01 6.858 3.621 7.5l-2.13-.824c-.176-.069-.231-.068-.323-.043l-.08.022c-.063.016-.09.056-.088.1.002.057.046.076.19.228 0 0 2.873 2.805 3.033 2.948a.221.221 0 00.204.048l10.138-2.731a.219.219 0 00.151-.144c.131-.4.313-1.058.28-1.179a.458.458 0 00-.163-.243zm-1.252.206l-.271.073c-.03.008-.074.026-.122.006l-.46-.169a.139.139 0 01-.087-.138.141.141 0 01.103-.127l.271-.073a.142.142 0 01.088.005l.506.204c.056.023.086.055.082.115s-.052.09-.11.104z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "#800664",
    fillRule: "evenodd",
    d: "M2 11.999h12v1H2z",
    clipRule: "evenodd"
  }));
}

function QuietIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.901 5.733c0 .1-.04.194-.11.265L9.418 9.443V7.509H7.57a.45.45 0 01-.332-.16.451.451 0 01-.109-.28V3.748H5.705l1.27-2.663h5.926v4.648zm-8.425.407c.547 0 .993.394.993.877v5.327a.77.77 0 01-.219.515.593.593 0 01-.177.16L3.614 14l-.465-.672 1.466-.985.029-5.326c-.013-.031-.324-.034-.338.005l.001 2.251h-.003v.789h-.826v-.79c-.024-.03-.32-.032-.332.006v1.535h-.825v-.788c-.012-.03-.32-.034-.336.005l.001.748h-.004v.384h-.825l.004-.384c-.012-.03-.322-.035-.336.004v1.934H0v-1.938c0-.536.592-.957 1.17-.863.068-.483.62-.837 1.16-.752.068-.48.617-.834 1.152-.753V7.017c0-.483.446-.877.994-.877zM13.069 0c.513 0 .931.412.931.918v4.815c0 .382-.148.744-.418 1.019l-3.76 3.839a.865.865 0 01-.643.265.883.883 0 01-.302-.055c-.346-.159-.542-.45-.558-.776V8.593h-.743c-.432.019-.9-.202-1.187-.557a1.514 1.514 0 01-.36-.958V4.832h-.592a.925.925 0 01-.88-1.223L6.015.555C6.132.24 6.483 0 6.87 0h6.199z",
    clipRule: "evenodd"
  }));
}

function RunningIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M10.132 4a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M13.533 6.586l-1.734.117a.15.15 0 01-.12-.048L10.316 5.18a1.242 1.242 0 00-.347-.263l-1.6-.82a1 1 0 00-.828-.015l-2.213.95a.6.6 0 00-.237.183l-1.59 2.048a.428.428 0 00.591.618L5.67 6.137a.25.25 0 01.098-.066l1.408-.525-1.01 2.412a1.4 1.4 0 00-.062 1.049l.038.11a1.4 1.4 0 00.648.777l2.667 1.478.08.082 1.69 3.205a.6.6 0 101.083-.518l-1.423-3.428a1 1 0 00-.327-.42L8.5 8.764l1.142-2.44 1.518 1.354a.5.5 0 00.42.119l2.03-.36a.428.428 0 00-.078-.851z"
  }), /*#__PURE__*/createElement("path", {
    d: "M5.708 9.6a1.32 1.32 0 01-.075-.282l-.975 1.75-2.886 1.134a.6.6 0 10.394 1.134l3.371-.959 1.133-1.851-.33-.183c-.353-.228-.513-.456-.632-.743z"
  })));
}

function ScooterIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 11c-.019 0-.036.005-.055.005l-2.224-7.68A.45.45 0 009.79 3H7.5v.8h1.95a.1.1 0 01.097.072l1.53 5.281a.1.1 0 01-.02.093l-2.398 2.819a.1.1 0 01-.076.035H4.94A1.496 1.496 0 002 12.5a1.496 1.496 0 002.94.4H8.79a.45.45 0 00.343-.159l2.224-2.615.324 1.12c-.41.267-.682.728-.682 1.254a1.5 1.5 0 101.5-1.5zm-9 2.2a.7.7 0 11.002-1.402A.7.7 0 013.5 13.2zm9 0a.7.7 0 11.002-1.402.7.7 0 01-.002 1.402z",
    clipRule: "evenodd"
  }));
}

function StandardIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 0C3.14 0 0 3.141 0 7s3.14 7 7 7 7-3.141 7-7-3.14-7-7-7m0 1c3.309 0 6 2.691 6 6s-2.691 6-6 6c-3.308 0-6-2.691-6-6s2.692-6 6-6m.024 1.9c-1.405 0-2.458.975-2.458 2.323 0 1.03.52 1.606 1.625 2.128l.34.152.427.182c.828.356 1.14.61 1.14 1.038 0 .524-.475.942-1.113.942-.56 0-1.142-.314-1.586-.845h-.153l-.822.966.002.132c.213.233.493.477.841.69a3.195 3.195 0 001.68.492c1.47 0 2.653-1.074 2.653-2.505 0-1.097-.587-1.688-1.83-2.242l-.602-.259c-.803-.35-1.11-.6-1.11-1.01 0-.433.352-.76.976-.76.466 0 .944.228 1.344.685l.15.001.812-.913.003-.128C8.805 3.293 7.91 2.9 7.024 2.9z",
    clipRule: "evenodd"
  }));
}

function StandingIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M8 3.5a1.25 1.25 0 11-.001-2.499A1.25 1.25 0 018 3.5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M10.99 8.786l-.825-3.989A1 1 0 009.185 4h-2.37a1 1 0 00-.98.797l-.825 3.99a.428.428 0 00.836.184l.587-2.197h.047L6.5 10v4.4a.6.6 0 101.2 0l.101-4.338c.004-.033.026-.062.056-.062h.29c.032 0 .055.03.057.064L8.3 14.4a.6.6 0 101.2 0V10l.02-3.226h.047l.587 2.197a.428.428 0 00.836-.185z"
  })));
}

function StrollingIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M11.917 8.51l-1.361-1.68a.2.2 0 01-.029-.048l-.932-2.176A1 1 0 008.675 4H7.107a1 1 0 00-.837.453L5.143 6.177a.974.974 0 00-.15.392c-.088.575-.323 2.136-.323 2.136a.428.428 0 00.825.225l.554-2.132.518-.74.01 1.926c.002.303.091.6.257.853l1.708 2.621a.2.2 0 01.025.057l.824 3.02a.6.6 0 101.17-.27l-.53-3.019a1 1 0 00-.055-.192l-.978-2.498a.2.2 0 01-.014-.078l.062-2.193.507.894a.968.968 0 00.134.185l1.54 1.652a.428.428 0 00.69-.506z"
  }), /*#__PURE__*/createElement("path", {
    d: "M6.507 9.362l-.073 1.815a.2.2 0 01-.012.06l-1.059 2.946a.6.6 0 101.113.45l1.298-2.776a.998.998 0 00.066-.188l.072-.252-1.405-2.055z"
  }), /*#__PURE__*/createElement("path", {
    d: "M8.003 3.5a1.25 1.25 0 11-.001-2.499 1.25 1.25 0 010 2.499z"
  })));
}

function SubwayIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#DE8108",
    fillRule: "evenodd",
    d: "M5.004 5v1.166h2.412V12h1.168V6.166h2.415V5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "#DE8108",
    d: "M8 2c3.308 0 6 2.692 6 6s-2.692 6-6 6c-3.309 0-6-2.692-6-6s2.691-6 6-6m0-1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7z"
  }));
}

function TaxiIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__taxi ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || '#181c56'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.998 7.233h-.002l-1.092-3.337c-.168-.512-.685-.863-1.272-.863H9.5v-.502a.498.498 0 00-.498-.498H6.997a.498.498 0 00-.497.498v.502H4.364c-.587 0-1.104.35-1.272.862L1.996 7.233h-.002a.998.998 0 00-.998.999v3.503c0 .275.223.498.499.498h.501v.667a1.1 1.1 0 002.2 0v-.667h7.6v.667a1.1 1.1 0 002.2 0v-.667h.501a.499.499 0 00.5-.498V8.232a.998.998 0 00-1-.999zM3.266 7.167l.84-2.74a.51.51 0 01.495-.344h6.79c.23 0 .431.141.494.345l.84 2.739c.011.033-.016.066-.054.066H3.32c-.037 0-.065-.033-.055-.066zm-.47 1.066c.44.002.8.36.8.804a.8.8 0 11-.8-.804zm10.4 1.6a.8.8 0 110-1.6.8.8 0 010 1.6z",
    clipRule: "evenodd"
  }));
}

function TrainIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__train ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || '#00367f'
  }), /*#__PURE__*/createElement("path", {
    fill: "#00367F",
    fillRule: "evenodd",
    d: "M1 12h13v1H1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "#00367F",
    d: "M14.75 8.1a.623.623 0 00-.091-.11l-.035-.036a5.537 5.537 0 01-.093-.095c-.315-.314-2.34-1.805-3.436-2.528-.358-.236-.76-.331-.999-.331h-3.54l1.295-.89c.1-.076.149-.134.149-.256a.332.332 0 00-.142-.276L6.364 2.399H5.4l1.702 1.434-1.7 1.166h.001H1v6h12.612c.196 0 .38-.098.488-.263.49-.755.9-1.41.9-1.902 0-.277-.095-.529-.25-.735zm-2.537-.508c-.046.136-.173.172-.317.172h-.666c-.071 0-.185.01-.284-.063l-.95-.671a.332.332 0 01.2-.599h.666c.072 0 .142.024.2.068l1.034.778c.115.086.162.18.117.315z"
  }));
}

function TramIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: (!props.color ? 'eds-icon eds-icon__tram ' : 'eds-icon') + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || '#642e88'
  }), /*#__PURE__*/createElement("path", {
    fill: "#642E88",
    fillRule: "evenodd",
    d: "M14.062 5.272a.35.35 0 00-.341-.273H8.566l1.289-.89c.1-.075.149-.133.149-.255a.332.332 0 00-.142-.276L8.368 2.399h-.964l1.701 1.434-1.7 1.166H2.28a.35.35 0 00-.341.273L1.009 9.38a.451.451 0 00.074.35l.812 1.124a.35.35 0 00.283.145h11.643a.35.35 0 00.284-.145l.812-1.123a.451.451 0 00.074-.351l-.929-4.108zM3.75 8.182a.35.35 0 01-.35.35H2.35a.35.35 0 01-.342-.426l.31-1.4a.35.35 0 01.34-.275H3.4a.35.35 0 01.35.35v1.4zm3.5 0a.35.35 0 01-.35.35H4.799a.35.35 0 01-.35-.35V6.78a.35.35 0 01.35-.35h2.1a.35.35 0 01.35.35v1.4zm3.51 0a.35.35 0 01-.35.35h-2.1a.35.35 0 01-.35-.35V6.78a.35.35 0 01.35-.35h2.1a.35.35 0 01.35.35v1.4zm3.073.219a.35.35 0 01-.272.131H11.81a.35.35 0 01-.35-.35V6.781a.35.35 0 01.35-.35H13.251a.35.35 0 01.342.275l.309 1.4a.347.347 0 01-.07.295z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "#642E88",
    fillRule: "evenodd",
    d: "M2 11.999h12v1H2z",
    clipRule: "evenodd"
  }));
}

function WalkingIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M8.663 3.5a1.25 1.25 0 110-2.499 1.25 1.25 0 010 2.499z"
  }), /*#__PURE__*/createElement("path", {
    d: "M5.92 11.39l-.048.102-1.744 2.55a.6.6 0 10.963.716l1.905-2.297c.06-.104.116-.206.175-.31l.519-1.485-1.205-1.153-.564 1.878z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.791 7.79l-2.026-1.244a.203.203 0 01-.064-.063l-.98-1.702a1 1 0 00-.644-.438l-1.44-.29a1 1 0 00-.797.18L5.04 5.582a1 1 0 00-.288.34L3.671 8.017a.428.428 0 00.724.456l1.293-1.996a.197.197 0 01.063-.061l1.088-.666-.309 1.533a2.294 2.294 0 00.596 2.043l2.276 2.288.045.07 1.115 2.912a.6.6 0 101.137-.384l-.805-2.874-.155-.32-1.854-2.545a.347.347 0 01-.06-.272l.374-1.857.687.871a1 1 0 00.348.28l2.12 1.03a.428.428 0 00.437-.735z"
  })));
}

function AdditionalZonesTicketIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 2.5c.351 0 .636.283.636.632v3.195a.634.634 0 01-.636.632c-.635 0-1.1.453-1.1 1.061s.465 1.06 1.1 1.06c.351 0 .636.284.636.633v3.155a.634.634 0 01-.636.632H1.636A.634.634 0 011 12.868V9.713c0-.35.285-.632.636-.632l.125-.006c.57-.055.975-.488.975-1.055 0-.608-.465-1.06-1.1-1.06l-.094-.008A.633.633 0 011 6.327V3.132c0-.35.285-.632.636-.632h12.728zm-.637 1.263H2.273v2.014l.122.034a2.29 2.29 0 011.608 2.053l.005.156a2.293 2.293 0 01-1.613 2.209l-.122.034v1.973h11.454v-1.973l-.122-.034a2.29 2.29 0 01-1.608-2.053l-.005-.156c0-1.049.665-1.907 1.613-2.209l.122-.034V3.763zM8.5 5.67V7.5h1.83v.998H8.5v1.83h-.998V8.5H5.67v-.998H7.5V5.67h.998z",
    clipRule: "evenodd"
  }));
}

function CabinIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.557 1.166a.657.657 0 01.873 0l5.437 4.833c.14.124.22.303.22.49v7.854a.657.657 0 01-.656.657H9.806a.657.657 0 01-.657-.657v-3.572H6.84v3.572a.657.657 0 01-.568.651L6.18 15H2.558a.657.657 0 01-.657-.657V6.49c0-.188.08-.367.22-.491l5.437-4.833zm.437 1.369l-4.78 4.249v6.902h2.31v-3.572c0-.332.248-.607.568-.65l.09-.007h3.624c.363 0 .657.295.657.657v3.572h2.31V6.785l-4.78-4.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 10.55v-1.1h10v1.1H3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 8.55v-1.1h10v1.1H3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 6.55v-1.1h10v1.1H3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 4.55v-1.1h6v1.1H5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 12.55v-1.1h3.333v1.1H3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 12.55v-1.1h4v1.1h-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.95 6V2h1.1v4h-1.1z",
    clipRule: "evenodd"
  }));
}

function CityIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.624 14.872A.624.624 0 011 14.248V1.764c0-.345.28-.624.624-.624H9.57c.344 0 .624.28.624.624l-.001 6.733 4.184.02c.316 0 .577.235.618.54L15 9.14v5.107a.624.624 0 01-.54.619l-.084.005H1.624zm8.568-5.126v3.878h3.56v-3.86l-3.56-.018zM8.944 2.388H2.248v11.236h2.724v-1.135h1.249l-.001 1.135h2.724V2.388zM5.086 10.22v1.249H3.27v-1.249h1.816zm2.837 0v1.249H6.107v-1.249h1.816zM5.086 7.95v1.249H3.27V7.949h1.816zm2.837 0v1.249H6.107V7.949h1.816zM5.086 5.68v1.25H3.27v-1.25h1.816zm2.837 0v1.25H6.107v-1.25h1.816zM5.086 3.41v1.25H3.27v-1.25h1.816zm2.837 0v1.25H6.107v-1.25h1.816z",
    clipRule: "evenodd"
  }));
}

function ConductorIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.827 1.37c.115-.02.231-.02.346 0l2.6.433c.506.085.877.523.877 1.036V4.1c0 .37-.19.694-.479.881.211.45.329.953.329 1.484 0 1.178-.582 2.22-1.474 2.854 2.458.798 4.28 3.009 4.474 5.681H13c-.228-2.392-1.931-4.31-4.263-4.648l-.097.251a.596.596 0 01-.306.323.418.418 0 01.054.126l.576 2.304a.4.4 0 01-.03.276l-.576 1.152a.4.4 0 01-.716 0l-.576-1.152a.4.4 0 01-.03-.276l.576-2.304a.418.418 0 01.054-.126.596.596 0 01-.306-.323l-.097-.25C4.932 10.688 3.228 12.607 3 15H1.5c.203-2.664 2.023-4.879 4.476-5.68a3.496 3.496 0 01-1.22-4.17H3.5v-1.3h.85V2.839c0-.513.371-.951.877-1.036l2.6-.433zm.933 3.78h1.004a2.2 2.2 0 11-3.529 0H7.24a.998.998 0 001.52 0zm0-1.3a.998.998 0 00-1.52 0H5.65v-.8L8 2.66l2.35.392v.799H8.76z",
    clipRule: "evenodd"
  }));
}

function CorrespondenceIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.943 2.5L5 3.443l4.291 4.29L5 12.023l.943.944 4.762-4.762a.667.667 0 00.07-.86l-.07-.083L5.943 2.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.043 2.5l-.943.943 4.291 4.29-4.291 4.29.943.944 4.762-4.762a.667.667 0 00.07-.86l-.07-.083L10.043 2.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.943 2.5L1 3.443l4.291 4.29L1 12.023l.943.944 4.762-4.762a.667.667 0 00.07-.86l-.07-.083L1.943 2.5z",
    clipRule: "evenodd"
  }));
}

function DestinationIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 12 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.243 0c.496 0 .807.516.606.946l-.047.084L9.71 4.244l2.092 3.216a.667.667 0 01-.463 1.023l-.096.007h-9.81V14H.1V.667C.1.329.35.05.676.007L.766 0h10.477zm-1.23 1.333h-8.58v5.823h8.581L8.356 4.61a.667.667 0 01-.047-.642l.047-.086 1.657-2.548z",
    clipRule: "evenodd"
  }));
}

function EnvironmentIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.249 1.009a.645.645 0 01.745.722 9.035 9.035 0 01-.021.148l-.11.648a29.9 29.9 0 01-.195.982 27.261 27.261 0 01-1.134 3.894c-.697 1.834-1.55 3.33-2.593 4.372-.449.45-.925.818-1.425 1.11-1.751 1.02-3.609 1.043-5.332.474a7.248 7.248 0 01-.463-.17L1.912 15 1 14.088l1.804-1.804a7.004 7.004 0 01-.174-.456c-.622-1.805-.566-3.761.635-5.597a7.36 7.36 0 01.96-1.172c1.01-1.01 2.57-1.86 4.54-2.585a32.29 32.29 0 013.766-1.11c.224-.052.44-.1.647-.145l.592-.122.479-.088zm-.685 1.446l-.74.165a31.031 31.031 0 00-3.613 1.065C7.4 4.35 5.987 5.12 5.137 5.97a6.072 6.072 0 00-.792.966c-.955 1.458-.999 3.01-.495 4.471l-.043-.128 4.287-4.286.912.912-4.273 4.274c1.36.415 2.793.372 4.133-.41a5.728 5.728 0 001.163-.907c.892-.892 1.661-2.24 2.3-3.918a26.002 26.002 0 001.078-3.709c.048-.221.092-.435.131-.64l.026-.141z",
    clipRule: "evenodd"
  }));
}

function GoalIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M5.818 2.312L14 6.25l-8.182 3.937v3.938c0 .525-.363.875-.909.875S4 14.65 4 14.125V1.875C4 1.35 4.364 1 4.91 1s.908.35.908.875v.437z"
  }));
}

function GymIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 4a1 1 0 00-2 0v2a1 1 0 00-2 0v4a1 1 0 102 0v2a1 1 0 102 0V8.7h6V12a1 1 0 102 0v-2a1 1 0 102 0V6a1 1 0 10-2 0V4a1 1 0 10-2 0v3.3H5V4z",
    clipRule: "evenodd"
  }));
}

function HomeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.557 1.166a.657.657 0 01.873 0l5.437 4.833c.14.124.22.303.22.49v7.854a.657.657 0 01-.656.657H9.806a.657.657 0 01-.657-.657v-3.572H6.84v3.572a.657.657 0 01-.568.651L6.18 15H2.558a.657.657 0 01-.657-.657V6.49c0-.188.08-.367.22-.491l5.437-4.833zm.437 1.369l-4.78 4.249v6.902h2.31v-3.572c0-.332.248-.607.568-.65l.09-.007h3.624c.363 0 .657.295.657.657v3.572h2.31V6.785l-4.78-4.25z",
    clipRule: "evenodd"
  }));
}

function InternationalIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 110 14A7 7 0 018 1zM6.798 2.4l-.082.017c-.46.106-.9.267-1.312.476.188.216.36.458.522.73.62 1.04.91 2.195.263 3.03-.248.322-.563.544-1.076.811L4.5 7.77l-.207.109c-.09.05-.16.093-.214.132l-.055.043.013.028c.039.074.12.189.26.363l.525.621c.09.11.167.212.235.313.674.995.582 2.055.02 2.997a2.38 2.38 0 01-.277.372A5.727 5.727 0 0012.8 4.876c-1.077.443-2.493.828-3.02.866-.58.042-.967-.204-1.284-.692l-.359-.603-.091-.147a2.627 2.627 0 00-.23-.295l-.445-.518-.061-.076c-.29-.364-.466-.676-.513-1.011zm3.235 3.75c1.444 0 2.643 1.033 2.661 2.364.03 2.15-2.66 4.817-4.356 4.125-.885-.361-1.02-.768-.949-2.015l.012-.193.018-.289c.03-.556.02-.995-.043-1.546-.157-1.355 1.16-2.445 2.657-2.445zM4.33 3.603A5.721 5.721 0 002.273 8c0 1.518.59 2.898 1.554 3.923.064-.066.116-.133.156-.2.332-.556.379-1.1.02-1.63a3.333 3.333 0 00-.17-.226l-.481-.565c-.471-.566-.616-.843-.616-1.302 0-.594.33-.913 1.033-1.286l.351-.177.226-.11.28-.145c.29-.158.461-.283.557-.407.198-.256.015-.988-.35-1.6a3.661 3.661 0 00-.503-.673zm5.703 3.822c-.81 0-1.45.53-1.393 1.026.085.733.084 1.296.031 2.068-.05.723-.062.835.055.901l.026.014.067.028c.721.294 2.62-1.59 2.602-2.93-.007-.593-.605-1.107-1.388-1.107zM8.239 2.53l.07.09c.065.082.137.167.248.295l.256.295c.13.153.19.232.26.335l.131.205.36.605c.072.11.07.12.102.119l.024-.002c.335-.025 1.36-.298 2.252-.627A5.705 5.705 0 008 2.273h.077c.026.057.078.144.162.258z",
    clipRule: "evenodd"
  }));
}

function InterrailIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.736 1.58a2.95 2.95 0 012.95 2.95l-.001 1.678h.522c.945 0 1.72.731 1.788 1.66L15 8v5.786c0 .322-.24.588-.55.63l-.086.006H1.636a.636.636 0 01-.63-.55L1 13.787V8c0-.945.731-1.72 1.66-1.788l.133-.005h.521V4.53a2.95 2.95 0 012.777-2.945l.173-.005h3.472zm3.47 5.9h-.521v5.67h1.042V8.001a.52.52 0 00-.436-.513l-.084-.007zm-9.892 0h-.52a.52.52 0 00-.514.437l-.007.084v5.149h1.041V7.48zm6.589 2.31l-.167.005-1.1-.001v1.158H7.364l-.001-1.158H6.264a2.937 2.937 0 01-1.678-.523v3.879h6.827V9.272c-.433.3-.95.487-1.51.518zm-.167-6.937H6.264c-.926 0-1.677.75-1.677 1.677v2.314c0 .88.678 1.603 1.54 1.673l.137.005h1.099V7.365h1.273v1.157h1.1c.88 0 1.602-.678 1.672-1.54l.005-.138V4.53c0-.88-.678-1.602-1.54-1.672l-.137-.005z",
    clipRule: "evenodd"
  }));
}

function InvalidTicketIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 2.5c.351 0 .636.283.636.632v3.195a.634.634 0 01-.636.632c-.635 0-1.1.453-1.1 1.061s.465 1.06 1.1 1.06c.351 0 .636.284.636.633v3.155a.634.634 0 01-.636.632H1.636A.634.634 0 011 12.868V9.713c0-.35.285-.632.636-.632l.125-.006c.57-.055.975-.488.975-1.055 0-.608-.465-1.06-1.1-1.06l-.094-.008A.633.633 0 011 6.327V3.132c0-.35.285-.632.636-.632h12.728zm-.637 1.263H2.273v2.014l.122.034a2.29 2.29 0 011.608 2.053l.005.156a2.293 2.293 0 01-1.613 2.209l-.122.034v1.973h11.454v-1.973l-.122-.034a2.29 2.29 0 01-1.608-2.053l-.005-.156c0-1.049.665-1.907 1.613-2.209l.122-.034V3.763zM9.294 6.004L10 6.71 8.706 8.004 10 9.298l-.706.706L8 8.71l-1.294 1.295L6 9.298l1.294-1.294L6 6.71l.706-.706L8 7.298l1.294-1.294z",
    clipRule: "evenodd"
  }));
}

function LuggageIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 1v1.333h-.546v11.455c0 .337-.25.616-.576.66l-.09.007-.546-.001V15H11.91v-.546H3.545V15H2.212v-.546h-.545v-1.333H13.12V1.667c0-.338.251-.617.576-.66l.09-.007H15zM8.333 1c.338 0 .617.25.66.576l.007.09-.001 1.758h2.365c.334 0 .611.247.66.568l.006.099v7.273a.667.667 0 01-.666.666H1.667A.667.667 0 011 11.364V4.09c0-.368.298-.667.667-.667H4.03V1.667c0-.338.251-.617.577-.66L4.697 1h3.636zm2.363 6.181H2.333v3.515h8.363V7.181zm0-2.424H2.333v1.091h8.363v-1.09zm-3.03-2.424H5.364v1.091h2.303v-1.09z",
    clipRule: "evenodd"
  }));
}

function MapIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.29c1.73 0 3.246 1.232 3.494 3.012l2.715-.679a.637.637 0 01.785.53L15 4.24v8.678c0 .26-.157.49-.39.587l-.092.03-4.628 1.157a.636.636 0 01-.268.01l-.088-.023L6.24 13.58l-4.45 1.112a.637.637 0 01-.784-.53L1 14.075V5.397c0-.26.157-.49.39-.587l.092-.03 3.078-.77C4.924 2.388 6.366 1.29 8 1.29zm5.727 3.765l-2.324.582a5.733 5.733 0 01-.505 1.163c-.253.457-.573.934-.945 1.424a19.44 19.44 0 01-1.307 1.542l-.194.202a.636.636 0 01-.904 0 10.573 10.573 0 01-.194-.202l-.279-.304c-.35-.39-.7-.807-1.028-1.238-.372-.49-.692-.967-.945-1.424-.292-.526-.49-1.015-.579-1.469l-2.25.563v7.365l3.837-.958a.636.636 0 01.268-.009l.088.022 3.295 1.099 3.966-.992V5.055zM8 2.563c-1.218 0-2.256.935-2.256 2.256 0 .335.162.806.471 1.364.221.398.508.827.845 1.27.305.402.633.793.961 1.157L8 8.585l.306-.347c.108-.127.216-.256.322-.387l.312-.397c.337-.444.624-.873.845-1.271.31-.558.471-1.03.471-1.364 0-1.32-1.038-2.256-2.256-2.256zm0 1.182a.991.991 0 110 1.982.991.991 0 010-1.982z",
    clipRule: "evenodd"
  }));
}

function MapPinIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c2.946 0 5.485 2.289 5.485 5.485 0 .906-.358 1.947-1.004 3.112a19.78 19.78 0 01-1.55 2.334 32.169 32.169 0 01-2.262 2.655l-.217.226a.636.636 0 01-.904 0l-.348-.364-.43-.469a32.168 32.168 0 01-1.701-2.048 19.78 19.78 0 01-1.55-2.334c-.646-1.165-1.004-2.206-1.004-3.112C2.515 3.289 5.055 1 8 1zm0 1.273c-2.27 0-4.212 1.75-4.212 4.212 0 .648.293 1.502.844 2.495a18.55 18.55 0 001.45 2.181 30.915 30.915 0 001.633 1.967l.285.311.284-.311a30.914 30.914 0 001.633-1.967 18.55 18.55 0 001.45-2.181c.552-.993.845-1.847.845-2.495 0-2.462-1.942-4.212-4.212-4.212zM8 5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    clipRule: "evenodd"
  }));
}

function MountainIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 1.45a.55.55 0 01.508.338l1.916 4.599L9.979 5A.55.55 0 0111 5l3.51 8.795a.55.55 0 01-.51.754H2a.55.55 0 01-.508-.761l5-12A.55.55 0 017 1.449zm5.367 12l-2.339-5.613.461-1.152 2.699 6.764h-.821zM8.81 7.774l2.364 5.674h-8.35l2.226-5.341.438 1.097a.55.55 0 001.003.041L7.15 7.93l.46.46a.55.55 0 00.847-.084l.353-.53zm-.509-1.22L7 3.43 5.655 6.657l.4 1.002.453-.905a.55.55 0 01.88-.143l.526.526.388-.582z",
    clipRule: "evenodd"
  }));
}

function PlaygroundIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.905 10.186a.757.757 0 100-1.514.757.757 0 000 1.514zm0 1.1a1.857 1.857 0 100-3.714 1.857 1.857 0 000 3.714z",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.151 1.507a.55.55 0 00-.492 0L3.707 3.983a.55.55 0 00.246 1.042H5.26v4.15l-1.82 1.56H2a.55.55 0 00-.55.55v3.095c0 .303.246.55.55.55h1.643a.55.55 0 00.358-.133l1.259-1.079v1.28h1.1v-1.925h5.09v1.925h1.1V13.39l.9.45V15h1.1v-1.5a.55.55 0 00-.304-.492l-1.696-.848V5.025h1.307a.55.55 0 00.247-1.042L9.15 1.507zm-5.15 10.195l1.259-1.079v1.647l-1.82 1.56h-.89v-1.995h1.093a.55.55 0 00.358-.133zm7.45.27H6.36V6.884h5.09v5.09zm0-6.189H6.36v-.758h5.09v.758zm0-1.896L8.904 2.614 6.36 3.887v.038h5.09v-.038z",
    clipRule: "evenodd"
  }));
}

function PositionIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/createElement("path", {
    d: "M14.975 1.862l-.018.055.005-.015a.672.672 0 00.013-.04z"
  }), /*#__PURE__*/createElement("path", {
    d: "M14.993 1.774a.672.672 0 00-.183-.562L14.8 1.2a.672.672 0 00-.574-.194l-.012.002-.01.001a.694.694 0 00-.121.033L1.445 5.7l-.099.045a.681.681 0 00.03 1.203l5.117 2.559 2.56 5.118a.68.68 0 001.248-.07l4.656-12.637a.657.657 0 00.032-.12l.004-.023zM9.567 12.608L7.488 8.48l-4.097-2.05 9.777-3.6-3.6 9.777z"
  })));
}

function PrioritySeatPregnantIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 10 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.363 3.079c.7-.142 1.384.299 1.529.986l.253 1.202c.085-.01.17-.017.254-.02 1.385 0 2.508 1.104 2.508 2.465 0 .22-.04.44-.102.654l.5-.001c.524 0 .963.368 1.045.877l.642 3.986a.668.668 0 01-.565.763.677.677 0 01-.777-.554L8.049 9.7H4.476a1.32 1.32 0 01-1.308-1.082l-.791-3.954v-.001l-.018-.083a1.271 1.271 0 011.004-1.501zm-2.01-.01l1.231 6.484a.994.994 0 00.863.798l.119.007h3.933l.001 1.311H3.566a2.325 2.325 0 01-2.253-1.712l-.036-.16L0 3.068h1.353zM3.27 0a1.34 1.34 0 11.001 2.68 1.34 1.34 0 010-2.68z",
    clipRule: "evenodd"
  }));
}

function PrioritySeatSeniorsIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 12 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.997 6.977v-.003a.964.964 0 00-.963-.965.965.965 0 00-.982.946v.429c-.003.15.119.276.273.279a.277.277 0 00.284-.268v-.422c0-.227.186-.41.416-.41.23 0 .416.183.416.41l.002.009v6.738a.276.276 0 00.274.278.276.276 0 00.283-.27V6.978h-.003zm-8.431 3.55l-.119-.005a.994.994 0 01-.862-.797L1.354 3.24H0l1.277 6.725.036.161a2.323 2.323 0 002.253 1.714H7.5l-.001-1.313H3.566zM8.17 8.454H5.704l1.303-4.188 4.34.878a.512.512 0 00.608-.393.506.506 0 00-.4-.596L5.89 3.008c-.054-.006-.207-.006-.207-.006-.544 0-1.046.336-1.212.873L3.14 8.147c-.205.66.172 1.359.844 1.561.082.024.293.06.425.06h3.509l.591 3.677a.665.665 0 00.765.546.657.657 0 00.555-.75L9.2 9.315a1.03 1.03 0 00-1.028-.863M6.68 2.68A1.34 1.34 0 106.68 0a1.34 1.34 0 00-.001 2.68",
    clipRule: "evenodd"
  }));
}

function SkiIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.35 0l.274.255C5.668.296 6.7 1.28 6.7 3.051L6.75 14H4V3.05C4 1.28 5.032.297 5.076.256L5.35 0zm3.408 0l.273.255c.044.041 1.077 1.025 1.077 2.796L10.158 14h-2.75V3.05c0-1.77 1.031-2.754 1.076-2.795L8.758 0zm.575 9.109a1.35 1.35 0 01-1.123.003v4.087h1.142l-.019-4.09zm-3.407 0a1.35 1.35 0 01-1.124.003v4.087h1.142l-.018-4.09zM1.956 1L1.95 11.45h.66v.802l-.661-.001v.81h-.802l-.001-.81H.49v-.8l.657-.001.005-7.05C.538 4.29.067 3.852.006 3.315L0 3.198l.001-.97c0-.629.564-1.147 1.288-1.218l.146-.008L1.437 1h.518zM12.564.968c.744.012 1.354.492 1.428 1.106l.007.124v.969c0 .55-.431 1.017-1.023 1.173l-.129.03v7.048h.66v.802h-.66v.81h-.802v-.81h-.658v-.801h.658V.968h.519zM5.36 6.752a.559.559 0 00-.559.548v.583l.007.08a.56.56 0 001.11-.09l-.001-.411-.001-.161-.006-.08a.558.558 0 00-.55-.469zm3.408 0a.559.559 0 00-.56.548l.001.583.007.08a.56.56 0 001.11-.09l-.001-.19-.002-.396-.005-.067a.558.558 0 00-.55-.468zM5.35 1.181c-.24.357-.548.988-.548 1.87v3.021a1.354 1.354 0 011.111-.003l-.015-3.018c0-.882-.308-1.513-.548-1.87zm3.408 0c-.24.357-.548.988-.548 1.87v3.02a1.354 1.354 0 011.11-.002L9.306 3.05c0-.882-.309-1.513-.548-1.87zm-7.604.68c-.174.063-.308.173-.342.303l-.009.066v.968c0 .135.107.256.266.335l.084.035V1.86zm11.694-.033v1.709c.201-.075.35-.213.35-.37v-.969c0-.156-.149-.294-.35-.37z",
    clipRule: "evenodd"
  }));
}

function SuitcaseIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 12",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.726 12C.325 12 0 11.697 0 11.323V3.58c0-.374.325-.678.726-.678h3.266V.677c0-.343.274-.626.628-.67L4.719 0H9.28c.368 0 .672.255.72.585l.006.092v2.226h3.267c.368 0 .671.255.72.586L14 3.58v7.742c0 .374-.325.677-.726.677H.726zM2.28 4.258h-.83v6.387h.83V4.258zm7.985 0H3.733v6.387h6.533V4.258zm2.282 0h-.83v6.387h.83V4.258zM8.555 1.355h-3.11l-.001 1.548h3.111V1.355z",
    clipRule: "evenodd"
  }));
}

function TrackIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M11.492 9.466H4.538l-.445 1.494h7.844l-.445-1.494zm1.611 0l.445 1.494h.705a.747.747 0 010 1.493h-.26l.166.562c.156.373-.155.821-.544.896-.389.15-.778-.075-.933-.448l-.301-1.01H3.649l-.3 1.01c-.156.373-.545.597-1.012.523-.389-.15-.622-.523-.544-.896l.19-.637h-.236a.747.747 0 010-1.493h.68l.444-1.494h-.347a.747.747 0 010-1.493h.791L3.76 6.48h-.458a.747.747 0 010-1.493h.902l.7-2.35c.155-.448.544-.672 1.01-.598a.85.85 0 01.545.97l-.588 1.978h4.288L9.57 3.01a.85.85 0 01.545-.97c.389-.15.855.149.933.522l.722 2.425h.928a.747.747 0 010 1.493h-.484l.445 1.493h.817a.747.747 0 010 1.494h-.373zm-2.055-1.493l-.445-1.493H5.427l-.445 1.493h6.066z"
  }));
}

function UniversityIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    fill: "none",
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.695 1.542a.55.55 0 01.61 0l6 4A.55.55 0 0114 6.549h-.35v7.4H15v1.1H1v-1.1h1.35v-7.4H2a.55.55 0 01-.305-1.007l6-4zm4.655 12.407v-7.4h-1.2v7.4h1.2zm-3.7-7.4h1.2v7.4h-1.2v-7.4zm-2.5 0h1.2v7.4h-1.2v-7.4zm-1.3 0h-1.2v7.4h1.2v-7.4zm7.333-1.1L8 2.66 3.816 5.45h8.367z",
    clipRule: "evenodd"
  }));
}

function ValidTicketIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 2.5c.351 0 .636.283.636.632v3.195a.634.634 0 01-.636.632c-.635 0-1.1.453-1.1 1.061s.465 1.06 1.1 1.06c.351 0 .636.284.636.633v3.155a.634.634 0 01-.636.632H1.636A.634.634 0 011 12.868V9.713c0-.35.285-.632.636-.632l.125-.006c.57-.055.975-.488.975-1.055 0-.608-.465-1.06-1.1-1.06l-.094-.008A.633.633 0 011 6.327V3.132c0-.35.285-.632.636-.632h12.728zm-.637 1.263H2.273v2.014l.122.034a2.29 2.29 0 011.608 2.053l.005.156a2.293 2.293 0 01-1.613 2.209l-.122.034v1.973h11.454v-1.973l-.122-.034a2.29 2.29 0 01-1.608-2.053l-.005-.156c0-1.049.665-1.907 1.613-2.209l.122-.034V3.763zM10.236 6l.69.768-3.443 3.1a.517.517 0 01-.613.057l-.078-.058-1.722-1.55.691-.767 1.376 1.238L10.236 6z",
    clipRule: "evenodd"
  }));
}

function ZoneIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M3.226 6.335c-.174.114-.34.235-.496.361a6.113 6.113 0 00-.062.05v.001l-.005.004-.01.008a5.595 5.595 0 00-.009.008l-.004.003a5.165 5.165 0 00-.01.008l-.004.004-.005.004-.005.004-.004.004-.005.004-.004.004h-.001l-.009.008-.004.004h-.001l-.004.004-.004.004h-.002c0 .002-.002.003-.003.004l-.005.004-.004.004h-.001a1.762 1.762 0 01-.004.004l-.005.004-.004.003-.001.002c-.002 0-.003.002-.004.003l-.004.004H2.54a.173.173 0 00-.004.004l-.004.004-.001.001-.003.003h-.001l-.003.003-.001.001-.004.004-.002.001-.002.002-.002.002-.003.003-.002.001-.002.003-.002.001-.003.002-.001.002c-.002 0-.003.002-.004.003l-.002.002-.002.002-.002.001-.002.003-.002.001-.003.003a.423.423 0 00-.004.004l-.002.001-.002.002-.003.003-.003.002a.451.451 0 00-.004.004l-.001.001-.004.003-.002.002-.002.002-.002.002a.3.3 0 00-.006.006l-.003.003h-.002c0 .002-.001.002-.002.003l-.001.001-.005.004-.001.001-.003.003a5.414 5.414 0 00-.01.009l-.003.003-.006.006-.003.003h-.001l-.003.003-.006.006-.003.003-.01.009-.003.003a5.725 5.725 0 00-.02.018l-.002.003h-.001l-.009.01-.003.002a4.668 4.668 0 00-1.084 1.536l1.203.51c.26-.615.771-1.186 1.477-1.652l-.72-1.09z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M2.293 10.352L1 10.535a3.665 3.665 0 00.054.294l.006.027.003.012.004.016.002.011.003.012.003.011.001.004.003.012.003.011.003.012.001.004.003.011a5.234 5.234 0 00.006.023l.001.004.002.008.002.003v.001a4.794 4.794 0 00.006.022v.001l.001.003v.001l.002.007.001.004.004.011v.001l.003.01v.001l.001.004.003.007v.004h.001l.003.011v.001l.004.01v.005h.001a2.172 2.172 0 00.002.008l.001.003v.001l.004.01v.001l.004.01v.005h.001l.002.007.002.004a1.444 1.444 0 01.003.011v.001l.004.01v.001l.001.004.004.011.004.011v.001l.004.01v.001l.001.004.003.007v.004h.001a4.825 4.825 0 00.004.012l.004.01v.001l.001.003v.001l.003.007.001.003v.002l.004.01.002.004.002.007.002.004v.001l.002.006.002.004v.001l.004.01v.001l.004.01v.001l.002.003v.002l.003.006.001.004.004.01v.002l.002.003c0 .003.002.005.003.007l.001.004a.076.076 0 00.003.007l.001.004.001.001.004.01v.001l.002.003.002.007v.001l.002.003v.001a1.922 1.922 0 00.003.007l.001.003v.001l.005.01v.001l.002.003v.001l.002.006v.001l.002.003v.002l.003.005v.001l.002.003v.001a4.3 4.3 0 00.005.011l.001.003.003.007v.001l.002.003v.002l.003.005v.001l.001.003v.002l.005.009v.002l.002.002v.002l.003.005v.001l.002.003v.001l.002.006.001.001.001.003a.115.115 0 00.005.01v.002l.002.003.003.007v.001l.002.003v.001l.003.006.002.004v.001l.005.01.002.004.003.006a.106.106 0 00.002.005l.003.006v.002l.002.002v.002l.005.01.005.01v.001l.002.003v.002l.003.005v.001l.002.003v.001l.005.01a.132.132 0 01.002.004l.003.006v.002l.002.003.003.006.001.001.001.003.001.002.005.009v.001l.002.003c0 .003.002.005.003.007v.001l.002.003v.001l.003.005v.002l.002.002.001.002.003.006.002.003v.002l.002.002v.001l.003.006v.001l.002.003v.001l.004.005v.002a.462.462 0 01.002.004l.003.006.002.003v.002l.006.009v.001l.002.003v.001l.003.006.002.004h.001l.003.007.002.003v.002l.002.002v.001l.004.006v.001l.002.003v.001l.003.005.001.002.001.003h.001l.003.007.002.003a.145.145 0 01.007.012.534.534 0 00.005.009v.001l.002.003v.002l.006.009v.001l.006.01c0 .002.001.002.002.003v.001l.004.006v.001l.002.003v.001l.006.01.006.01v.001l.002.003v.001l.004.006.002.003v.001l.006.01v.001l.006.01.002.003.001.001.003.006a.484.484 0 00.003.005l.003.005.001.001.001.003.002.002.001.002a.193.193 0 00.004.006v.002a.544.544 0 00.003.004l.003.005v.001l.002.003.001.001.004.006.002.003v.001l.006.01.002.004h.001l.003.006.001.001.002.003v.001l.006.01c.003.003.005.007.006.01h.001a.541.541 0 00.006.01l.003.004.006.01v.001l.006.01h.001c0 .002.001.002.002.003v.001l.004.006.002.004h.001l.006.01v.001l.007.01.002.003.004.007.003.003v.001l.007.01a4.58 4.58 0 00.007.01l.002.004.004.006.003.004.006.01a2.872 2.872 0 00.008.011l.002.003.004.007.003.003v.001l.007.01.007.01.007.01.002.004.007.01a5.196 5.196 0 00.01.014l.004.006.003.004.007.01a2.931 2.931 0 00.008.01l.006.01a.043.043 0 01.003.003v.001l.007.01.008.01a.775.775 0 01.002.003l.005.007.003.003.007.01.007.01a4.832 4.832 0 00.025.034l.008.01.003.003.007.01.008.01.008.01.01.014.008.01c.175.225.374.439.595.64l.882-.962c-.588-.54-.946-1.16-1.036-1.796z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M4.675 13.035l-.559 1.18a8.37 8.37 0 00.87.351l.03.01.004.002h.001l.004.002h.001a8.47 8.47 0 00.029.01h.004v.001l.005.001.005.002.024.008.005.001.004.002h.002l.004.002.005.001.024.008.004.001h.002l.003.002h.002l.004.002.005.001.018.006h.002l.003.002h.002l.003.001h.002l.003.002h.002l.004.001.001.001.004.001h.002a6.774 6.774 0 00.016.006h.002l.003.001.003.001h.002l.003.002h.002l.003.001.003.001.003.001h.002l.005.002.006.002.005.001.002.001.003.001h.002l.003.002h.003l.003.001h.002l.003.002h.002l.004.002h.001a2.323 2.323 0 00.008.002l.003.001h.002l.003.002h.003l.003.001.002.001h.003l.002.002h.004l.002.001.003.001h.002l.01.004h.002l.004.001h.002l.003.002h.002l.004.001.002.001a4.994 4.994 0 00.005.002h.004l.001.001.005.001.011.004h.002l.004.001h.001l.004.002h.002l.004.001h.001a2.99 2.99 0 00.006.002l.005.002.017.005.005.001h.001l.005.002h.001l.004.001h.001l.005.002.017.005h.001l.005.001h.001l.004.002h.002l.004.001h.001l.005.002.029.008.005.001.006.002c.472.126.967.217 1.48.268l.13-1.3a7.595 7.595 0 01-2.467-.665z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M11.346 13.023c-.73.35-1.582.583-2.463.674l.135 1.3h.004l.003-.001a3.627 3.627 0 00.011-.001h.002l.004-.001h.008l.004-.001h.006l.002-.001h.006l.005-.001a.338.338 0 01.013-.002h.001a6.905 6.905 0 01.007 0l.003-.001h.006l.003-.001h.006l.003-.001h.007l.001-.001h.008l.004-.001h.002l.004-.001h.006l.002-.001h.006l.004-.001a.638.638 0 00.006 0l.002-.001h.005l.006-.001h.002l.004-.001h.006l.002-.001h.006l.004-.001h.002l.003-.001h.006l.004-.001h.004l.002-.001h.006l.004-.001h.002l.004-.001h.006l.002-.001h.006l.004-.001h.002l.005-.001h.002l.004-.001h.006l.002-.001h.006l.004-.001h.002l.004-.001h.002l.004-.001h.002l.011-.002h.008l.004-.001h.002l.004-.001h.002l.004-.001h.006l.002-.001.011-.002h.008l.004-.001h.002l.004-.001h.002l.004-.001h.006l.001-.001h.006l.012-.003h.008l.004-.001h.001l.005-.001h.001a6.885 6.885 0 00.01-.002h.002l.012-.002h.005l.002-.001h.006l.004-.002h.008a4.103 4.103 0 00.005-.002h.006l.012-.002.006-.001h.001l.005-.001h.002l.004-.001h.006l.001-.001.005-.001.019-.003h.005l.001-.001h.005l.002-.001h.005l.005-.002h.001a8.732 8.732 0 00.03-.005h.007l.004-.002h.007l.018-.004h.006l.001-.001h.005v-.001h.005l.002-.001.005-.001a2.921 2.921 0 00.024-.004l.006-.001.006-.001.005-.001h.002l.005-.001.018-.004h.006l.006-.002h.006l.006-.002.024-.004.006-.001.006-.002.03-.005.005-.001h.001l.005-.001.006-.002.036-.007a8.85 8.85 0 001.305-.36l.005-.002.005-.002.022-.008a17.301 17.301 0 00.01-.003h.001l.005-.002.005-.002h.001l.016-.007.005-.001.001-.001.004-.001h.001a1.621 1.621 0 00.01-.004l.005-.002a8.232 8.232 0 00.017-.007l.004-.001.002-.001.003-.001.002-.001.003-.001h.002l.004-.002a.449.449 0 01.005-.002h.001a5.7 5.7 0 00.01-.005h.002l.004-.002h.001l.004-.002h.002l.003-.001.002-.001.003-.001.002-.001.003-.002h.002l.004-.002.006-.002h.001l.004-.002h.002l.003-.002h.002l.003-.002h.002l.003-.002h.002l.003-.002h.002l.003-.002h.002l.002-.002.006-.002h.002l.002-.002h.003l.002-.002h.002l.003-.002h.002l.004-.002h.001l.003-.001.002-.001.003-.002.014-.005.004-.002h.001l.004-.002.005-.002.005-.001.027-.012.005-.002c.002 0 .003 0 .004-.002.141-.057.278-.118.412-.182l-.564-1.178z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M13.705 10.33c-.084.636-.436 1.259-1.02 1.8l.889.957a5.4 5.4 0 00.439-.456v-.001l.01-.013h.001l.008-.01.008-.01.011-.012a28.835 28.835 0 00.008-.01l.008-.01.008-.01.003-.003a5.62 5.62 0 00.015-.019l.001-.001.003-.003.004-.006h.001l.002-.004h.001l.005-.006.002-.003v-.001l.008-.009V12.5l.003-.003.004-.006h.001l.002-.003.002-.002.003-.004.001-.002.002-.002.001-.002.003-.003.002-.002c0-.001 0-.002.002-.003v-.001l.003-.003.001-.002.003-.003.001-.002.002-.002a2.87 2.87 0 01.004-.006l.002-.002.002-.002.001-.002.002-.002.002-.004.002-.002.002-.002.001-.002.003-.003.001-.002.002-.003.002-.001.002-.003c0-.001 0-.002.002-.003l.002-.002.001-.002.002-.003.001-.001a1.216 1.216 0 00.006-.008l.002-.002a9.263 9.263 0 00.004-.005c0-.001 0-.002.002-.003a.248.248 0 01.005-.007l.002-.003.001-.002.002-.002.001-.002.003-.004.001-.001.002-.003.002-.002.002-.004.002-.001c0-.001 0-.002.002-.003v-.001l.003-.004.001-.001.003-.004v-.001l.003-.003.001-.002.003-.004.003-.004.001-.001.003-.004v-.002c.002 0 .002-.002.003-.003l.001-.001.003-.004.003-.005h.001a.884.884 0 00.003-.005l.003-.004.001-.002.003-.003v-.001a1.55 1.55 0 01.003-.004l.001-.001.002-.004.001-.001.003-.004a.95.95 0 00.003-.005h.001l.003-.005.003-.005h.001l.003-.004v-.001l.003-.005.003-.004.001-.001.003-.004.003-.005.001-.001.003-.004.003-.005.003-.004v-.001l.004-.005.003-.004v-.001l.007-.01.003-.004.003-.005.001-.001.003-.004.003-.005.003-.005.007-.01a2.74 2.74 0 00.007-.01c0-.002.002-.003.003-.005 0-.002.002-.003.003-.005l.003-.005.007-.01.006-.01.003-.004a4.075 4.075 0 00.496-1.077l.008-.028.003-.011.003-.011.002-.006.001-.005.002-.005c0-.004.002-.008.003-.011v-.001l.003-.01v-.001l.001-.005.002-.005v-.001-.005h.001l.001-.006.002-.005.001-.006.002-.005v-.005l.001-.001.001-.005v-.001l.002-.004v-.001a1.112 1.112 0 00.002-.01v-.002l.002-.004.001-.005v-.002l.001-.004v-.001l.002-.005v-.001-.004l.001-.001.001-.005a.131.131 0 01.003-.01v-.002l.001-.004v-.002l.001-.003v-.002l.002-.004v-.002-.003l.001-.002.001-.005v-.002l.001-.002v-.003l.001-.003.001-.003v-.003l.001-.002V10.8l.001-.002.001-.004v-.002l.001-.003v-.002l.002-.004v-.003-.002l.001-.003v-.002l.002-.005v-.002-.002l.001-.002v-.005l.001-.002.001-.003v-.002-.003h.001l.001-.007v-.001l.001-.003v-.002l.002-.005v-.002-.003l.002-.008v-.003l.001-.002.002-.01V10.7v-.004l.002-.007.003-.016c.01-.057.02-.115.027-.173l-1.295-.17z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12.741 6.316l-.714 1.093c.71.464 1.225 1.033 1.492 1.647l1.198-.52a4.442 4.442 0 00-.643-1.043 5.081 5.081 0 00-.018-.022l-.004-.004a17.562 17.562 0 00-.015-.018l-.004-.005a4.797 4.797 0 00-.007-.009l-.004-.004a2.821 2.821 0 00-.015-.018l-.004-.004a4.948 4.948 0 00-.007-.009l-.004-.004a4.75 4.75 0 00-.008-.01l-.004-.004-.004-.004a1.755 1.755 0 01-.003-.004l-.004-.005-.004-.004a12.183 12.183 0 00-.003-.004l-.001-.001a4.714 4.714 0 00-.007-.008l-.001-.001-.003-.003v-.001l-.004-.004-.004-.004v-.001l-.004-.003v-.001l-.004-.004v-.001a.855.855 0 00-.003-.003l-.002-.001c0-.002-.002-.003-.003-.004l-.004-.004v-.001l-.003-.003-.001-.001-.003-.004-.001-.001-.003-.003-.001-.001-.003-.003v-.001a1.804 1.804 0 01-.004-.004h-.001l-.003-.004-.001-.001-.003-.003v-.001l-.004-.004-.001-.001-.003-.003v-.001l-.004-.004-.004-.004v-.001l-.004-.003v-.001a1.25 1.25 0 00-.004-.004h-.001c0-.002-.002-.003-.003-.004l-.001-.001a.808.808 0 00-.004-.004l-.003-.004a.921.921 0 00-.004-.004l-.004-.004v-.001l-.004-.003-.001-.002-.003-.002v-.002c-.002 0-.003-.002-.004-.003l-.001-.001-.003-.003a.307.307 0 01-.004-.005 2.048 2.048 0 01-.006-.005l-.002-.003-.001-.001-.003-.003-.001-.001-.003-.004-.002-.001-.002-.003-.002-.001-.003-.003-.001-.002-.002-.002-.002-.002-.002-.002-.002-.002a1.184 1.184 0 01-.003-.003l-.002-.002-.002-.002a.356.356 0 00-.003-.004l-.002-.002-.003-.003-.002-.001-.002-.003-.001-.001-.003-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002a1.177 1.177 0 00-.003-.003l-.002-.002-.002-.002-.002-.002-.001-.002c-.001 0-.002 0-.002-.002l-.003-.003-.002-.002-.002-.002-.002-.001-.002-.002-.003-.003-.002-.002-.002-.002-.002-.002a.37.37 0 00-.001-.002l-.003-.002-.002-.003-.002-.002-.002-.002-.002-.002-.002-.001-.003-.004-.002-.001-.002-.002-.002-.002-.002-.002-.002-.003-.003-.002-.002-.002-.001-.002-.002-.001-.003-.003a.66.66 0 00-.002-.002l-.002-.002-.002-.002-.002-.002-.002-.002-.003-.003-.002-.002-.002-.002-.002-.002-.001-.001-.005-.004v-.001l-.003-.003h-.001l-.003-.003a.222.222 0 00-.005-.005l-.001-.002-.003-.002-.001-.001a.5.5 0 00-.004-.004l-.003-.003-.002-.002-.002-.002-.002-.002-.002-.002-.003-.003c-.001 0-.002 0-.002-.002l-.002-.001-.002-.002-.002-.002a1.175 1.175 0 01-.005-.005l-.002-.002-.002-.002-.002-.002L13.613 7l-.003-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.002-.003-.003-.002-.001-.002-.002a.42.42 0 01-.007-.007l-.002-.002-.002-.002-.002-.001-.003-.003-.002-.002-.002-.002-.002-.002-.002-.002a.378.378 0 00-.007-.006l-.003-.002-.001-.002-.003-.002-.001-.002-.004-.003a.298.298 0 00-.006-.005l-.002-.003-.002-.001-.003-.003-.002-.002-.002-.002-.002-.001-.003-.003-.002-.002-.002-.002-.002-.002-.003-.002-.001-.001a1.366 1.366 0 00-.005-.005l-.003-.002-.001-.002-.004-.003-.004-.004a.215.215 0 01-.004-.003l-.002-.002-.003-.003-.002-.001-.002-.003h-.002c0-.002-.002-.003-.003-.003l-.001-.001-.004-.004-.004-.004h-.001a1.435 1.435 0 01-.004-.004l-.005-.004-.004-.004-.005-.004-.004-.004h-.001l-.003-.004a.141.141 0 00-.006-.004l-.004-.004-.005-.004-.004-.004h-.001l-.004-.004a5.38 5.38 0 00-.009-.008l-.004-.004h-.001l-.005-.004-.004-.004a.086.086 0 01-.004-.004h-.001l-.004-.004h-.001a1.617 1.617 0 01-.004-.004l-.005-.004-.004-.004-.005-.004-.01-.007v-.001l-.004-.004-.005-.004-.004-.003-.01-.008-.004-.004a6.001 6.001 0 00-.023-.02h-.001a6.42 6.42 0 00-.57-.417z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M8 1a3.532 3.532 0 00-3.57 3.57c0 .573.21 1.23.642 2.008.251.452.576.943.968 1.458.315.415.67.842 1.057 1.273l.484.516c.111.113.26.175.419.175h.001c.16 0 .308-.063.42-.177l.135-.14A19.587 19.587 0 009.96 8.037c.392-.515.717-1.006.968-1.458.431-.779.641-1.435.641-2.009A3.532 3.532 0 008 1zm2.388 3.57c0 .355-.171.852-.493 1.435-.223.4-.517.844-.876 1.316-.304.4-.638.802-.992 1.194L8 8.545l-.026-.03c-.36-.4-.695-.801-.993-1.194-.359-.472-.653-.915-.876-1.316-.322-.582-.492-1.078-.492-1.436C5.613 3.23 6.661 2.182 8 2.182s2.388 1.048 2.388 2.387z"
  }), /*#__PURE__*/createElement("circle", {
    cx: 8,
    cy: 4.579,
    r: 0.991,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}

function AccessibilityIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M7.997 15a7 7 0 110-14 7 7 0 010 14zm0-1a6 6 0 100-12 6 6 0 000 12z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.934 6.293l.002 2.134.857 3.52c.057.23.055.465-.173.523-.227.057-.406-.007-.463-.236l-.954-2.899c-.01-.025-.027-.036-.047-.037h-.485c-.019 0-.033.01-.041.036l-.907 2.9c-.086.22-.244.321-.463.236-.219-.085-.215-.333-.13-.554l.827-3.452v-2.17l-2.436-.217c-.212-.018-.364-.135-.347-.348.016-.214.217-.341.429-.324H8.46l2.903-.005c.213-.008.45.114.457.329.01.212-.244.338-.456.348l-2.43.216zM7.997 5.11a.805.805 0 110-1.61.805.805 0 010 1.61z",
    clipRule: "evenodd"
  }));
}

function AddCardIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.734 10.3l-.09-.007c-.293-.046-.518-.315-.518-.64V6.742H15V4.346c0-1.02-.776-1.846-1.734-1.846H2.734C1.776 2.5 1 3.326 1 4.346v5.307c0 1.02.776 1.847 1.734 1.847h5.245l-.001-1.2H2.734zm-.608-5.49v-.374c0-.345.272-.625.608-.625h10.532l.09.007a.619.619 0 01.517.618v1.315H2.126v-.94zm10.875 5.69v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z",
    clipRule: "evenodd"
  }));
}

function AddIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.7 1l-.001 6.3H15v1.4H8.699L8.7 15H7.3V8.7H1V7.3h6.3V1h1.4z",
    clipRule: "evenodd"
  }));
}

function AdditionalIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.788 13.242V11.91H2.333V2.334h9.576v5.454h1.333V1.667a.667.667 0 00-.576-.66L12.576 1H1.666a.667.667 0 00-.66.576L1 1.666v10.91c0 .337.25.616.576.66l.09.006h6.122zm5.454-3.09v1.757H15v1.333h-1.758V15H11.91v-1.758h-1.757V11.91h1.757v-1.757h1.333z",
    clipRule: "evenodd"
  }));
}

function AdjustmentsIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 10.62a2 2 0 11-1.894 2.645H1v-1.273l2.101-.001A2 2 0 015 10.62zm10 1.372v1.272H8.52v-1.272H15zM9.63 6a2 2 0 11-1.896 2.637H1V7.363l6.734-.001A2 2 0 019.63 6zM15 7.364v1.272h-1.851V7.364H15zM5 1.38a2 2 0 11-1.899 2.63L1 4.007V2.736l2.106-.001A2 2 0 015 1.38zm10 1.356v1.272H8.52V2.736H15z",
    clipRule: "evenodd"
  }));
}

function AdminIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M14.18 11.5l-.002-.109a2.555 2.555 0 00-.021-.225l-.004-.026.847-.695-.818-1.39-1.036.372-.029-.022a2.657 2.657 0 00-.572-.323l-.037-.014L12.318 8h-1.636l-.156.874a5.384 5.384 0 00-1.006-.562 3.596 3.596 0 001.238-2.723C10.758 3.607 9.167 2 7.205 2 5.242 2 3.65 3.607 3.65 5.59c0 1.013.416 1.928 1.085 2.58A5.466 5.466 0 001 13.357V14h1.273v-.643l.004-.196a4.182 4.182 0 014.18-3.982h.965l.197.004a4.16 4.16 0 011.016.183L8 10.445l.847.695s-.027.216-.027.36l.002.109c.004.074.01.149.021.226l.004.025-.847.696.818 1.389 1.036-.372.029.023c.175.129.367.237.572.323l.036.013.191 1.068h1.636l.19-1.068.037-.014c.205-.085.397-.193.572-.322l.028-.023 1.037.372.818-1.39-.847-.696s.027-.214.027-.359zM7.205 7.893c-1.26 0-2.28-1.031-2.28-2.304 0-1.272 1.02-2.303 2.28-2.303s2.28 1.031 2.28 2.303a2.292 2.292 0 01-2.28 2.304zm6.995 4.8l-.296.503-.631-.226a.466.466 0 00-.453.078c-.18.148-.386.264-.614.346l-.05.021a.45.45 0 00-.244.324l-.117.651h-.592l-.114-.651a.453.453 0 00-.295-.345 2.061 2.061 0 01-.614-.346l-.044-.032a.467.467 0 00-.41-.046l-.63.226-.297-.502.518-.424a.445.445 0 00.157-.422 1.976 1.976 0 01-.032-.348c0-.108.01-.22.032-.347l.007-.053a.447.447 0 00-.164-.37l-.518-.424.297-.502.631.227a.466.466 0 00.453-.078 2.05 2.05 0 01.614-.346l.05-.022a.453.453 0 00.245-.324l.114-.651h.592l.117.651a.45.45 0 00.294.345c.228.082.435.199.614.347l.044.031c.12.078.273.096.41.046l.63-.226.296.502-.517.424a.445.445 0 00-.157.422c.021.127.032.24.032.348 0 .108-.01.221-.032.348l-.007.053a.446.446 0 00.164.369l.517.424z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M11.5 10.25c-.689 0-1.25.561-1.25 1.25 0 .69.561 1.25 1.25 1.25s1.25-.56 1.25-1.25c0-.689-.561-1.25-1.25-1.25zm0 1.975a.726.726 0 11.725-.725c0 .4-.326.725-.725.725z"
  }));
}

function AgreesIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.953 1.854v1.249H2.249v10.052h10.053V7.832h1.25v5.949a.625.625 0 01-.54.618l-.085.006H1.625a.625.625 0 01-.62-.54L1 13.781V2.478c0-.316.235-.577.54-.619l.085-.005h8.328zm4.164-.26l.883.884-6.985 6.985a.625.625 0 01-.806.066l-.077-.066-2.822-2.82.884-.884 2.379 2.379 6.544-6.543z",
    clipRule: "evenodd"
  }));
}

function BellIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c2.654 0 4.779 1.85 4.895 4.217l.005.204v1.895c0 2.084 2.1 2.59 2.1 3.79 0 .817-1.584 1.489-4.227 1.762C10.587 14.103 9.43 15 8 15s-2.587-.897-2.774-2.132C2.584 12.594 1 11.923 1 11.105c0-1.15 1.929-1.662 2.09-3.537l.01-.252V5.42C3.1 2.958 5.27 1 8 1zm1.294 11.973c-.316.014-.638.022-.969.025L8 13c-.449 0-.88-.01-1.294-.027.204.412.683.694 1.294.694s1.09-.282 1.294-.694zM8 2.39c-1.917 0-3.395 1.275-3.495 2.861l-.005.171v1.895c0 1.229-.433 2.102-1.262 3l-.578.59.094.04.214.077c.039.013.078.026.119.038l.19.057c1.12.312 2.769.493 4.723.493s3.603-.181 4.722-.493c.2-.056.375-.114.524-.172l.093-.04-.394-.396c-.884-.905-1.377-1.756-1.438-2.936l-.007-.258V5.42C11.5 3.756 9.985 2.39 8 2.39z",
    clipRule: "evenodd"
  }));
}

function BookmarkIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12.79 15a.714.714 0 01-.376-.108L8 12.132l-4.414 2.76A.71.71 0 012.5 14.29V1.71A.71.71 0 013.21 1h9.58a.71.71 0 01.71.71v12.58a.71.71 0 01-.71.71zM8 10.584c.13 0 .26.036.376.108l3.704 2.317V2.42H3.92v10.588l3.704-2.317A.716.716 0 018 10.584z"
  }));
}

function BrightnessIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.851 7.364v1.272H1V7.364h1.851zm.637-4.776l1.305 1.305-.9.9-1.305-1.305.9-.9zM8.636 1v1.851H7.364V1h1.272zm3.876 1.588l.9.9-1.305 1.305-.9-.9 1.305-1.305zM15 7.364v1.272h-1.851V7.364H15zm-2.893 3.843l1.305 1.305-.9.9-1.305-1.305.9-.9zm-3.47 1.942V15H7.363v-1.851h1.272zm-4.744-1.942l.9.9-1.305 1.305-.9-.9 1.305-1.305zM8 3.893a4.107 4.107 0 100 8.214 4.107 4.107 0 000-8.214zm0 1.272a2.834 2.834 0 110 5.67 2.834 2.834 0 010-5.67z",
    clipRule: "evenodd"
  }));
}

function BugIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.784 1l.866.866-1.256 1.256c.144.222.26.465.34.725.21.152.409.322.595.506l1.126-1.126.866.866-1.224 1.224a6.4 6.4 0 01.915 2.618h1.726v1.226h-1.68a6.504 6.504 0 01-.98 3.155l1.243 1.243-.866.867-1.143-1.142c-.839.849-1.919 1.385-3.107 1.44L8 14.729c-1.27 0-2.425-.548-3.312-1.445l-1.143 1.142-.866-.867 1.242-1.243a6.504 6.504 0 01-.98-3.155H1.262V7.936h1.729a6.476 6.476 0 01.926-2.604L2.679 4.093l.866-.866 1.136 1.136c.183-.185.378-.355.584-.51.08-.261.196-.507.341-.731L4.35 1.866 5.216 1l1.259 1.258a2.822 2.822 0 013.05 0L10.785 1zm-5.07 4.07l-.04.036c-.042.04-.084.08-.126.123l.033.034-.419.416c-.628.842-1.004 1.954-1.004 3.147 0 1.227.397 2.343 1.037 3.178l.386.386-.027.027c.519.525 1.15.888 1.834 1.026V5.759a4.671 4.671 0 01-1.193-.422 6.174 6.174 0 01-.48-.267zm4.582-.006l-.027.017c-.133.081-.289.169-.464.256a4.671 4.671 0 01-1.193.422v7.684c.685-.138 1.315-.5 1.834-1.026l-.027-.027.386-.386c.64-.835 1.037-1.95 1.037-3.178 0-1.17-.335-2.238-.915-3.056l-.508-.507.043-.043a3.903 3.903 0 00-.166-.156zM8 3.036c-.671 0-1.264.422-1.515 1.037l-.01.024.135.076.133.069c.444.222.88.353 1.257.353s.813-.131 1.257-.353c.093-.046.178-.092.255-.136l.011-.009-.008-.024A1.653 1.653 0 008.133 3.04L8 3.036z",
    clipRule: "evenodd"
  }));
}

function CalendarIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.273 1l-.001 1.157h5.427L10.7 1h1.273l-.001 1.161.078-.004h2.314c.322 0 .588.24.63.55l.006.086v11.57c0 .323-.24.59-.55.631l-.086.006H1.636a.636.636 0 01-.63-.55L1 14.364V2.794c0-.323.24-.589.55-.631l.086-.006H3.95L4 2.16 4 1h1.273zm8.454 5.9H2.272v6.827h11.455V6.9zm-1.755-3.477v1.164H10.7l-.001-1.158H5.272v1.158H4l-.001-1.161-.049.004H2.273l-.001 2.198h11.455V3.429H12.05l-.078-.006z",
    clipRule: "evenodd"
  }));
}

function CardIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.27 3.004H2.737c-.957 0-1.733.798-1.733 1.784v6.428c0 .986.776 1.784 1.733 1.784H13.27c.958 0 1.734-.798 1.734-1.784V4.788c0-.986-.776-1.784-1.734-1.784zm0 8.837H2.737l-.09-.007a.62.62 0 01-.517-.618V7.102h11.747v4.114a.616.616 0 01-.607.625zm.607-6.798v1.059H2.13V4.788c0-.345.272-.625.607-.625H13.27l.09.007a.62.62 0 01.517.618v.255z",
    clipRule: "evenodd"
  }));
}

function ChannelsIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.632 1A2.372 2.372 0 119.91 5.004l-4.24 2.41a2.377 2.377 0 010 1.173l4.24 2.409a2.372 2.372 0 11-.596 1.125l-4.28-2.43a2.372 2.372 0 110-3.381l4.28-2.43A2.372 2.372 0 0111.632 1zm0 10.529a1.1 1.1 0 100 2.198 1.1 1.1 0 000-2.198zM3.372 6.9a1.1 1.1 0 100 2.198 1.1 1.1 0 000-2.198zm8.26-4.628a1.1 1.1 0 100 2.198 1.1 1.1 0 000-2.198z",
    clipRule: "evenodd"
  }));
}

function ChatIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.421 1.5c3.517 0 6.422 2.245 6.422 5.103 0 .097-.003.194-.01.29C14.576 7.587 15 8.46 15 9.397c0 .889-.382 1.721-1.056 2.398l-.101.096v1.976c0 .436-.429.731-.83.603l-.085-.034-2.304-1.113-.067.01a6.95 6.95 0 01-.547.043l-.274.006c-1.766 0-3.385-.66-4.353-1.74l-2.311 1.117a.637.637 0 01-.909-.477l-.006-.091V9.52l-.144-.17c-.603-.747-.956-1.61-1.007-2.52L1 6.603C1 3.745 3.905 1.5 7.421 1.5zm6.018 6.896l-.039.08c-.941 1.907-3.28 3.23-5.979 3.23l.213-.004a5.353 5.353 0 002.102.416c.297 0 .595-.024.892-.072a.64.64 0 01.288.02l.09.036 1.564.755V11.61a.63.63 0 01.163-.422l.068-.065c.603-.496.926-1.102.926-1.726 0-.345-.098-.683-.288-1zM7.421 2.764c-2.873 0-5.148 1.758-5.148 3.839 0 .804.342 1.578.979 2.235a.63.63 0 01.178.439v1.904l1.881-.909a.64.64 0 01.35-.06l.088.017a6.69 6.69 0 001.672.212c2.652 0 4.795-1.497 5.11-3.363-.001-.027.003-.053.01-.079.02-.13.03-.263.03-.396 0-2.08-2.276-3.84-5.15-3.84z",
    clipRule: "evenodd"
  }));
}

function CheckIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.08 3l.92.976-8.502 8.826a.631.631 0 01-.84.071l-.08-.071L1 8.049l.92-.976 4.117 4.275L14.08 3z",
    clipRule: "evenodd"
  }));
}

function ClockIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 110 14A7 7 0 018 1zm0 1.4a5.6 5.6 0 100 11.2A5.6 5.6 0 008 2.4zM8.7 4v3.3H12v1.4H8a.7.7 0 01-.694-.605L7.3 8V4h1.4z",
    clipRule: "evenodd"
  }));
}

function CloseIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.075 1l.925.925L8.924 8 15 14.075l-.925.925L8 8.924 1.925 15 1 14.075 7.075 8 1 1.925 1.925 1 8 7.075 14.075 1z",
    clipRule: "evenodd"
  }));
}

function CloseSmallIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M3.004 3.934l.93-.93 9.07 9.069-.93.93z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M3.004 12.073l9.07-9.07.93.93-9.069 9.07z"
  }));
}

function ColorPickerIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 8.006c0-.953.788-1.732 1.75-1.732s1.752.78 1.752 1.732-.788 1.732-1.751 1.732S9 8.958 9 8.006zm-.121 4.426c-.525 0-.876-.347-.876-.866s.35-.866.876-.866c.525 0 .875.346.875.866s-.35.866-.875.866m-3.804-1.2c-.525 0-.875-.347-.875-.866s.35-.866.875-.866.876.346.876.866-.35.866-.876.866m-1.2-3C3.35 8.232 3 7.885 3 7.366s.35-.866.875-.866.876.346.876.866-.35.866-.876.866m.126-6.27A6.78 6.78 0 001 7.603C1 11.427 4.13 14.5 8.024 14.5c3.148 0 5.925-2.085 6.768-5.016.512-2.132.143-4.29-1.832-5.287-1.31-.604-2.414-.565-4.01-.107l-.79.234c-.968.279-1.187.265-1.387.03.003.003.006.002.01-.005l.212-.7c.165-.58.165-1.04-.133-1.461l-.048-.06c-.566-.835-1.918-.782-2.813-.167zm1.75.86l.041.054c.042.05.05.135-.001.34l-.068.235-.02.065c-.26.816-.298 1.164.081 1.63.69.814 1.197.832 2.853.347l.42-.126c1.468-.447 2.34-.506 3.34-.045 1.27.642 1.544 2.24 1.16 3.848-.683 2.366-2.96 4.076-5.533 4.076-3.188 0-5.747-2.512-5.747-5.642 0-1.872.916-3.573 2.453-4.613.385-.265.94-.287 1.021-.168z",
    clipRule: "evenodd"
  }));
}

function CommentIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.5c3.858 0 7 2.6 7 5.914 0 1.253-.475 2.442-1.329 3.456l-.146.165.314 2.746a.64.64 0 01-.788.699l-.084-.028-3.214-1.324-.038.011c-.44.11-.893.168-1.402.184L8 13.328c-3.858 0-7-2.6-7-5.914S4.142 1.5 8 1.5zm0 1.288c-3.205 0-5.727 2.088-5.727 4.626S4.795 12.04 8 12.04c.63 0 1.133-.062 1.61-.207a.63.63 0 01.423.02l2.418.995-.224-1.964a.65.65 0 01.12-.455l.063-.074c.853-.864 1.317-1.882 1.317-2.941 0-2.538-2.522-4.626-5.727-4.626zm1.215 5.153v1.288H5.05V7.941h4.165zm1.735-2.342v1.288h-5.9V5.599h5.9z",
    clipRule: "evenodd"
  }));
}

function ConfigurationIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.786 1l-.048.002c-2.033.144-3.657 1.938-3.586 3.996l.009.242c.006.08.015.158.026.236l.042.219-5.34 4.709c-1.12 1.034-1.195 2.774-.149 3.815l.131.122c1.113.975 2.787.86 3.716-.295l4.723-5.311.144.026c.403.062.831.058 1.345.007a3.97 3.97 0 003.065-2.774c.206-.75.17-1.514-.059-2.275l-.035-.094a.681.681 0 00-1.097-.192L12.381 4.72 11.277 3.62l1.29-1.282a.68.68 0 00-.295-1.137A5.307 5.307 0 0010.786 1zm-.26 1.402l.058-.01-.75.747a.68.68 0 000 .965L11.9 6.162l.084.071a.68.68 0 00.877-.071l.737-.735-.001.013c-.012.06-.026.119-.042.178A2.587 2.587 0 0111.6 7.424c-.532.05-.933.028-1.307-.096a.68.68 0 00-.723.193l-5.022 5.646c-.476.592-1.305.627-1.846.088-.487-.485-.45-1.333.1-1.841L8.46 6.426a.68.68 0 00.181-.765 1.75 1.75 0 01-.128-.687c-.042-1.24.854-2.333 2.014-2.572z",
    clipRule: "evenodd"
  }));
}

function ContactsIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.437 1.5H1.563A.555.555 0 001 2.046v9.64l.005.074a.558.558 0 00.558.472h4.223l1.781 2.072.06.06c.233.2.6.18.806-.06l1.78-2.073h4.224a.555.555 0 00.563-.545v-9.64a.555.555 0 00-.563-.546zm-.563 1.092v8.548H9.95l-.082.006a.568.568 0 00-.35.19L8 13.102l-1.518-1.764-.057-.058a.574.574 0 00-.375-.139H2.126V2.592h11.748zM8 3.64c.958 0 1.734.776 1.734 1.733v.585c0 .354-.107.684-.291.96l.767.58c.4.3.65.756.689 1.25l.005.136v1.149H5.096V8.885c0-.5.216-.973.587-1.3l.106-.086.768-.579a1.726 1.726 0 01-.29-.96v-.586c0-.957.775-1.733 1.733-1.733zm.495 3.976a1.818 1.818 0 01-.356.07L8 7.693c-.173 0-.341-.026-.499-.073l-1.036.78a.606.606 0 00-.237.404l-.005.081-.001.022h3.555v-.022a.606.606 0 00-.181-.433L9.534 8.4l-1.039-.782zM8 4.767a.607.607 0 00-.607.607v.585c0 .224.12.42.293.525.016.004.03.013.044.022.075.04.158.06.243.061l.086-.003c.31-.03.548-.291.548-.605v-.585A.607.607 0 008 4.767z",
    clipRule: "evenodd"
  }));
}

function CopyIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.96 3.4c.357 0 .647.3.647.671v10.257a.66.66 0 01-.647.672H2.647A.66.66 0 012 14.328V4.071a.66.66 0 01.647-.672h8.313zm-.646 1.343h-7.02v8.913h7.02V4.743zM13.354 1c.327 0 .597.253.64.58l.006.092v11.255h-1.293l-.001-10.583H4.284V1h9.07z",
    clipRule: "evenodd"
  }));
}

function DateIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M13.25 13.25H2.75V7.125h10.5v6.125zm.875-10.5h-1.75v-.875c0-.525-.35-.875-.875-.875h-.875c-.525 0-.875.35-.875.875v.875h-3.5v-.875C6.25 1.35 5.9 1 5.375 1H4.5c-.525 0-.875.35-.875.875v.875h-1.75C1.35 2.75 1 3.1 1 3.625v10.5c0 .525.35.875.875.875h12.25c.525 0 .875-.35.875-.875v-10.5c0-.525-.35-.875-.875-.875z"
  }));
}

function DeleteIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.314 1c.322 0 .588.24.63.55l.006.086v1.678h3.25v1.273l-1.101-.001v9.778c0 .322-.24.588-.55.63l-.086.006H3.372a.636.636 0 01-.63-.55l-.006-.086-.001-9.778H1.8V3.315h3.249V1.636c0-.322.24-.588.55-.63L5.687 1h4.628zm1.512 3.586H4.008v9.141h7.818V4.586zM9.943 6.478v5.357H8.67V6.478h1.273zm-2.77 0v5.357H5.9V6.478h1.273zm2.504-4.205H6.322v1.041h3.355V2.273z",
    clipRule: "evenodd"
  }));
}

function HorizontalDotsIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.75 6.25a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm5.25 0a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm5.25 0a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z",
    clipRule: "evenodd"
  }));
}

function VerticalDotsIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.75 2.75a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm0 5.25a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm0 5.25a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z",
    clipRule: "evenodd"
  }));
}

function DraggableIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("circle", {
    cx: 10.75,
    cy: 2.5,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("circle", {
    cx: 10.75,
    cy: 8,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("circle", {
    cx: 10.75,
    cy: 13.5,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("circle", {
    cx: 5.25,
    cy: 2.5,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("circle", {
    cx: 5.25,
    cy: 8,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/createElement("circle", {
    cx: 5.25,
    cy: 13.5,
    r: 1.5,
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}

function EditIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.37 14.558a.612.612 0 01-.432.18H1.875a.613.613 0 01-.612-.613v-3.063c0-.162.064-.318.179-.433l9.187-9.187c.24-.24.627-.24.867 0l3.062 3.062c.24.24.24.627 0 .867l-9.187 9.187zm3.854-9.98l-6.736 6.736v2.198h2.196l6.738-6.737-2.198-2.198zm1.838-1.838l-.973.97 2.198 2.198.973-.97-2.197-2.198z",
    clipRule: "evenodd"
  }));
}

function EmailIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 13.34c0 .334-.24.61-.55.654l-.086.006H1.636a.645.645 0 01-.63-.571L1 13.339V2.661C1 2.296 1.285 2 1.636 2h12.728c.351 0 .636.296.636.661v10.678zm-1.273-6.562L8.305 9.851a.616.616 0 01-.61 0L2.272 6.778v5.9h11.455v-5.9zm0-3.456H2.273v1.95l5.726 3.245 5.728-3.244V3.322z",
    clipRule: "evenodd"
  }));
}

function ExtendIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.269 0c.37 0 .676.275.724.632l.007.1v5.372h-1.463V2.496L2.496 12.537h3.608V14H.731a.731.731 0 01-.724-.632l-.007-.1V7.897h1.463l-.001 3.607L11.503 1.462H7.896V0h5.373z"
  }));
}

function StarredIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.535 5.267H1.733l-.105.007a.732.732 0 00-.423 1.23L4.057 9.48 2.89 14.086l-.02.104a.732.732 0 001.093.71L8 12.576l4.037 2.324.094.046a.732.732 0 00.98-.86L11.941 9.48l2.853-2.975.067-.08a.732.732 0 00-.595-1.157h-3.803L8.662 1.421a.731.731 0 00-1.324 0L5.535 5.267z",
    clipRule: "evenodd"
  }));
}

function UnstarredIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.535 5.267H1.733l-.105.007a.732.732 0 00-.423 1.23L4.057 9.48 2.89 14.086l-.02.104a.732.732 0 001.093.71L8 12.576l4.037 2.324.094.046a.732.732 0 00.98-.86L11.941 9.48l2.853-2.975.067-.08a.732.732 0 00-.595-1.157h-3.803L8.662 1.421a.731.731 0 00-1.324 0L5.535 5.267zm2.464-1.814l1.34 2.856.05.091a.731.731 0 00.611.33h2.551l-1.945 2.03-.068.082a.731.731 0 00-.113.603l.842 3.324-2.902-1.67-.1-.048a.731.731 0 00-.63.048l-2.903 1.67.843-3.324.019-.106a.731.731 0 00-.2-.58L3.448 6.73H6a.731.731 0 00.662-.42l1.337-2.856z",
    clipRule: "evenodd"
  }));
}

function FileIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.782 1a.67.67 0 01.462.186l-.06-.051c.016.012.031.024.045.037l.015.014 3.565 3.471a.644.644 0 01.153.236l.008.022a.6.6 0 01.024.106l.003.055.003.031v9.257a.645.645 0 01-.653.636H2.653A.645.645 0 012 14.364V1.636C2 1.285 2.293 1 2.653 1h7.13zm-.654 1.272H3.307v11.455h9.386l-.001-7.984h-2.91a.648.648 0 01-.647-.55l-.006-.086-.001-2.835zm1.842 8.563v1.272H5.03v-1.272h5.94zm0-2.893v1.273H5.03V7.942h5.94zM7.406 5.05v1.272H5.03V5.05h2.376zm3.029-1.879v1.3l1.334-.001-1.334-1.299z",
    clipRule: "evenodd"
  }));
}

function FillIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.804 1a.804.804 0 00-.797.695L1 1.804v9.184h1.607l.001-7.245 10.413 10.414 1.137-1.137L3.744 2.607h7.244V1H1.804z",
    clipRule: "evenodd"
  }));
}

function GridViewIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.843 1H1.636A.636.636 0 001 1.636v5.207c0 .351.285.636.636.636h5.207a.636.636 0 00.636-.636V1.636A.636.636 0 006.843 1zm-.637 1.273v3.933H2.273V2.273h3.933zM14.364 1H9.157a.636.636 0 00-.636.636v5.207c0 .351.285.636.636.636h5.207A.636.636 0 0015 6.843V1.636A.636.636 0 0014.364 1zm-.637 1.273v3.933H9.793V2.273h3.934zM6.843 8.52H1.636A.636.636 0 001 9.157v5.207c0 .351.285.636.636.636h5.207a.636.636 0 00.636-.636V9.157a.636.636 0 00-.636-.636zm-.637 1.272v3.934H2.273V9.793h3.933zm8.158-1.272H9.157a.636.636 0 00-.636.636v5.207c0 .351.285.636.636.636h5.207a.636.636 0 00.636-.636V9.157a.636.636 0 00-.636-.636zm-.637 1.272v3.934H9.793V9.793h3.934z",
    clipRule: "evenodd"
  }));
}

function HandToolIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 12 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.045 0C6.717 0 7.3.377 7.582.928c.18-.064.376-.099.58-.099.673 0 1.255.378 1.538.928.18-.063.376-.098.58-.098.902 0 1.643.68 1.714 1.546l.006.139v7.15c0 1.142-.29 2.03-.786 2.679-.32.417-.656.66-.918.773a.672.672 0 01-.174.048L10.03 14H2.866a.67.67 0 01-.449-.172l-.067-.071-1.48-1.812a3.841 3.841 0 01-.864-2.207L0 9.518v-2.17c0-.936.796-1.685 1.764-1.685.152 0 .3.019.441.054v-3.16l.003-.043c0-.93.77-1.685 1.72-1.685.204 0 .4.035.582.1C4.791.376 5.373 0 6.045 0zm0 1.295a.395.395 0 00-.39.32l-.007.07v3.94a.655.655 0 01-.662.647.657.657 0 01-.655-.56l-.006-.087V2.514a.393.393 0 00-.397-.39.395.395 0 00-.391.32l-.007.07-.003.041V8.07a.655.655 0 01-.661.648.657.657 0 01-.655-.56l-.006-.088v-.722c0-.209-.192-.39-.441-.39-.222 0-.398.143-.434.322l-.007.068v2.17c0 .522.161 1.031.46 1.46l.12.158 1.28 1.568h6.67l.04-.029c.054-.045.12-.107.19-.19l.072-.089c.292-.382.485-.924.517-1.672l.005-.23v-7.15a.393.393 0 00-.397-.39.395.395 0 00-.391.32l-.006.07v2.28a.655.655 0 01-.662.648.657.657 0 01-.655-.56l-.006-.088v-3.11a.393.393 0 00-.397-.39.395.395 0 00-.391.32l-.007.07v3.11a.655.655 0 01-.661.648.657.657 0 01-.655-.56l-.006-.087v-3.94a.393.393 0 00-.398-.39z",
    clipRule: "evenodd"
  }));
}

function HeartIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.675 1.006c-1.007.056-1.935.5-2.646 1.225L8 2.26l-.029-.03C7.209 1.455 6.199 1 5.107 1 2.847 1 1 2.927 1 5.284c0 .993.386 2.09 1.088 3.288.57.975 1.34 1.997 2.261 3.045.71.808 1.47 1.585 2.229 2.305l.383.359.636.569c.234.2.572.2.806 0l.285-.25.35-.319a36.58 36.58 0 002.613-2.664c.92-1.048 1.69-2.07 2.261-3.045C14.614 7.374 15 6.277 15 5.284 15 2.927 13.153 1 10.893 1l-.218.006zm.218 1.322c1.557 0 2.834 1.332 2.834 2.956 0 .705-.31 1.588-.9 2.596-.523.892-1.245 1.85-2.114 2.84a34.235 34.235 0 01-2.147 2.22l-.37.346-.196.178-.197-.178a35.29 35.29 0 01-2.516-2.566c-.869-.99-1.59-1.948-2.113-2.84-.591-1.008-.901-1.89-.901-2.596 0-1.624 1.277-2.956 2.834-2.956.95 0 1.817.505 2.369 1.341a.622.622 0 001.048 0c.552-.836 1.418-1.341 2.369-1.341z",
    clipRule: "evenodd"
  }));
}

function LikeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.648 1.136c1.058.635 1.828 2.151 1.896 3.48l.005.189-.001 1.274h2.547c1.006 0 1.835.786 1.9 1.845L15 8.07l-.632 5.018a1.915 1.915 0 01-1.773 1.907l-.136.005H8.002c-.852 0-1.69-.18-2.398-.518l-.232-.118-.553-.265v.264c0 .32-.235.585-.542.63L4.183 15H1.637A.637.637 0 011 14.363v-7.01c0-.351.285-.637.637-.637h2.546c.22 0 .414.112.528.282L6.73 4.573V2.256c0-.975.98-1.53 1.92-1.12zM8.004 2.25l-.002.007v2.549c0 .12-.033.235-.095.336l-.052.072-3.036 3.644v3.829l1.133.544a4.25 4.25 0 001.805.49l.245.006h4.457c.32 0 .588-.243.634-.613l.007-.104.632-5.018a.642.642 0 00-.551-.632l-.086-.005H9.912a.637.637 0 01-.63-.551l-.006-.087V4.805c0-.95-.587-2.158-1.206-2.537-.047-.02-.061-.023-.066-.019zM3.545 7.99H2.273v5.735h1.272V7.99z",
    clipRule: "evenodd"
  }));
}

function ListViewIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 11.6V13H4v-1.4h11zm-12.6 0V13H1v-1.4h1.4zM15 7.3v1.4H4V7.3h11zm-12.6 0v1.4H1V7.3h1.4zM15 3v1.4H4V3h11zM2.4 3v1.4H1V3h1.4z",
    clipRule: "evenodd"
  }));
}

function LoadingIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 7.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM8 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5-.6a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    clipRule: "evenodd"
  }));
}

function ClosedLockIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.018 1l.18.005c1.858.103 3.28 1.63 3.28 3.524v1.099h1.067c.32 0 .584.236.63.542l.007.094v8.1a.636.636 0 01-.637.636h-9.09a.636.636 0 01-.637-.636v-8.1c0-.351.285-.636.637-.636h1.067v-1.1c0-1.902 1.433-3.424 3.285-3.523L8 1h.018zM5.146 6.9H4.09v6.827h7.818V6.9l-1.056-.001-.012.002H5.159a.65.65 0 01-.013 0zm2.852 1.4a1.402 1.402 0 01.638 2.65v1.506H7.364v-1.504A1.402 1.402 0 017.998 8.3zM8 2.273c-1.237 0-2.205.985-2.205 2.256v1.098h4.41V4.53c0-1.172-.825-2.107-1.916-2.24l-.143-.012L8 2.273z",
    clipRule: "evenodd"
  }));
}

function OpenedLockIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1c1.32 0 2.524.764 3.116 1.946l.08.171.255.584-1.166.509-.255-.584A2.233 2.233 0 008 2.273c-1.187 0-2.127.908-2.2 2.105l-.005.15v1.1h6.75c.32 0 .584.236.63.542l.007.094v8.1a.636.636 0 01-.637.636h-9.09a.636.636 0 01-.637-.636v-8.1c0-.351.285-.636.637-.636h1.067v-1.1C4.523 2.56 6.056 1 8 1zm3.91 5.9H4.09v6.827h7.82V6.9zM7.997 8.3a1.402 1.402 0 01.638 2.65v1.506H7.364v-1.504A1.402 1.402 0 017.998 8.3z",
    clipRule: "evenodd"
  }));
}

function LogOutIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 1v14h-1.394V1H15zM7.828 4.041l3.8 3.801c.245.245.27.627.074.9l-.074.086-3.8 3.8-.986-.985 2.61-2.612H1V7.639h8.453l-2.61-2.611.985-.986z",
    clipRule: "evenodd"
  }));
}

function MenuIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 7.3v1.4H1V7.3h14zM15 3v1.4H1V3h14zm0 8.6V13H1v-1.4h14z",
    clipRule: "evenodd"
  }));
}

function MinimizeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/createElement("path", {
    d: "M5.396 8c.306 0 .558.227.598.522L6 8.604V13H4.791v-2.924L.867 14 0 13.133l3.924-3.925H1V8h4.396z"
  }), /*#__PURE__*/createElement("path", {
    d: "M8.604 6a.605.605 0 01-.598-.522L8 5.396V1h1.209v2.924L13.133 0 14 .867l-3.924 3.925H13V6H8.604z"
  })));
}

function NewIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.073 10.625l.071.008c.138.032.24.156.24.303 0 .869.698 1.576 1.555 1.576a.311.311 0 110 .622c-.81 0-1.477.622-1.549 1.414l-.006.141-.008.071a.311.311 0 01-.232.232L4.073 15a.311.311 0 01-.311-.311c0-.81-.63-1.477-1.433-1.549l-.143-.006-.071-.008a.311.311 0 01.071-.614 1.6 1.6 0 001.57-1.435l.006-.141.008-.071a.311.311 0 01.232-.232l.07-.008zM10.646 4.5c.343 0 .622.278.622.622 0 1.738 1.395 3.152 3.11 3.152a.622.622 0 110 1.244 3.114 3.114 0 00-3.105 2.934l-.005.176-.007.092a.623.623 0 01-.513.522l-.102.008a.622.622 0 01-.622-.622c0-1.656-1.318-3.014-2.973-3.105l-.179-.005-.092-.007a.622.622 0 01.092-1.237c1.65 0 3.052-1.346 3.147-2.976l.005-.176.006-.092a.623.623 0 01.514-.522l.102-.008zm-.013 3.157l-.041.062a4.677 4.677 0 01-1.163 1.15l-.023.014.073.049c.373.259.706.572.985.928l.178.243.041-.06c.26-.37.573-.7.93-.976l.24-.175-.14-.098a4.566 4.566 0 01-.975-.987l-.105-.15zM4.077 1c.24 0 .435.195.435.435 0 1.217.977 2.207 2.178 2.207a.435.435 0 110 .87 2.18 2.18 0 00-2.172 2.022l-.006.156-.007.078a.436.436 0 01-.35.35l-.078.007a.435.435 0 01-.435-.435c0-1.149-.906-2.092-2.05-2.172l-.157-.006-.078-.007a.436.436 0 01.078-.863c1.144 0 2.118-.925 2.2-2.052l.007-.155.007-.078a.436.436 0 01.35-.35L4.077 1z",
    clipRule: "evenodd"
  }));
}

function NightIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.961 1.016a6.895 6.895 0 00-3.42 1.9C.82 5.68.82 10.163 3.54 12.927s7.131 2.765 9.852 0c.384-.39.72-.83 1.013-1.316.288-.478-.13-1.074-.669-.953a5.643 5.643 0 01-5.276-1.558c-1.876-1.906-2.199-4.858-.83-7.13.287-.478-.13-1.074-.67-.953zm-1.057 1.72l-.055.171c-.746 2.45-.14 5.195 1.726 7.092l.185.18a6.88 6.88 0 004.507 1.885l.199.002.04-.04c-2.23 2.268-5.848 2.268-8.08 0s-2.231-5.943 0-8.21a5.675 5.675 0 011.297-.986l.181-.095z",
    clipRule: "evenodd"
  }));
}

function OrganizationIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a2.546 2.546 0 01.694 4.995l.006.096v2.192l2.388 1.763a.699.699 0 01.162.167 2.546 2.546 0 11-.994.958L8 9.506l-2.256 1.665a2.546 2.546 0 11-.993-.959.652.652 0 01.082-.099l.079-.067L7.3 8.283V6.091l.006-.096A2.547 2.547 0 018 1zM3.545 11.31a1.146 1.146 0 100 2.29 1.146 1.146 0 000-2.29zm8.91 0a1.146 1.146 0 100 2.29 1.146 1.146 0 000-2.29zM8 2.4a1.146 1.146 0 100 2.291A1.146 1.146 0 008 2.4z",
    clipRule: "evenodd"
  }));
}

function PackageIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.137 1.067c.18-.09.39-.09.57 0l6.941 3.471a.625.625 0 01.236.204l.035.056c.02.036.038.075.05.115l-.036-.09a.638.638 0 01.067.284l-.007-.094.004.031.003.063v5.785c0 .224-.117.431-.31.546l-5.784 3.471a.639.639 0 01-.318.09h-.05a.636.636 0 01-.05-.006l.09.007a.637.637 0 01-.284-.067l.092.037a.632.632 0 01-.073-.028l-.02-.01-6.941-3.47a.636.636 0 01-.352-.57V4.53a.639.639 0 01.188-.451l.076-.065a.637.637 0 01.084-.051l.004-.002 5.785-2.893zM2.272 5.56v4.94l5.67 2.834v-4.94L2.272 5.56zm11.455.577L9.214 8.393v4.846l4.513-2.708V6.136zM4.59 3.763l-1.53.765 5.52 2.76 1.53-.765-5.52-2.76zm2.832-1.416l-1.408.704 5.52 2.76 1.407-.704-5.52-2.76z",
    clipRule: "evenodd"
  }));
}

function PlayIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 10 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 .733v12.534c0 .603.7.947 1.191.585l8.511-6.267a.723.723 0 000-1.17L1.192.148C.7-.214 0 .13 0 .733zm1.489 1.462L8.013 7 1.49 11.805v-9.61z",
    clipRule: "evenodd"
  }));
}

function PrivacyIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.826 1.025a.618.618 0 01.348 0l5.373 1.578a.635.635 0 01.453.611V9.15c0 1.507-1.157 2.894-2.98 4.188-.926.657-1.902 1.2-2.756 1.603a.618.618 0 01-.528 0 18.457 18.457 0 01-2.755-1.603C3.158 12.044 2 10.658 2 9.15V3.214c0-.283.185-.533.453-.611l5.373-1.578zM8 2.298L3.253 3.692V9.15c0 .907.85 1.968 2.234 2.992l.212.153c.642.456 1.318.856 1.95 1.186l.351.177.414-.21c.508-.268 1.042-.58 1.563-.93l.324-.223c1.508-1.07 2.445-2.193 2.445-3.145V3.692L8 2.298zm2.25 3.495l.707.707-3.707 3.707L5.043 8l.707-.707 1.5 1.5 3-3z",
    clipRule: "evenodd"
  }));
}

function PurposeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.46.169a.575.575 0 01.953.225l.345 1.034.62-.62a.575.575 0 01.88.734l-.066.08-.621.619 1.035.346a.576.576 0 01.288.88l-.063.072-1.918 1.918a.575.575 0 01-.588.14l-.566-.19a5.753 5.753 0 11-2.166-2.166l-.19-.566a.575.575 0 01.14-.588L10.46.169zM5.754 3.836a4.41 4.41 0 103.5 1.725l-.87.869a3.197 3.197 0 11-.813-.813l.869-.87a4.392 4.392 0 00-2.686-.911zm0 2.557a1.854 1.854 0 101.653 1.014L6.16 8.654a.575.575 0 01-.88-.734l.066-.08 1.247-1.246a1.845 1.845 0 00-.84-.201zm5.909-3.242l-.311.31-.697.698.696.233 1.01-1.009-.698-.232zM10.616 1.64L9.607 2.649l.233.696 1.008-1.008-.232-.697z",
    clipRule: "evenodd"
  }));
}

function QuestionIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#181c56",
    d: "M8 1C4.15 1 1 4.15 1 8s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7zm0 3c1.405 0 2.61 1.205 2.61 2.61 0 1.134-.786 2.138-1.829 2.482l-.082.023v.74H7.301V8.518c0-.355.262-.647.603-.694L8 7.818c.632 0 1.21-.577 1.21-1.209S8.631 5.4 8 5.4c-.39 0-.833.292-1.086.698l-.07.125-.313.625-1.252-.625.313-.627C6.049 4.682 6.999 4 8 4zm.006 6.88a.875.875 0 110 1.75.875.875 0 010-1.75z"
  }));
}

function QuitIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.69 2.697l.559.318A6.404 6.404 0 0114.5 8.58C14.5 12.125 11.59 15 8 15s-6.5-2.875-6.5-6.421a6.4 6.4 0 013.038-5.436l.21-.126.558-.319.646 1.102-.558.318a5.135 5.135 0 00-2.606 4.46c0 2.844 2.334 5.15 5.212 5.15s5.212-2.306 5.212-5.15a5.13 5.13 0 00-2.419-4.347l-.19-.114-.557-.318.645-1.102zM8.645 1v5.322H7.356V1h1.288z",
    clipRule: "evenodd"
  }));
}

function RSSIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 6.895a8.106 8.106 0 018.101 7.848l.004.257H7.632c0-3.58-2.84-6.5-6.389-6.627L1 8.368V6.895zM1 1c7.624 0 13.823 6.092 13.996 13.674L15 15h-1.474c0-6.812-5.436-12.353-12.208-12.522L1 2.474V1zm1.474 11.053A1.474 1.474 0 112.473 15a1.474 1.474 0 010-2.948z",
    clipRule: "evenodd"
  }));
}

/** @deprecated ReportsIcon is deprecated; use CopyIcon instead */

function ReportsIcon(props) {
  console.warn('Design system warning: ReportsIcon is deprecated; use CopyIcon instead');
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.96 3.4c.357 0 .647.3.647.671v10.257a.66.66 0 01-.647.672H2.647A.66.66 0 012 14.328V4.071a.66.66 0 01.647-.672h8.313zm-.646 1.343h-7.02v8.913h7.02V4.743zM13.354 1c.327 0 .597.253.64.58l.006.092v11.255h-1.293l-.001-10.583H4.284V1h9.07z",
    clipRule: "evenodd"
  }));
}

function RowHeightDefaultIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 5.4h13.999V3H1v2.4zm0 3.8h13.999V6.801H1V9.2zM1 13h13.999v-2.399H1V13z",
    clipRule: "evenodd"
  }));
}

function RowHeightMiddleIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 10.129h13.999V8.718H1v1.411zM1 13h13.999v-1.411H1V13zm0-8.588h13.999V3H1v1.412zm0 2.871h13.999V5.871H1v1.412z",
    clipRule: "evenodd"
  }));
}

function RowHeightSmallIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 10.769h13.999V9.673H1v1.096zM1 13h13.999v-1.097H1V13zm0-6.673h13.999V5.23H1v1.097zm0 2.232h13.999V7.462H1v1.097zm0-4.462h13.999V3H1v1.097z",
    clipRule: "evenodd"
  }));
}

function RulesIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.993 5.38V6.74H1V5.38h13.993zm0-3.88v1.358H1V1.5h13.993zM5.798 9.261v1.358H1V9.261h4.798zm0 3.88V14.5H1v-1.358h4.798zm8.19-4.16L15 9.917l-4.3 4.372a.715.715 0 01-.932.07l-.08-.07-2.391-2.432 1.012-.938 1.885 1.917 3.794-3.857z",
    clipRule: "evenodd"
  }));
}

function ScopeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.637 1.029a7.002 7.002 0 016.334 6.334v1.274a7.002 7.002 0 01-6.334 6.334H7.363A7.002 7.002 0 011.03 8.637V7.363A7.002 7.002 0 017.363 1.03h1.274zm0 1.279v2.279H7.363v-2.28a5.73 5.73 0 00-5.056 5.056h2.279v1.273h-2.28a5.73 5.73 0 005.056 5.056v-2.279h1.273v2.28a5.73 5.73 0 005.056-5.056h-2.279V7.363h2.28a5.73 5.73 0 00-5.056-5.056zM8 6.207a1.793 1.793 0 110 3.586 1.793 1.793 0 010-3.586zm0 1.272A.52.52 0 108 8.52a.52.52 0 000-1.04z",
    clipRule: "evenodd"
  }));
}

function SearchIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.795 1a5.795 5.795 0 014.548 9.388L15 14.044l-.956.956-3.656-3.657A5.795 5.795 0 116.796 1zm0 1.352a4.443 4.443 0 100 8.885 4.443 4.443 0 000-8.885z",
    clipRule: "evenodd"
  }));
}

function SelectIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.373 12.864l.035.097c.218.487.94.504 1.163-.016l1.64-3.826 4.693 4.695a.636.636 0 00.9 0l2.01-2.01.067-.079a.636.636 0 00-.067-.82L9.119 6.21l3.826-1.639c.552-.237.498-1.037-.08-1.198L.806.023a.636.636 0 00-.783.784l3.35 12.057zM1.552 1.552l9.226 2.562-3.024 1.297-.083.043a.637.637 0 00-.116.992l4.909 4.908-1.11 1.11-4.908-4.909-.072-.062a.637.637 0 00-.963.261l-1.297 3.024-2.562-9.226z",
    clipRule: "evenodd"
  }));
}

function SendIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.226 1.007a.672.672 0 01.573.194l.011.01a.672.672 0 01.183.563l-.004.022a.657.657 0 01-.032.121l.018-.055a.679.679 0 01-.013.04l-.005.015L10.3 14.555a.68.68 0 01-1.248.069l-2.56-5.118-5.117-2.56a.681.681 0 01-.03-1.202l.1-.045 12.637-4.656a.739.739 0 01.12-.033h.01l.013-.003zm-1.619 3.348L7.829 9.133l1.738 3.475 3.04-8.253zm-.961-.965L3.391 6.432 6.866 8.17l4.78-4.78z",
    clipRule: "evenodd"
  }));
}

function SettingsIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.636 1H6.364l-.382 2.135-.073.029c-.41.169-.793.386-1.143.646l-.058.043-2.072-.742L1 5.89l1.694 1.39s-.055.431-.055.72l.005.218c.007.147.021.297.042.451l.008.051L1 10.111l1.636 2.779 2.073-.744.056.045c.351.259.734.476 1.145.646l.072.027L6.364 15h3.272l.381-2.136.073-.028a5.326 5.326 0 001.144-.645l.056-.045 2.074.744L15 10.111l-1.695-1.392s.056-.43.056-.719l-.005-.218a5.125 5.125 0 00-.042-.45l-.009-.052L15 5.89l-1.636-2.779-2.073.742-.056-.043a5.318 5.318 0 00-1.145-.646l-.074-.029L9.636 1zM7.407 2.22h1.184l.233 1.302c.056.317.28.58.588.69.456.164.869.397 1.229.693l.087.064a.933.933 0 00.821.091l1.259-.453.591 1.004-1.033.849a.89.89 0 00-.315.844c.044.254.066.48.066.696 0 .216-.022.443-.066.695l-.012.106a.891.891 0 00.328.739l1.032.847-.591 1.004-1.262-.452a.932.932 0 00-.906.157 4.124 4.124 0 01-1.228.692l-.099.042a.902.902 0 00-.489.648l-.233 1.302H7.407l-.23-1.302a.906.906 0 00-.589-.69 4.123 4.123 0 01-1.229-.693l-.087-.063a.934.934 0 00-.82-.092l-1.261.451-.592-1.004 1.035-.847a.89.89 0 00.315-.844A3.944 3.944 0 013.883 8c0-.216.021-.442.066-.695l.012-.106a.894.894 0 00-.328-.739l-1.034-.849.592-1.004 1.263.454a.931.931 0 00.905-.156c.36-.296.773-.529 1.229-.692l.099-.043a.906.906 0 00.49-.648l.23-1.302zM5.499 8a2.505 2.505 0 002.5 2.5c1.379 0 2.5-1.122 2.5-2.5A2.503 2.503 0 008 5.5 2.504 2.504 0 005.5 8zm1.05 0c0-.799.652-1.45 1.45-1.45.8 0 1.45.651 1.45 1.45 0 .8-.65 1.45-1.45 1.45-.798 0-1.45-.65-1.45-1.45z",
    clipRule: "evenodd"
  }));
}

function SubtractIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 7.3v1.4H1V7.3z",
    clipRule: "evenodd"
  }));
}

function TimelineIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 4",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.727 0v1.75h-1.909V0H9.545v1.75H7.636V0H6.364v1.75h-1.91V0H3.183v1.75h-1.91V0H0v2.45l.006.095c.042.342.309.605.63.605h12.728l.086-.006c.31-.046.55-.339.55-.694V0h-1.273z",
    clipRule: "evenodd"
  }));
}

function UnviewIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.78.999l1.013 1.014-2.439 2.438c.584.321 1.144.72 1.68 1.185a11.716 11.716 0 011.665 1.784l.077.104.116.168a.65.65 0 010 .718c-.046.069-.11.16-.193.271l-.09.117-.213.268c-.393.477-.848.953-1.362 1.399C11.538 11.762 9.849 12.55 8 12.55c-1.305 0-2.53-.393-3.664-1.08l-2.322 2.321L1 12.778l2.155-2.153A11.716 11.716 0 011.301 8.68l-.077-.104-.116-.167a.65.65 0 010-.718c.091-.14.258-.368.496-.657.393-.477.848-.953 1.362-1.399C4.462 4.34 6.151 3.551 8 3.551c.666 0 1.311.102 1.934.293L12.779 1zm-1.71 4.838l.016.052c.08.28.122.577.122.883A3.215 3.215 0 018 9.993a3.183 3.183 0 01-1.7-.488l-.986.987c.857.47 1.756.73 2.686.73 1.468 0 2.86-.65 4.13-1.75.362-.314.693-.648.99-.985l.215-.253.147-.184-.147-.183a10.385 10.385 0 00-1.206-1.238 8.765 8.765 0 00-1.058-.792zm-6.141 0c-.361.228-.714.493-1.058.792a10.33 10.33 0 00-.99.985l-.216.253-.148.183.148.184c.348.422.752.845 1.206 1.238l.236.199 1.18-1.18a3.232 3.232 0 01-.358-2.654zm4.793.247L7.288 8.519c.22.094.46.146.712.146 1.014 0 1.847-.842 1.847-1.893a1.93 1.93 0 00-.125-.688zM8 4.878c-1.014 0-1.847.843-1.847 1.894 0 .254.048.496.137.717L8.74 5.037A1.802 1.802 0 008 4.878z",
    clipRule: "evenodd"
  }));
}

function UserIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1a4.107 4.107 0 012.616 7.274 6.42 6.42 0 014.38 5.873l.004.217V15h-1.273v-.636c0-2.778-2.199-5.042-4.951-5.145l-.197-.004H7.42a5.149 5.149 0 00-5.145 4.951l-.003.198V15H1v-.636a6.424 6.424 0 014.384-6.092A4.107 4.107 0 018 1zm0 1.273a2.834 2.834 0 100 5.669 2.834 2.834 0 000-5.67z",
    clipRule: "evenodd"
  }));
}

function UsersIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.508 6.985A3.56 3.56 0 019.52 8.37c1.912.79 3.275 2.627 3.355 4.79l.004.204v.636h-1.273v-.636c0-2.218-1.766-4.03-3.987-4.132l-.198-.005h-.964c-2.246 0-4.077 1.75-4.18 3.942l-.004.195v.636H1v-.636c0-2.393 1.566-4.42 3.736-5.135a3.553 3.553 0 014.435-5.514 2.492 2.492 0 013.669 3.364 3.82 3.82 0 012.155 3.262l.005.19v.637h-1.273V9.53c0-1.356-1.038-2.46-2.345-2.54l-.152-.005h-.722zm.409-3.812c-.342 0-.65.14-.872.366a3.53 3.53 0 01.713 2.134l-.002-.071a1.22 1.22 0 10.161-2.429zm-3.712.22a2.28 2.28 0 110 4.56 2.28 2.28 0 010-4.56z",
    clipRule: "evenodd"
  }));
}

function OutlinedValidationCheckIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M8 1a7 7 0 100 14A7 7 0 008 1zm0 13c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z"
  }), /*#__PURE__*/createElement("path", {
    d: "M6.82 9.386L4.917 7.43 4 8.375l2.36 2.43.081.07c.254.188.61.164.838-.07L12 5.944 11.082 5 6.819 9.386z"
  })));
}

function OutlinedValidationErrorIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M8 1C4.15 1 1 4.15 1 8s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7zm0 13c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z"
  }), /*#__PURE__*/createElement("path", {
    d: "M10.05 4.96L8 7.01 5.95 4.96l-.99.99L7.01 8l-2.05 2.05.99.99L8 8.989l2.05 2.051.99-.99L8.989 8l2.051-2.05z"
  })));
}

function OutlinedValidationExclamationIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/createElement("path", {
    d: "M8 1C4.15 1 1 4.15 1 8s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7zm0 13c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z"
  }), /*#__PURE__*/createElement("path", {
    d: "M7.3 4h1.4v5.1H7.3z"
  }), /*#__PURE__*/createElement("circle", {
    cx: 8.005,
    cy: 11.375,
    r: 0.875
  })));
}

function OutlinedValidationInfoIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/createElement("path", {
    d: "M8 1C4.15 1 1 4.15 1 8s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7zm0 13c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z"
  }), /*#__PURE__*/createElement("circle", {
    cx: 8.005,
    cy: 4.875,
    r: 0.875
  }), /*#__PURE__*/createElement("path", {
    d: "M8.7 7.5l-.006-.095A.7.7 0 008 6.8H6.3v1.4h1v2.418h-1v1.4h3.4v-1.4H8.699L8.7 7.5z"
  })));
}

function ValidationCheckIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 14",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 0a7 7 0 100 14A7 7 0 007 0zm-.721 9.804a.636.636 0 01-.838.07l-.08-.07L3 7.374l.918-.944L5.82 8.386 10.082 4l.918.945-4.721 4.86z",
    clipRule: "evenodd"
  }));
}

function ValidationErrorIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.475 10.343l-1.132 1.131L8 9.13l-2.343 2.345-1.132-1.131 2.343-2.344-2.343-2.343 1.132-1.131L8 6.868l2.343-2.343 1.132 1.131L9.13 8z",
    clipRule: "evenodd"
  }));
}

function ValidationExclamationIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("circle", {
    cx: 8,
    cy: 8,
    r: 4.4,
    fill: "transparent"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm-.7 3h1.4v5.1H7.3V4zm.7 8.2c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9c0 .6-.4.9-.9.9z",
    clipRule: "evenodd"
  }));
}

function ValidationInfoIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1C4.15 1 1 4.15 1 8s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7zm.005 3a.875.875 0 110 1.75.875.875 0 010-1.75zM9.7 12.018H6.3v-1.4h1V8.199l-1 .001V6.8H8a.7.7 0 01.694.605L8.7 7.5l-.001 3.118H9.7v1.4z",
    clipRule: "evenodd"
  }));
}

function ValueIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 13",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.278.187l.008.007a.595.595 0 01.047.058l.008.011 2.557 3.732a.591.591 0 01.045.077l.008.018a.55.55 0 01.049.233v.014a.576.576 0 01-.004.05L14 4.324a.579.579 0 01-.126.36L7.481 12.77a.614.614 0 01-.012.015l-.01.013a.595.595 0 01-.068.064l-.011.01a.606.606 0 01-.017.012l-.016.011-.01.006a.601.601 0 01-.12.061l-.031.01-.007.003-.013.004a.622.622 0 01-.073.015l-.012.002-.02.002A.631.631 0 017 13h-.016l-.022-.001a.632.632 0 01-.073-.009l-.022-.004a.623.623 0 01-.033-.008l-.013-.004a.637.637 0 01-.082-.031l.082.03a.621.621 0 01-.097-.037l-.012-.007-.023-.012a.6.6 0 01-.034-.021l-.014-.01-.009-.007-.022-.017a.605.605 0 01-.091-.093l.06.066a.599.599 0 01-.045-.046v-.002l-.015-.018L.126 4.683A.59.59 0 010 4.323v-.025l.006-.06L0 4.322a.578.578 0 01.102-.328l-.042.071a.585.585 0 01.026-.046l.016-.025L2.659.263a.587.587 0 01.055-.069l.012-.012A.555.555 0 012.878.07.594.594 0 013.164 0l-.099.008A.638.638 0 013.146 0H10.836a.622.622 0 01.238.048L11.028.03a.62.62 0 01.245.15l.005.007zM8.733 4.913H5.265l1.734 5.486 1.734-5.486zM5.43 9.455L3.994 4.913H1.839L5.43 9.455zm6.729-4.542h-2.154L8.57 9.453l3.589-4.54zm.098-1.181l-1.239-1.809-.619 1.809h1.858zM2.98 1.922l-1.239 1.81H3.6l-.62-1.81zm4.019-.266L5.577 3.732h2.844L6.999 1.656zm-1.134-.475H4.006l.62 1.808 1.239-1.808zm4.128 0H8.134l1.239 1.808.62-1.808z",
    clipRule: "evenodd"
  }));
}

function ViewIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 3.5c1.85 0 3.538.788 5.034 2.086a11.716 11.716 0 011.742 1.887l.116.168a.65.65 0 010 .718c-.061.092-.155.225-.282.388l-.214.268c-.393.477-.848.953-1.362 1.4C11.538 11.711 9.849 12.5 8 12.5s-3.538-.788-5.034-2.086a11.716 11.716 0 01-1.742-1.887l-.116-.168a.65.65 0 010-.718c.091-.139.258-.367.496-.656.393-.477.848-.953 1.362-1.4C4.462 4.289 6.151 3.5 8 3.5zm3.07 2.286l.016.053c.08.28.122.577.122.882 0 1.774-1.43 3.222-3.208 3.222S4.792 8.495 4.792 6.72c0-.324.048-.638.137-.934-.361.227-.714.493-1.058.791-.454.393-.858.816-1.206 1.238L2.517 8l.148.184c.348.422.752.845 1.206 1.238 1.268 1.1 2.66 1.75 4.129 1.75s2.86-.65 4.13-1.75c.453-.393.857-.816 1.205-1.238L13.482 8l-.147-.184a10.385 10.385 0 00-1.206-1.238 8.765 8.765 0 00-1.058-.792zM8 4.828c1.014 0 1.847.842 1.847 1.893S9.014 8.615 8 8.615 6.153 7.772 6.153 6.72 6.986 4.828 8 4.828z",
    clipRule: "evenodd"
  }));
}

function WarningIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 17.231 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "#181c56",
    d: "M8.615 1.5a.947.947 0 00-.842.496L1.728 13.121c-.338.624.124 1.379.844 1.379H14.66c.72 0 1.18-.755.842-1.379L9.457 1.996a.946.946 0 00-.842-.496zm-.699 4h1.398v4.1H7.916V5.5zm.705 5.5a.875.875 0 110 1.75.875.875 0 010-1.75z"
  }));
}

function CloudIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M9.248 20.247c-4.25 0-7.86-3.315-8.219-7.55C.67 8.46 3.671 4.582 7.863 3.868c3.952-.674 7.84 1.66 9.161 5.382h.477c3.032 0 5.499 2.466 5.499 5.499s-2.467 5.498-5.499 5.498H9.248zM9.232 5.585c-.351 0-.705.03-1.061.09-3.26.555-5.595 3.571-5.315 6.867.28 3.294 3.087 5.873 6.392 5.873h8.253a3.67 3.67 0 003.666-3.666 3.67 3.67 0 00-3.666-3.666h-1.154a.917.917 0 01-.888-.688c-.736-2.853-3.358-4.81-6.227-4.81z"
  }));
}

function CloudLightningIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M18.413 17.405a.917.917 0 01-.182-1.814 3.653 3.653 0 002.917-3.96 3.652 3.652 0 00-3.645-3.296h-1.16a.915.915 0 01-.887-.687 6.413 6.413 0 10-9.315 7.215.916.916 0 01-.888 1.603 8.244 8.244 0 013.994-15.46 8.244 8.244 0 017.773 5.497h.484a5.479 5.479 0 015.468 4.944 5.481 5.481 0 01-4.376 5.94.995.995 0 01-.183.018z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M11.083 22.994a.915.915 0 01-.761-1.425l2.716-4.072H9.252a.917.917 0 01-.763-1.425l3.666-5.496a.916.916 0 111.525 1.016l-2.716 4.072h3.785a.916.916 0 01.763 1.425l-3.666 5.497a.915.915 0 01-.763.408z"
  }));
}

function CloudRainIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M8.343 21.166a.916.916 0 01-.917-.917v-1.833a.916.916 0 111.833 0v1.833c0 .507-.41.917-.916.917z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M8.343 15.666a.916.916 0 01-.917-.916v-1.833a.917.917 0 011.833 0v1.833c0 .507-.41.916-.916.916z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M15.674 21.166a.916.916 0 01-.916-.917v-1.833a.916.916 0 111.833 0v1.833c0 .507-.41.917-.917.917z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M15.674 15.666a.916.916 0 01-.916-.916v-1.833a.916.916 0 111.833 0v1.833c0 .507-.41.916-.917.916z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12.009 22.999a.916.916 0 01-.917-.917V20.25a.916.916 0 111.833 0v1.833c0 .507-.41.917-.916.917z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12.009 17.5a.916.916 0 01-.917-.917V14.75a.916.916 0 111.833 0v1.833c0 .507-.41.917-.916.917z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M19.342 17.115a.917.917 0 01-.368-1.756 3.684 3.684 0 002.117-4.108 3.682 3.682 0 00-3.584-2.917h-1.154a.916.916 0 01-.887-.687 6.395 6.395 0 00-5.852-4.802A6.392 6.392 0 003.261 6.96a6.394 6.394 0 001.987 7.304.916.916 0 11-1.144 1.432 8.22 8.22 0 01-2.555-9.39 8.213 8.213 0 018.168-5.29A8.22 8.22 0 0117.031 6.5h.477a5.522 5.522 0 015.377 4.375 5.524 5.524 0 01-3.176 6.162.907.907 0 01-.367.077z"
  }));
}

function CloudSnowIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M19.342 18.031a.917.917 0 01-.368-1.756 3.684 3.684 0 002.117-4.108 3.682 3.682 0 00-3.584-2.916h-1.154a.916.916 0 01-.887-.688 6.395 6.395 0 00-5.852-4.801 6.395 6.395 0 00-6.353 4.114 6.394 6.394 0 001.987 7.303.916.916 0 11-1.144 1.433 8.22 8.22 0 01-2.555-9.39 8.215 8.215 0 018.168-5.29 8.22 8.22 0 017.314 5.486h.477a5.522 5.522 0 015.377 4.375 5.524 5.524 0 01-3.176 6.161.907.907 0 01-.367.077z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M8.352 16.583a.92.92 0 01-.921-.917c0-.506.405-.916.912-.916h.009a.916.916 0 110 1.833z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M8.352 20.25c-.507 0-.921-.41-.921-.917s.405-.917.912-.917h.009a.916.916 0 110 1.833z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12.018 18.416a.92.92 0 01-.92-.917c0-.506.405-.916.91-.916h.01a.916.916 0 110 1.833z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12.018 22.082a.92.92 0 01-.92-.916c0-.507.405-.917.91-.917h.01a.916.916 0 110 1.833z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M15.684 16.583a.92.92 0 01-.92-.917c0-.506.405-.916.911-.916h.01a.916.916 0 110 1.833z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M15.684 20.25c-.506 0-.92-.41-.92-.917s.405-.917.911-.917h.01a.916.916 0 110 1.833z"
  }));
}

function SunIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12 17.5c-3.033 0-5.5-2.467-5.5-5.5S8.967 6.5 12 6.5s5.5 2.467 5.5 5.5-2.467 5.5-5.5 5.5zm0-9.167A3.67 3.67 0 008.333 12 3.67 3.67 0 0012 15.667 3.67 3.67 0 0015.667 12 3.67 3.67 0 0012 8.333z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12 4.667a.917.917 0 01-.917-.917V1.917a.917.917 0 011.834 0V3.75c0 .506-.41.917-.917.917z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12 23a.916.916 0 01-.917-.917V20.25a.916.916 0 111.834 0v1.833c0 .507-.41.917-.917.917z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M6.17 7.087a.914.914 0 01-.648-.269L4.22 5.516A.916.916 0 115.516 4.22l1.302 1.302a.916.916 0 01-.648 1.565z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M19.132 20.049a.914.914 0 01-.648-.269l-1.302-1.302a.916.916 0 111.296-1.296l1.302 1.302a.916.916 0 01-.648 1.565z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M3.75 12.917H1.917a.917.917 0 010-1.834H3.75a.917.917 0 010 1.834z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M22.083 12.917H20.25a.916.916 0 110-1.834h1.833a.916.916 0 110 1.834z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M4.868 20.049a.916.916 0 01-.648-1.565l1.302-1.302a.916.916 0 111.296 1.296L5.516 19.78a.914.914 0 01-.648.269z"
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M17.83 7.087a.916.916 0 01-.648-1.565l1.302-1.302a.916.916 0 111.296 1.296l-1.302 1.302a.914.914 0 01-.648.269z"
  }));
}

function SunCloudIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/createElement("path", {
    d: "M8.765 5.53c.357 0 .647-.29.647-.648V3.588a.647.647 0 00-1.294 0v1.294c0 .358.29.647.647.647z"
  }), /*#__PURE__*/createElement("path", {
    d: "M4.192 7.048a.645.645 0 00.915 0 .647.647 0 000-.915l-.92-.919a.647.647 0 10-.914.915l.919.92z"
  }), /*#__PURE__*/createElement("path", {
    d: "M3.588 10.706a.647.647 0 00-.647-.647H1.647a.647.647 0 000 1.294h1.294c.358 0 .647-.29.647-.647z"
  }), /*#__PURE__*/createElement("path", {
    d: "M4.192 14.364l-.92.919a.647.647 0 10.916.915l.919-.92a.647.647 0 10-.915-.914z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.88 7.238a.645.645 0 00.458-.19l.918-.919a.647.647 0 10-.914-.915l-.92.92a.647.647 0 00.458 1.104z"
  }), /*#__PURE__*/createElement("path", {
    d: "M19.118 13.294h-.337c-.883-2.488-3.392-4.094-6.024-3.855a4.079 4.079 0 00-7.586 1.425 4.107 4.107 0 002.237 4.3c.02.009.04.013.06.02-.002.18.004.362.02.544.253 2.99 2.802 5.33 5.802 5.33H19.118c2.14 0 3.882-1.74 3.882-3.882s-1.741-3.882-3.882-3.882zM6.45 11.056a2.787 2.787 0 014.953-1.323 5.88 5.88 0 00-3.748 4.074 2.814 2.814 0 01-1.205-2.75zm12.667 8.709h-5.825-.003c-2.333 0-4.316-1.82-4.513-4.147-.197-2.326 1.45-4.456 3.753-4.848.25-.042.5-.063.749-.063 2.025 0 3.877 1.381 4.397 3.396a.646.646 0 00.627.485h.815a2.59 2.59 0 012.588 2.588 2.59 2.59 0 01-2.588 2.589z"
  })));
}

function SunCloudRainIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/createElement("path", {
    d: "M8.767 3.588c.357 0 .647-.29.647-.647V1.647a.647.647 0 00-1.294 0v1.294c0 .358.29.647.647.647z"
  }), /*#__PURE__*/createElement("path", {
    d: "M4.194 5.107a.645.645 0 00.915 0 .647.647 0 000-.915l-.919-.92a.647.647 0 10-.915.916l.92.919z"
  }), /*#__PURE__*/createElement("path", {
    d: "M3.59 8.765a.647.647 0 00-.646-.647H1.649a.647.647 0 000 1.294h1.295c.357 0 .647-.29.647-.647z"
  }), /*#__PURE__*/createElement("path", {
    d: "M4.194 12.423l-.919.919a.647.647 0 10.915.914l.92-.918a.647.647 0 10-.916-.915z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.883 5.297a.645.645 0 00.457-.19l.919-.92a.647.647 0 10-.915-.914l-.919.919a.647.647 0 00.458 1.105z"
  }), /*#__PURE__*/createElement("path", {
    d: "M22.916 14.442a3.9 3.9 0 00-3.796-3.09h-.336a5.803 5.803 0 00-6.025-3.855 4.079 4.079 0 00-7.586 1.426 4.107 4.107 0 002.237 4.3c.02.009.04.013.06.02a5.799 5.799 0 002.187 4.6.648.648 0 00.808-1.01 4.514 4.514 0 01-1.403-5.157 4.504 4.504 0 014.486-2.904 4.515 4.515 0 014.13 3.39.646.646 0 00.627.485h.814a2.6 2.6 0 012.531 2.06 2.6 2.6 0 01-1.496 2.9.647.647 0 00.52 1.185 3.9 3.9 0 002.242-4.35zM7.853 11.214c-.081.214-.145.43-.201.648a2.814 2.814 0 01-1.199-2.747A2.79 2.79 0 018.776 6.76a2.786 2.786 0 012.625 1.026 5.81 5.81 0 00-3.548 3.428z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.65 19.118a.647.647 0 00-.648.647v1.294a.647.647 0 101.294 0v-1.294a.647.647 0 00-.647-.647z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.65 15.235a.647.647 0 00-.648.647v1.294a.647.647 0 101.294 0v-1.294a.647.647 0 00-.647-.647z"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.826 19.118a.647.647 0 00-.647.647v1.294a.647.647 0 101.294 0v-1.294a.647.647 0 00-.647-.647z"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.826 15.235a.647.647 0 00-.647.647v1.294a.647.647 0 101.294 0v-1.294a.647.647 0 00-.647-.647z"
  }), /*#__PURE__*/createElement("path", {
    d: "M15.238 20.412a.647.647 0 00-.647.647v1.294a.647.647 0 101.294 0v-1.294a.647.647 0 00-.647-.647z"
  }), /*#__PURE__*/createElement("path", {
    d: "M15.238 16.53a.647.647 0 00-.647.646v1.295a.647.647 0 101.294 0v-1.295a.647.647 0 00-.647-.647z"
  })));
}

function ThermometerIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12 22.91a4.971 4.971 0 01-4.785-3.55 4.968 4.968 0 011.603-5.308v-9.78A3.185 3.185 0 0112 1.091a3.186 3.186 0 013.182 3.181v9.78a4.968 4.968 0 011.602 5.308A4.97 4.97 0 0112 22.91zm0-20c-.752 0-1.363.61-1.363 1.362v10.236a.91.91 0 01-.405.756 3.164 3.164 0 00-1.276 3.569A3.163 3.163 0 0012 21.091a3.161 3.161 0 003.044-2.258 3.163 3.163 0 00-1.276-3.57.908.908 0 01-.405-.755V4.272c0-.751-.611-1.363-1.363-1.363z"
  }), /*#__PURE__*/createElement("circle", {
    cx: 11.953,
    cy: 17.908,
    r: 2.145,
    fill: "currentColor"
  }));
}

function UmbrellaIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    d: "M12 1.917a11.046 11.046 0 00-10.996 9.996.917.917 0 00.913 1.004h9.166v5.5a3.667 3.667 0 007.334 0 .917.917 0 10-1.834 0 1.833 1.833 0 11-3.666 0v-5.5h9.166a.917.917 0 00.913-1.004A11.046 11.046 0 0012 1.917zm0 1.833a9.21 9.21 0 019.014 7.333H2.986A9.21 9.21 0 0112 3.75z"
  }));
}

function WindIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/createElement("path", {
    d: "M2 9h9.002a3 3 0 10-2.12-5.117 1 1 0 001.419 1.41A1 1 0 1111.006 7l-.004 1 .004-1H2a1 1 0 000 2z"
  }), /*#__PURE__*/createElement("path", {
    d: "M14.002 15H2a1 1 0 000 2H14.007a1 1 0 11-.705 1.706 1 1 0 00-1.42 1.41 3 3 0 102.12-5.115z"
  }), /*#__PURE__*/createElement("path", {
    d: "M21.25 6.468a3.5 3.5 0 00-4.223.553 1 1 0 001.413 1.416A1.5 1.5 0 1119.502 11H2a1 1 0 000 2h17.505l-.002-1v-.017L19.505 13a3.5 3.5 0 001.745-6.532z"
  })));
}

function ZoomInIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.795 1a5.795 5.795 0 014.549 9.387L15 14.044l-.956.956-3.656-3.657A5.795 5.795 0 116.796 1zm0 1.352a4.443 4.443 0 100 8.885 4.443 4.443 0 000-8.885zM7.25 4.42l-.001 1.907 1.908.001v.92H7.248v1.908h-.92l-.001-1.908H4.42v-.92l1.907-.001.001-1.907h.92z",
    clipRule: "evenodd"
  }));
}

function ZoomOutIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    width: props.width || props.size || '1em',
    height: props.height || props.size || '1em',
    className: 'eds-icon ' + (props.className || '') + (props.inline ? ' eds-icon--inline' : ''),
    inline: undefined,
    color: props.color || 'currentColor'
  }), /*#__PURE__*/createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.795 1a5.795 5.795 0 014.549 9.387L15 14.044l-.956.956-3.657-3.656A5.795 5.795 0 116.796 1zm0 1.352a4.443 4.443 0 100 8.885 4.443 4.443 0 000-8.885zm2.361 3.976v.92H4.42v-.92h4.736z",
    clipRule: "evenodd"
  }));
}

export { AccessibilityIcon, AddCardIcon, AddIcon, AdditionalIcon, AdditionalZonesTicketIcon, AdjustmentsIcon, AdminIcon, AgreesIcon, AlignCenterIcon, AlignLeftIcon, AlignRightIcon, AnimalFreeIcon, AnimalIcon, AttachmentIcon, BabyIcon, BackArrowIcon, BanknoteIcon, BanknoteMultiIcon, BatteryIcon, BellIcon, BergenBysykkelIcon, BicycleHotelIcon, BicycleIcon, BicycleParkingIcon, BoldIcon, BoltIcon, BookmarkIcon, BrakarIcon, BrakarNoTextIcon, BrightnessIcon, BugIcon, BulletListIcon, BusIcon, BusShelterIcon, CabinIcon, CablewayIcon, CalculatorIcon, CalendarIcon, CameraIcon, CarIcon, CardIcon, CarferryIcon, ChannelsIcon, ChatIcon, CheckIcon, CityBikeIcon, CityIcon, ClockIcon, CloseIcon, CloseSmallIcon, ClosedLockIcon, CloudDownloadIcon, CloudIcon, CloudLightningIcon, CloudRainIcon, CloudSnowIcon, CoffeeIcon, CollapsedIcon, ColorPickerIcon, CommentIcon, ConductorIcon, ConfigurationIcon, ContactsIcon, CopyIcon, CorrespondenceIcon, CouchetteIcon, CutleryIcon, DatabaseIcon, DateIcon, DeleteIcon, DenmarkIcon, DepositionIcon, DesktopIcon, DestinationIcon, DiffIcon, DownArrowIcon, DownloadIcon, DownwardIcon, DraggableIcon, EditIcon, EmailIcon, EnvironmentIcon, EuroIcon, ExpandIcon, ExtendIcon, ExternalIcon, FacebookIcon, FarteIcon, FerryIcon, FileIcon, FillIcon, ForwardIcon, FullIcon, FunicularIcon, GOAIcon, GithubIcon, GoalIcon, GoogleIcon, GridViewIcon, GymIcon, HandToolIcon, HeartIcon, HelicopterIcon, HomeIcon, HorizontalDotsIcon, ImageIcon, InnlandstrafikkIcon, InstagramIcon, InternationalIcon, InterrailIcon, InvalidTicketIcon, ItalicIcon, KolumbusBysykkelIcon, KolumbusIcon, LaptopIcon, LeftArrowIcon, LikeIcon, LimeIcon, LinkIcon, LinkedinIcon, ListViewIcon, LoadingIcon, LockerIcon, LogOutIcon, LogoNegativeIcon, LogoPositiveIcon, LuggageIcon, ManySeatsAvailableIcon, MapIcon, MapPinIcon, MastercardIcon, MenuIcon, MergeProfilesIcon, MinimizeIcon, MobileIcon, MoneyIcon, MountainIcon, MoveAboutIcon, NewIcon, NightIcon, NorwayIcon, NumberListIcon, OpenedLockIcon, OrganizationIcon, OsloBysykkelIcon, OstfoldIcon, OutlinedValidationCheckIcon, OutlinedValidationErrorIcon, OutlinedValidationExclamationIcon, OutlinedValidationInfoIcon, PackageIcon, ParkAndRideIcon, ParkIcon, ParkingGarageIcon, PhoneIcon, PlaneIcon, PlayIcon, PlaygroundIcon, PlayroomIcon, PositionIcon, PowerIcon, PremiumSeatIcon, PriceFromIcon, PricelistIcon, PrinterIcon, PrioritySeatPregnantIcon, PrioritySeatSeniorsIcon, PrivacyIcon, PurposeIcon, QRIcon, QuestionIcon, QuietIcon, QuitIcon, RSSIcon, RedoIcon, ReferenceIcon, RefreshIcon, ReportsIcon, ResetIcon, RightArrowIcon, RowHeightDefaultIcon, RowHeightMiddleIcon, RowHeightSmallIcon, RulesIcon, RunningIcon, RuterIcon, SJIcon, SamiIcon, SaveIcon, ScooterIcon, ScopeIcon, SearchIcon, SeatIcon, SeatsAvailableIcon, SelectIcon, SendIcon, SettingsIcon, ShareIcon, ShoppingCartIcon, SkiIcon, SkypeIcon, SkyssIcon, SleepIcon, SourceCodeIcon, StandardIcon, StandingAvailableIcon, StandingIcon, StarredIcon, StatsIcon, StrollerIcon, StrollingIcon, SubtractIcon, SubwayIcon, SuitcaseIcon, SunCloudIcon, SunCloudRainIcon, SunIcon, SwedenIcon, SwitchIcon, TVMIcon, TaxiIcon, TextColorIcon, ThermometerIcon, TierIcon, TimelineIcon, ToFromIcon, ToiletIcon, TrackIcon, TrainCarIcon, TrainIcon, TramIcon, TransferIcon, TrondheimBysykkelIcon, TurnableIcon, TwitterIcon, UKIcon, UmbrellaIcon, UnderlineIcon, UndoIcon, UniversityIcon, UnlinkIcon, UnsortedIcon, UnstarredIcon, UnviewIcon, UpArrowIcon, UploadIcon, UpwardIcon, UserIcon, UsersIcon, VKTIcon, ValidTicketIcon, ValidationCheckIcon, ValidationErrorIcon, ValidationExclamationIcon, ValidationInfoIcon, ValueIcon, VendingMachineIcon, VerticalDotsIcon, VerticalSwitchIcon, ViewIcon, VimeoIcon, VippsIcon, VippsLogoIcon, VisaIcon, VoiIcon, VyIcon, WaitingRoomIcon, WalkingIcon, WarningIcon, WaterTapIcon, WheelchairIcon, WifiIcon, WindIcon, YoutubeIcon, ZoneIcon, ZoomInIcon, ZoomOutIcon, ZvippIcon };
